var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
import { Box, Heading as Heading$1, Flex, Grid, Button as Button$1, useThemeUI, Spinner, Card as Card$1, createElement } from "theme-ui";
import Downshift, { useMultipleSelection, useSelect, useCombobox } from "downshift";
import React, { forwardRef, memo, useState, useLayoutEffect, useEffect, useMemo, useRef, useCallback } from "react";
import debounce$1 from "lodash.debounce";
import { v4 } from "uuid";
import { Formik, Form as Form$1, useFormikContext, useField } from "formik";
import { jsx, jsxs, Fragment } from "theme-ui/jsx-runtime";
import { Manager, Reference, Popper } from "react-popper";
import { matchSorter } from "match-sorter";
import { format, isMatch } from "date-fns";
import ReactDatePicker from "react-datepicker";
import { css, Global, keyframes } from "@emotion/react";
import { range } from "lodash";
import isequal from "lodash.isequal";
import debounce from "lodash/debounce";
import noop from "lodash/noop";
import isEmpty from "lodash/isEmpty";
import classNames from "classnames";
import { motion, AnimatePresence } from "framer-motion";
import SignaturePad from "signature_pad";
import Lottie from "react-lottie";
import { Menu as Menu$3, MenuButton, MenuList, MenuLink, MenuItem as MenuItem$1 } from "@reach/menu-button";
import Modal$1 from "react-modal";
import FocusLock from "react-focus-lock";
import { Tabs as Tabs$1, TabList, Tab, TabPanels, TabPanel } from "@reach/tabs";
import Dropzone from "react-dropzone";
import { DateTime } from "luxon";
const hiddenVisually = {
  border: 0,
  clip: "rect(0 0 0 0)",
  height: "1px",
  margin: "-1px",
  overflow: "hidden",
  padding: 0,
  position: "absolute",
  width: "1px",
  whiteSpace: "nowrap",
  wordWrap: "normal"
};
const VisuallyHidden = (_a) => {
  var _b = _a, {
    children
  } = _b, rest = __objRest(_b, [
    "children"
  ]);
  return jsx(Box, __spreadProps(__spreadValues({}, rest), {
    as: "span",
    "data-component": "VisuallyHidden",
    sx: hiddenVisually,
    children
  }));
};
const Heading = React.forwardRef((_c, ref) => {
  var _d = _c, {
    variant = "h1",
    as
  } = _d, props = __objRest(_d, [
    "variant",
    "as"
  ]);
  return jsx(Heading$1, __spreadValues({
    as: as || variant,
    "data-component": "Heading",
    variant,
    ref
  }, props));
});
const INTERNAL_ONLY_FORM_INFO = React.createContext({
  prefix: ""
});
const {
  Provider
} = INTERNAL_ONLY_FORM_INFO;
const ErrorSummary = ({
  globalErrors = {}
}) => {
  const [lastHandled, setLastHandled] = React.useState(0);
  const errorContainer = React.useRef(null);
  const {
    prefix
  } = React.useContext(INTERNAL_ONLY_FORM_INFO);
  const {
    errors,
    submitCount,
    isValid
  } = useFormikContext();
  React.useEffect(() => {
    var _a;
    if (submitCount > lastHandled && !isValid) {
      setLastHandled(submitCount);
      (_a = errorContainer.current) == null ? void 0 : _a.focus();
    }
  }, [submitCount, lastHandled, isValid, errorContainer]);
  const summaryErrors = Object.assign({}, errors, globalErrors);
  const flattenObject = (obj, prefixObject = "") => Object.keys(obj).reduce((acc, k) => {
    if (obj[k] == null)
      return acc;
    const pre = prefixObject.length ? `${prefixObject}.` : "";
    if (typeof obj[k] === "object")
      Object.assign(acc, flattenObject(obj[k], pre + k));
    else
      acc[pre + k] = obj[k];
    return acc;
  }, {});
  const errorListing = Object.entries(flattenObject(summaryErrors));
  const titleId = `${prefix}-error-summary-title`;
  if (!errorListing.length)
    return null;
  const styles2 = {
    border: "1px solid",
    borderRadius: "rounded",
    mb: 3,
    maxWidth: 416,
    borderColor: "danger.base",
    ":focus": {
      borderColor: "danger.d1"
    }
  };
  const [key] = errorListing[0];
  const message = {
    single: `There is 1 error that needs to be corrected before proceeding.`,
    multiple: `There are ${errorListing.length} errors that need to be corrected before proceeding.`
  };
  return jsxs(Box, {
    p: 3,
    tabIndex: -1,
    role: "alert",
    "aria-labelledby": titleId,
    sx: styles2,
    ref: errorContainer,
    children: [jsx(Heading, {
      id: titleId,
      variant: "h4",
      sx: {
        mb: 1
      },
      as: "h2",
      children: "Error Summary"
    }), errorListing.length > 1 ? message.multiple : message.single, "\xA0", jsx("a", {
      sx: {
        color: "primary.base",
        ":hover": {
          color: "primary.d1"
        }
      },
      href: `#${prefix}-${key}`,
      onClick: (e) => {
        e.preventDefault();
        const inputElement = document.getElementById(`${prefix}-${key}`);
        if (!inputElement) {
          console.warn(`${inputElement} is missing from the dom`);
          return;
        }
        inputElement.focus();
      },
      children: "Fix now."
    })]
  });
};
const Form = React.forwardRef((_e, ref) => {
  var _f = _e, {
    children,
    showSummary = true,
    formProps = {},
    validateOnBlur = false,
    validateOnMount = false,
    validateOnChange = false,
    onSubmit = () => {
    },
    validationSchema
  } = _f, rest = __objRest(_f, [
    "children",
    "showSummary",
    "formProps",
    "validateOnBlur",
    "validateOnMount",
    "validateOnChange",
    "onSubmit",
    "validationSchema"
  ]);
  const prefix = React.useMemo(() => v4(), []);
  const handleSubmit = (values, helpers) => {
    let newValues = values;
    const schema = validationSchema;
    if (schema) {
      newValues = schema.validateSync(values);
    }
    onSubmit(newValues, helpers);
  };
  return jsx(Provider, {
    value: {
      prefix
    },
    children: jsx(Formik, __spreadProps(__spreadValues({}, rest), {
      onSubmit: handleSubmit,
      innerRef: ref,
      validateOnBlur,
      validateOnChange,
      validateOnMount,
      validationSchema,
      children: jsxs(Form$1, __spreadProps(__spreadValues({
        noValidate: true
      }, formProps), {
        children: [showSummary ? jsx(ErrorSummary, {}) : jsx(VisuallyHidden, {
          children: jsx(ErrorSummary, {})
        }), children]
      }))
    }))
  });
});
const iconMapping = (type) => {
  switch (type) {
    case "warning":
      return "warning";
    case "danger":
      return "danger";
    case "success":
      return "check-circle";
    case "circle":
      return "circle";
    case "check":
      return "check";
    case "check-circle":
      return "check-circle";
    case "upload":
      return "upload";
    case "copy":
      return "copy";
    case "calendar":
      return "calendar";
    case "setting":
      return "setting";
    case "download":
      return "download";
    case "edit":
      return "edit";
    case "eye-open":
      return "eye";
    case "eye-closed":
      return "eye-slash";
    case "file":
      return "file";
    case "file-error":
      return "file-error";
    case "filter":
      return "filter";
    case "envelope":
      return "envelope";
    case "envelope-error":
      return "envelope-error";
    case "envelope-success":
      return "envelope-success";
    case "list":
      return "list-ul";
    case "grid":
      return "card";
    case "send":
      return "message";
    case "meatballs":
      return "meatballs";
    case "kebab":
      return "kebab";
    case "attachment":
      return "paperclip";
    case "plus":
      return "plus";
    case "sync":
      return "refresh";
    case "search":
      return "search";
    case "payment":
      return "payment";
    case "file-info":
      return "file-info";
    case "trash":
      return "trash";
    case "user":
      return "user";
    case "user-circle":
      return "user-circle";
    case "users":
      return "users";
    case "times":
      return "times";
    case "times-circle":
      return "times-circle";
    case "calculator":
      return "calculator";
    case "info":
      return "info-circle";
    case "phone":
      return "phone";
    case "refresh":
      return "refresh";
    case "angle-left":
      return "angle-left";
    case "angle-right":
      return "angle-right";
    case "angle-up":
      return "angle-up";
    case "angle-down":
      return "angle-down";
    case "arrow-left":
      return "arrow-left";
    case "arrow-right":
      return "arrow-right";
    case "arrow-double-left":
      return "angle-double-left";
    case "arrow-double-right":
      return "angle-double-right";
    case "arrow-up":
      return "arrow-up";
    case "arrow-down":
      return "arrow-down";
    case "sort":
      return "sort";
    case "avatar":
      return "user-circle";
    case "question":
      return "question";
    case "clipboard":
      return "clipboard-notes";
    case "paperclip":
      return "paperclip";
    case "keyboard":
      return "keyboard";
    case "home":
      return "home";
    case "money-sign":
      return "dollar";
    case "minus-circle":
      return "minus-circle";
    case "minus":
      return "minus";
    case "color-warning":
      return "warning-color";
    case "color-success":
      return "check-circle-color";
    case "color-plus":
      return "plus-circle-filled";
    case "color-times":
      return "times-circle-filled";
    case "color-danger":
      return "danger-color";
    case "color-info":
      return "info-circle-color";
    case "color-minus":
      return "minus-circle-filled";
    case "color-back":
      return "circle-chevron-left-color";
    case "color-triangle":
      return "caret-down";
    case "color-question":
      return "question-circle-filled";
    case "color-next":
      return "circle-chevron-right-color";
    case "arrow-circle-filled-up":
      return "arrow-circle-up-filled";
    case "arrow-circle-filled-left":
      return "arrow-circle-left-filled";
    case "arrow-circle-filled-down":
      return "arrow-circle-down-filled";
    case "arrow-circle-filled-right":
      return "arrow-circle-right-filled";
    case "notes":
      return "comment";
    case "notes-filled":
      return "comment-filled";
    case "notes-plus":
      return "comment-plus";
    case "file-edit":
      return "file-edit";
    case "logout":
      return "logout";
    case "lock":
      return "lock";
    case "lock-open":
      return "lock-open";
    case "file-dollar":
      return "file-dollar";
    case "credit":
      return "credit";
    case "clock":
      return "clock";
    case "file-plus":
      return "file-plus";
    case "question-circle-filled":
      return "question-circle-filled";
    case "question-circle":
      return "question-circle";
    case "in-progress":
      return "in-progress";
    case "waiting":
      return "waiting";
    case "block":
      return "block";
    case "minus-circle-filled":
      return "minus-circle-filled";
    case "arrow-circle-down":
      return "arrow-circle-down";
    case "arrow-circle-left":
      return "arrow-circle-left";
    case "arrow-circle-right":
      return "arrow-circle-right";
    case "arrow-circle-up":
      return "arrow-circle-up";
    case "info-filled":
      return "info-circle-filled";
    case "times-circle-filled":
      return "times-circle-filled";
    case "user-circle-filled":
      return "user-circle-filled";
    case "user-filled":
      return "user-filled";
    case "users-filled":
      return "users-filled";
    case "danger-filled":
      return "danger-filled";
    case "warning-filled":
      return "warning-filled";
    case "success-filled":
      return "check-circle-filled";
    case "check-color":
      return "check-color";
    case "upload-alt":
      return "upload-alt";
    case "camera-plus":
      return "camera-plus";
    case "circle-phone":
      return "circle-phone";
    case "file-alt":
      return "file-alt";
    case "setting-filled":
      return "setting-filled";
    case "bell":
      return "bell";
    case "bell-filled":
      return "bell-filled";
    case "caret-left":
      return "caret-left";
    case "caret-right":
      return "caret-right";
    case "caret-up":
      return "caret-up";
    case "caret-down":
      return "caret-down";
    case "sort-selected":
      return "sort-down";
    case "menu":
      return "menu";
    case "envelope-edit":
      return "envelope-edit";
    case "undo":
      return "undo";
    case "plus-circle-filled":
      return "plus-circle-filled";
    case "plus-circle":
      return "plus-circle";
    case "chart":
      return "chart-outline";
    case "chart-filled":
      return "chart-filled";
    case "chart-pie":
      return "chart-pie";
    case "chart-growth":
      return "chart-growth";
    case "chart-bar":
      return "chart-bar";
    case "circle-file":
      return "project-info";
    case "circle-file-edit":
      return "sign-loan-docs";
    case "circle-file-plus":
      return "conditions";
    case "open-new-tab":
      return "open-new-tab";
    default:
      throw new Error(`icon type: ${type} does not exist`);
  }
};
const sizeVariants$6 = {
  xs: "14px",
  sm: "18px",
  md: "24px",
  lg: "32px",
  xl: "64px"
};
const Icon = React.forwardRef((_g, ref) => {
  var _h = _g, {
    variant = "warning",
    size = "md",
    display = "inline-block",
    title,
    sx
  } = _h, props = __objRest(_h, [
    "variant",
    "size",
    "display",
    "title",
    "sx"
  ]);
  const iconType = iconMapping(variant);
  const dimension = Array.isArray(size) ? size.map((x) => sizeVariants$6[x]) : sizeVariants$6[size];
  return jsxs(Box, __spreadProps(__spreadValues({
    as: "svg",
    viewBox: "0 0 24 24",
    "data-component": "Icon",
    ref,
    sx: __spreadProps(__spreadValues({}, sx), {
      display,
      width: dimension,
      height: dimension
    })
  }, props), {
    children: [title && jsx("title", {
      children: title
    }), jsx("use", {
      href: `#icon-${iconType}`,
      xlinkHref: `#icon-${iconType}`
    })]
  }));
});
const InputError = ({
  errorMessage,
  id
}) => {
  if (!errorMessage)
    return null;
  return jsxs(Flex, {
    id,
    sx: {
      alignItems: "center",
      justifyContent: "flex-start",
      mt: "6px"
    },
    children: [jsx(Icon, {
      size: "sm",
      sx: {
        mr: 1,
        ml: "-1px"
      },
      variant: "color-danger",
      "aria-hidden": "true"
    }), jsx(VisuallyHidden, {
      children: "Error:"
    }), jsx(Box, {
      sx: {
        color: "danger.d1",
        fontWeight: 500,
        variant: "text.small"
      },
      children: errorMessage
    })]
  });
};
const InputBox = (_i) => {
  var _j = _i, {
    hasError
  } = _j, props = __objRest(_j, [
    "hasError"
  ]);
  return jsx(Box, __spreadValues({
    variant: hasError ? "inputContainer.boxError" : "inputContainer.box"
  }, props));
};
const InputFieldSet = (_k) => {
  var _l = _k, {
    hasError
  } = _l, props = __objRest(_l, [
    "hasError"
  ]);
  return jsx(Box, __spreadValues({
    as: "fieldset",
    variant: hasError ? "inputContainer.fieldsetError" : "inputContainer.fieldset"
  }, props));
};
const Prefix = (_m) => {
  var _n = _m, {
    inputElement,
    hasError,
    isReadonly
  } = _n, props = __objRest(_n, [
    "inputElement",
    "hasError",
    "isReadonly"
  ]);
  const className = [hasError ? "input-has-error" : "", isReadonly ? "read-only" : ""].join(" ");
  return jsx(Box, __spreadValues({
    className,
    variant: "inputContainer.prefix",
    onClick: () => {
      var _a;
      return (_a = inputElement.current) == null ? void 0 : _a.focus();
    }
  }, props));
};
const Suffix = (_o) => {
  var _p = _o, {
    hasError,
    inputElement,
    isReadonly
  } = _p, props = __objRest(_p, [
    "hasError",
    "inputElement",
    "isReadonly"
  ]);
  const className = [hasError ? "input-has-error" : "", isReadonly ? "read-only" : ""].join(" ");
  return jsx(Box, __spreadValues({
    className,
    variant: "inputContainer.suffix",
    onClick: () => {
      var _a;
      return (_a = inputElement.current) == null ? void 0 : _a.focus();
    }
  }, props));
};
const InputContainer = (_q) => {
  var _r = _q, {
    hasError,
    size,
    prefix,
    suffix,
    width = "100%",
    sx,
    sxProps = {},
    readOnly = false,
    name
  } = _r, rest = __objRest(_r, [
    "hasError",
    "size",
    "prefix",
    "suffix",
    "width",
    "sx",
    "sxProps",
    "readOnly",
    "name"
  ]);
  const inputRef = React.createRef();
  const classNames2 = [prefix ? "input-prefix" : "", suffix ? "input-suffix" : "", hasError ? "input-has-error" : "", readOnly ? "read-only" : ""].join(" ");
  const columns = [prefix ? "max-content" : void 0, "1fr", suffix ? "max-content" : void 0].filter(Boolean).join(" ");
  return jsxs(Grid, {
    gap: 0,
    sx: __spreadValues(__spreadValues({
      gridTemplateColumns: columns,
      width: size ? `calc(${size}ch + 40px)` : width,
      boxSizing: "border-box",
      pt: 1
    }, sx), sxProps),
    children: [prefix && jsx(Prefix, {
      isReadonly: readOnly,
      hasError,
      inputElement: inputRef,
      children: prefix
    }), jsx(Box, __spreadValues({
      variant: "inputContainer.base",
      ref: inputRef,
      className: classNames2,
      "aria-readonly": readOnly,
      readOnly,
      name,
      "aria-invalid": hasError
    }, rest)), suffix && jsx(Suffix, {
      isReadonly: readOnly,
      hasError,
      inputElement: inputRef,
      children: suffix
    })]
  });
};
const placementMap = (placement) => {
  switch (placement) {
    case "top":
      return {
        bottom: "-4px"
      };
    case "bottom":
      return {
        top: "-4px"
      };
    case "left":
      return {
        right: "-4px"
      };
    case "right":
      return {
        left: "-4px"
      };
    default:
      return {
        left: "-4px"
      };
  }
};
const Arrow = forwardRef((_s, ref) => {
  var _t = _s, {
    placement = "right",
    bg = "primary.l3"
  } = _t, props = __objRest(_t, [
    "placement",
    "bg"
  ]);
  return jsx(Box, __spreadProps(__spreadValues({
    ref,
    sx: __spreadProps(__spreadValues({
      position: "absolute",
      width: "10px",
      height: "10px",
      zIndex: "-1"
    }, placementMap(placement)), {
      "::after": {
        position: "absolute",
        width: "10px",
        height: "10px",
        zIndex: "-1",
        content: '""',
        transform: "rotate(45deg)",
        bg
      }
    })
  }, props), {
    "data-popper-arrow": true
  }));
});
const Tooltip = ({
  position = "right",
  children
}) => {
  const [visible, setVisible] = useState(false);
  return jsxs(Manager, {
    children: [jsx(Reference, {
      children: ({
        ref
      }) => jsx(Icon, {
        ref,
        variant: "color-question",
        color: "primary.base",
        onClick: () => setVisible(!visible),
        size: "sm",
        sx: {
          ml: 1
        }
      })
    }), visible ? jsx(Popper, {
      placement: position,
      eventsEnabled: false,
      children: ({
        ref,
        style,
        placement,
        arrowProps
      }) => jsxs(Box, {
        role: "tooltip",
        ref,
        style,
        "data-placement": placement,
        sx: {
          bg: "primary.l3",
          color: "#3d3d3d",
          py: 1,
          px: 2,
          fontSize: 2,
          borderRadius: "rounded",
          boxShadow: 1
        },
        children: [children, jsx(Arrow, __spreadProps(__spreadValues({}, arrowProps), {
          placement: placement || "right"
        }))]
      })
    }) : null]
  });
};
var Tooltip$1 = memo(Tooltip);
const TextInput = (_u) => {
  var _v = _u, {
    name,
    label,
    description,
    type = "text",
    tooltip
  } = _v, props = __objRest(_v, [
    "name",
    "label",
    "description",
    "type",
    "tooltip"
  ]);
  const [field, meta] = useField(name);
  const {
    prefix
  } = React.useContext(INTERNAL_ONLY_FORM_INFO);
  const hasError = Boolean(meta.error);
  const inputId = `${prefix}-${name}`;
  const descriptionId = `${inputId}-description`;
  const errorId = `${inputId}-error`;
  const describedBy = [description ? descriptionId : void 0, hasError ? errorId : void 0].filter(Boolean);
  const options = {
    hasError,
    id: inputId,
    type,
    "aria-describedby": describedBy.length ? describedBy.join(" ") : void 0
  };
  return jsxs(InputBox, {
    hasError,
    children: [jsx("label", {
      htmlFor: inputId,
      children: label
    }), tooltip && jsx(Tooltip$1, {
      children: tooltip
    }), description && jsx(Box, {
      variant: "inputContainer.description",
      id: descriptionId,
      children: description
    }), jsx(InputContainer, __spreadValues(__spreadValues(__spreadValues({
      as: "input"
    }, options), props), field)), jsx(InputError, {
      id: errorId,
      errorMessage: meta.error
    })]
  });
};
const Button = (_w) => {
  var _x = _w, {
    variant = "primary",
    type = "button"
  } = _x, rest = __objRest(_x, [
    "variant",
    "type"
  ]);
  return jsx(Button$1, __spreadProps(__spreadValues({
    type,
    "data-component": "Button"
  }, rest), {
    variant
  }));
};
const ButtonLink = (_y) => {
  var _z = _y, {
    clean
  } = _z, rest = __objRest(_z, [
    "clean"
  ]);
  return jsx(Button, __spreadValues({
    sx: __spreadProps(__spreadValues({
      color: "primary.base",
      fontSize: 2,
      fontWeight: 400,
      textTransform: "none",
      px: 0
    }, !clean && {
      textDecoration: "underline"
    }), {
      "&:hover": {
        color: "primary.d2",
        bg: "transparent"
      }
    }),
    variant: "ghost"
  }, rest));
};
const ButtonBack = (_A) => {
  var _B = _A, {
    sx = {},
    children
  } = _B, rest = __objRest(_B, [
    "sx",
    "children"
  ]);
  const styles2 = __spreadValues({
    color: "primary.base",
    textTransform: "none",
    fontSize: 2,
    py: "1px",
    px: 0,
    ":hover": {
      bg: "transparent",
      textDecoration: "underline"
    }
  }, sx);
  return jsxs(Button, __spreadProps(__spreadValues({
    sx: styles2,
    variant: "ghost"
  }, rest), {
    children: [jsx(Box, {
      sx: {
        bg: "primary.base",
        px: "1px",
        mr: 2,
        borderRadius: "full"
      },
      children: jsx(Icon, {
        variant: "arrow-left",
        color: "white",
        sx: {
          "::before": {
            mx: 0,
            ml: "-1px"
          }
        }
      })
    }), children]
  }));
};
const DispositionButton = ({
  color = "neutral.l4",
  icon,
  iconColor = "neutral.base",
  iconSize = "md",
  disabled = false,
  onClick
}) => jsx("a", {
  onClick: disabled ? () => {
  } : () => {
    onClick && onClick();
  },
  children: jsx(Box, {
    sx: {
      bg: color,
      border: "1px solid",
      borderColor: "neutral.l3",
      borderRadius: "rounded",
      width: 40,
      height: 32,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      cursor: disabled ? "not-allowed" : "pointer"
    },
    children: jsx(Icon, {
      size: iconSize,
      variant: icon,
      color: iconColor
    })
  })
});
const ButtonConfirmationTooltip = ({
  buttonLabel,
  buttonVariant = "primary",
  tooltipPosition = "top",
  children,
  zIndex = 0,
  onClick: onClickHandler = void 0,
  dismissOnOutsideClick = true
}) => {
  const [visible, setVisible] = useState(false);
  return jsxs(Manager, {
    children: [jsx(Reference, {
      children: ({
        ref
      }) => jsx(Button$1, {
        sx: {
          zIndex
        },
        ref,
        type: "button",
        "data-component": "Button",
        variant: buttonVariant,
        onClick: async () => {
          let state = !visible;
          if (onClickHandler) {
            const res = await onClickHandler();
            if (typeof res === "boolean")
              state = res;
          }
          setVisible(state);
        },
        children: buttonLabel
      })
    }), visible ? jsxs(Fragment, {
      children: [jsx(Box, {
        sx: {
          position: "fixed",
          zIndex: zIndex + 1,
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: "rgba(0, 0, 0, 0.5)"
        },
        onClick: () => setVisible(!dismissOnOutsideClick)
      }), jsx(Popper, {
        placement: tooltipPosition,
        eventsEnabled: false,
        modifiers: [{
          name: "offset",
          options: {
            offset: [-65, 30]
          }
        }],
        children: ({
          ref,
          style,
          placement,
          arrowProps
        }) => jsxs(Box, {
          role: "tooltip",
          ref,
          style,
          "data-placement": placement,
          sx: {
            bg: "primary.l4",
            color: "#3d3d3d",
            py: 10,
            px: 10,
            fontSize: 2,
            borderRadius: "3px",
            boxShadow: "0 0 4px 0 rgba(0,0,0,0.1)",
            border: "1px solid #F2F8F9",
            zIndex: zIndex + 2
          },
          children: [children, jsx(Arrow, __spreadProps(__spreadValues({}, arrowProps), {
            placement,
            bg: "primary.l4"
          }))]
        })
      })]
    }) : null]
  });
};
const SecretInput = (_C) => {
  var _D = _C, {
    name,
    label,
    description,
    children,
    tooltip
  } = _D, props = __objRest(_D, [
    "name",
    "label",
    "description",
    "children",
    "tooltip"
  ]);
  const [field, meta] = useField(name);
  const [isVisible, setVisible] = React.useState(false);
  const {
    prefix
  } = React.useContext(INTERNAL_ONLY_FORM_INFO);
  const hasError = Boolean(meta.error);
  const inputId = `${prefix}-${name}`;
  const descriptionId = `${inputId}-description`;
  const errorId = `${inputId}-error`;
  const describedBy = [description ? descriptionId : void 0, hasError ? errorId : void 0].filter(Boolean);
  const options = {
    hasError,
    id: inputId,
    type: isVisible ? "text" : "password",
    "aria-describedby": describedBy.length ? describedBy.join(" ") : void 0
  };
  return jsxs(InputBox, {
    hasError,
    children: [jsxs(Flex, {
      sx: {
        justifyContent: "space-between",
        alignItems: "flex-end"
      },
      children: [jsxs("div", {
        children: [jsx("label", {
          htmlFor: inputId,
          children: label
        }), tooltip && jsx(Tooltip$1, {
          children: tooltip
        }), description && jsx(Box, {
          variant: "inputContainer.description",
          id: descriptionId,
          children: description
        })]
      }), jsx(Button, {
        sx: {
          height: "28px",
          width: "30px",
          minHeight: "0",
          mb: -1,
          p: 0
        },
        onClick: () => setVisible(!isVisible),
        tabIndex: -1,
        type: "button",
        variant: "ghost",
        "aria-pressed": isVisible,
        children: jsx(Icon, {
          size: "sm",
          variant: isVisible ? "eye-closed" : "eye-open",
          title: "Show password"
        })
      })]
    }), jsx(InputContainer, __spreadValues(__spreadValues(__spreadValues({
      as: "input"
    }, options), props), field)), jsx(InputError, {
      id: errorId,
      errorMessage: meta.error
    }), React.Children.map(children, (child) => React.cloneElement(child, {
      inputId,
      name
    }))]
  });
};
const NumberInput = (_E) => {
  var _F = _E, {
    name,
    label,
    description,
    tooltip
  } = _F, props = __objRest(_F, [
    "name",
    "label",
    "description",
    "tooltip"
  ]);
  const [field, meta] = useField(name);
  const {
    prefix
  } = React.useContext(INTERNAL_ONLY_FORM_INFO);
  const inputId = `${prefix}-${name}`;
  const hasError = Boolean(meta.error);
  const descriptionId = `${inputId}-description`;
  const errorId = `${inputId}-error`;
  const describedBy = [description ? descriptionId : void 0, hasError ? errorId : void 0].filter(Boolean);
  const options = {
    hasError,
    id: inputId,
    spellCheck: false,
    "aria-describedby": describedBy.length ? describedBy.join(" ") : void 0,
    type: "text",
    inputMode: "decimal"
  };
  return jsxs(InputBox, {
    hasError,
    children: [jsx("label", {
      htmlFor: inputId,
      children: label
    }), tooltip && jsx(Tooltip$1, {
      children: tooltip
    }), description && jsx(Box, {
      variant: "inputContainer.description",
      id: descriptionId,
      children: description
    }), jsx(InputContainer, __spreadValues(__spreadValues(__spreadValues({
      as: "input",
      pattern: "^\\d*(\\.\\d{0,2})?$"
    }, options), props), field)), jsx(InputError, {
      id: errorId,
      errorMessage: meta.error
    })]
  });
};
const parseValue = (value) => {
  if (Number.isNaN(value))
    return "";
  const fixed = value.toFixed(2);
  return fixed.replace(".00", "");
};
const PercentageInput = (_G) => {
  var _H = _G, {
    name,
    label,
    description,
    variant = "text",
    tooltip
  } = _H, props = __objRest(_H, [
    "name",
    "label",
    "description",
    "variant",
    "tooltip"
  ]);
  const [field, meta, helpers] = useField(name);
  const initialValue = parseFloat(field.value) * 100;
  const [value, setValue] = useState(parseValue(initialValue));
  const {
    prefix
  } = React.useContext(INTERNAL_ONLY_FORM_INFO);
  const hasError = Boolean(meta.error);
  const inputId = `${prefix}-${name}`;
  const descriptionId = `${inputId}-description`;
  const errorId = `${inputId}-error`;
  const describedBy = [description ? descriptionId : void 0, hasError ? errorId : void 0].filter(Boolean);
  const options = {
    hasError,
    id: inputId,
    spellCheck: false,
    pattern: "[0-9]*",
    type: variant,
    "aria-describedby": describedBy.length ? describedBy.join(" ") : void 0
  };
  return jsxs(InputBox, {
    hasError,
    children: [jsx("label", {
      htmlFor: inputId,
      children: label
    }), tooltip && jsx(Tooltip$1, {
      children: tooltip
    }), description && jsx(Box, {
      variant: "inputContainer.description",
      id: descriptionId,
      children: description
    }), jsx(InputContainer, __spreadProps(__spreadValues(__spreadValues(__spreadValues({
      as: "input",
      inputMode: "numeric"
    }, options), props), field), {
      value,
      onChange: (e) => {
        setValue(e.target.value);
        const percent = parseFloat(e.target.value) / 100 || "";
        helpers.setValue(percent);
      }
    })), jsx(InputError, {
      id: errorId,
      errorMessage: meta.error
    })]
  });
};
const TextArea = (_I) => {
  var _J = _I, {
    name,
    label,
    description,
    maxLength,
    tooltip
  } = _J, props = __objRest(_J, [
    "name",
    "label",
    "description",
    "maxLength",
    "tooltip"
  ]);
  const [field, meta] = useField(name);
  const [showLength, toggleLength] = React.useState(false);
  const {
    prefix
  } = React.useContext(INTERNAL_ONLY_FORM_INFO);
  const hasError = Boolean(meta.error);
  const inputId = `${prefix}-${name}`;
  const descriptionId = `${inputId}-description`;
  const errorId = `${inputId}-error`;
  React.useEffect(() => {
    if (!maxLength)
      return;
    const criticalPercent = maxLength - 0.25 * maxLength;
    if (field.value && field.value.length >= criticalPercent)
      toggleLength(true);
    else if (showLength)
      toggleLength(false);
  }, [field.value]);
  const describedBy = [description ? descriptionId : void 0, hasError ? errorId : void 0].filter(Boolean);
  const options = {
    hasError,
    id: inputId,
    maxLength,
    "aria-describedby": describedBy.length ? describedBy.join(" ") : void 0
  };
  return jsxs(InputBox, {
    hasError,
    children: [label && jsx("label", {
      htmlFor: inputId,
      children: label
    }), tooltip && jsx(Tooltip$1, {
      children: tooltip
    }), description && jsx(Box, {
      variant: "inputContainer.description",
      id: descriptionId,
      children: description
    }), jsx(InputContainer, __spreadValues(__spreadValues(__spreadValues({
      as: "textarea"
    }, options), field), props)), jsxs(Grid, {
      columns: [1, "1fr max-content"],
      sx: {
        alignItems: "center"
      },
      children: [jsx(InputError, {
        id: errorId,
        errorMessage: meta.error
      }), maxLength && showLength && jsxs("div", {
        "aria-live": "polite",
        role: "status",
        sx: {
          variant: "text.small",
          color: "danger.base",
          fontWeight: 500
        },
        children: [maxLength - field.value.length, jsx("span", {
          children: " "
        }), "remaining characters"]
      })]
    })]
  });
};
const DateInputContainers = ({
  name,
  autoComplete,
  readOnly,
  helpers,
  field,
  inputId
}) => {
  const fieldValue = (field == null ? void 0 : field.value) || "--";
  const yearId = `${inputId}-year`;
  const dayId = `${inputId}-day`;
  const {
    monthValue,
    yearValue,
    dayValue
  } = React.useMemo(() => {
    const date = fieldValue == null ? void 0 : fieldValue.split("-");
    return {
      monthValue: date[1],
      dayValue: date[2],
      yearValue: date[0]
    };
  }, [fieldValue]);
  return jsxs(Fragment, {
    children: [jsxs("div", {
      sx: {
        mr: 2
      },
      children: [jsx("label", {
        htmlFor: inputId,
        children: "Month"
      }), jsx(InputContainer, {
        as: "input",
        readOnly,
        id: inputId,
        inputMode: "numeric",
        name: `${name}.month`,
        placeholder: "MM",
        size: 2,
        maxLength: 2,
        autoComplete,
        onChange: (e) => {
          helpers.setValue(`${yearValue}-${e.target.value}-${dayValue}`);
        },
        value: monthValue,
        hasError: false
      })]
    }), jsxs("div", {
      sx: {
        mr: 2
      },
      children: [jsx("label", {
        htmlFor: dayId,
        children: "Day"
      }), jsx(InputContainer, {
        as: "input",
        id: dayId,
        readOnly,
        placeholder: "DD",
        inputMode: "numeric",
        name: `${name}.day`,
        size: 2,
        maxLength: 2,
        autoComplete,
        onChange: (e) => {
          helpers.setValue(`${yearValue}-${monthValue}-${e.target.value}`);
        },
        value: dayValue,
        hasError: false
      })]
    }), jsxs("div", {
      sx: {
        mr: 2
      },
      children: [jsx("label", {
        htmlFor: yearId,
        children: "Year"
      }), jsx(InputContainer, {
        as: "input",
        id: yearId,
        readOnly,
        placeholder: "YYYY",
        inputMode: "numeric",
        name: `${name}.year`,
        size: 4,
        maxLength: 4,
        autoComplete,
        onChange: (e) => {
          helpers.setValue(`${e.target.value}-${monthValue}-${dayValue}`);
        },
        value: yearValue,
        hasError: false
      })]
    })]
  });
};
const DateInput = ({
  name,
  label,
  tooltip,
  description,
  autoComplete,
  readOnly = false
}) => {
  const [field, meta, helpers] = useField(name);
  const {
    prefix
  } = React.useContext(INTERNAL_ONLY_FORM_INFO);
  const hasError = Boolean(meta.error);
  const inputId = `${prefix}-${name}`;
  const descriptionId = `${inputId}-description`;
  const errorId = `${inputId}-error`;
  const describedBy = [description ? descriptionId : void 0, hasError ? errorId : void 0].filter(Boolean);
  const options = {
    "aria-describedby": describedBy.length ? describedBy.join(" ") : void 0
  };
  return jsxs(InputFieldSet, __spreadProps(__spreadValues({
    hasError
  }, options), {
    sx: {
      display: "flex",
      flexDirection: "column"
    },
    children: [jsxs("legend", {
      children: [label, tooltip && jsx(Tooltip$1, {
        children: tooltip
      })]
    }), description && jsx("div", {
      sx: {
        variant: "inputContainer.description"
      },
      id: descriptionId,
      children: description
    }), jsx("div", {
      sx: {
        mt: 1,
        display: "flex",
        alignItems: "center",
        flexFlow: "row nowrap",
        "& label": {
          fontSize: 1
        }
      },
      children: jsx(DateInputContainers, {
        name,
        helpers,
        field,
        inputId,
        autoComplete,
        readOnly
      })
    }), jsx(InputError, {
      id: errorId,
      errorMessage: meta.error
    })]
  }));
};
const SelectSearch = (props) => jsx(InputContainer, __spreadValues({
  as: "input",
  type: "search",
  placeholder: "Search",
  autoCapitalize: "none",
  autoComplete: "off",
  prefix: jsx(Icon, {
    variant: "search",
    color: "primary.base",
    sx: {
      width: 20,
      height: 20,
      ml: 1,
      mt: 1
    }
  })
}, props));
const getListPositionFromRef = (parentRef) => {
  var _a;
  const element = parentRef == null ? void 0 : parentRef.current;
  if (element) {
    let parent = element == null ? void 0 : element.parentElement;
    const {
      offsetLeft,
      offsetTop,
      offsetHeight
    } = element;
    let scrollTop = 0;
    let top = 0;
    let scrollParent;
    do {
      scrollTop = parent == null ? void 0 : parent.scrollTop;
      scrollParent = parent;
      parent = parent == null ? void 0 : parent.parentElement;
    } while (parent != null && scrollTop === 0);
    if (scrollTop !== 0 && scrollParent.localName !== "html") {
      const nextElementSibling = element == null ? void 0 : element.nextElementSibling;
      const nextSiblingOffsetHeight = (_a = nextElementSibling == null ? void 0 : nextElementSibling.offsetHeight) != null ? _a : 0;
      const parentScrollHeight = scrollParent.scrollHeight;
      const elementBottom = element.getBoundingClientRect().bottom;
      if (nextSiblingOffsetHeight + elementBottom + scrollTop > parentScrollHeight) {
        top = offsetTop - nextSiblingOffsetHeight + window.scrollY;
      } else {
        top = offsetTop + offsetHeight;
      }
      top = top - scrollTop > 0 ? top - scrollTop : top;
    } else {
      top += offsetTop + offsetHeight;
    }
    const position = {
      left: offsetLeft,
      top,
      width: element.offsetWidth
    };
    return position;
  }
  return null;
};
const getScrollParents = (element) => {
  var _a, _b;
  const parents = [];
  let parent = element == null ? void 0 : element.parentNode;
  while (parent && parent.nodeType === 1) {
    let style;
    try {
      style = window.getComputedStyle(parent);
    } catch (err) {
      style = null;
    }
    if (style) {
      if (/(auto|scroll|overlay)/.test(style.overflow + style.overflowY + style.overflowX)) {
        if (["relative", "absolute", "fixed", "static"].indexOf(style.position) >= 0) {
          parents.push(parent);
        }
      }
    }
    parent = parent.parentNode;
  }
  parents.push((_a = element == null ? void 0 : element.ownerDocument) == null ? void 0 : _a.body);
  if ((element == null ? void 0 : element.ownerDocument) !== document) {
    parents.push((_b = element == null ? void 0 : element.ownerDocument) == null ? void 0 : _b.defaultView);
  }
  return parents;
};
const useSetDropdownListPosition = (refObject, isOpen) => {
  const [listPosition, setListPosition] = useState(null);
  useLayoutEffect(() => {
    const updatePosition = () => {
      if (isOpen) {
        const position = getListPositionFromRef(refObject);
        setListPosition(position);
      }
    };
    updatePosition();
    const current = refObject == null ? void 0 : refObject.current;
    const parentListeners = [];
    const scrollParents = getScrollParents(current);
    scrollParents == null ? void 0 : scrollParents.forEach((parent) => {
      if (parent !== (current == null ? void 0 : current.ownerDocument)) {
        parent == null ? void 0 : parent.addEventListener("scroll", updatePosition);
        parentListeners.push(parent);
      }
    });
    ["resize", "touchmove"].forEach((eventType) => window.addEventListener(eventType, updatePosition));
    return () => {
      ["resize", "touchmove"].forEach((eventType) => window.removeEventListener(eventType, updatePosition));
      parentListeners.forEach((parent) => {
        parent.removeEventListener("scroll", updatePosition);
      });
    };
  }, [refObject, isOpen]);
  return listPosition;
};
const SingleSelect$1 = ({
  width = "100%",
  name,
  label,
  description,
  items,
  placeholder = "Select",
  allowSearch = false,
  dangerouslyOnChange = () => {
  },
  readOnly = false,
  sxProps = {},
  tooltip
}) => {
  const [field, meta, helpers] = useField(name);
  const downshiftRef = React.useRef();
  const selectValueItem = React.useMemo(() => {
    if (!field.value)
      return void 0;
    return items.find((item) => item.value === field.value.toString());
  }, [field.value, items]);
  React.useEffect(() => {
    var _a;
    if (!allowSearch)
      (_a = downshiftRef.current) == null ? void 0 : _a._rootNode.removeAttribute("role");
  }, [downshiftRef, allowSearch]);
  const {
    prefix
  } = React.useContext(INTERNAL_ONLY_FORM_INFO);
  const inputId = `${prefix}-${name}`;
  const labelId = `${inputId}-label`;
  const descriptionId = `${inputId}-description`;
  const errorId = `${inputId}-error`;
  const hasError = Boolean(meta.error);
  const buttonRef = React.useRef(null);
  const [isListOpen, setIsListOpen] = React.useState(false);
  const listPosition = useSetDropdownListPosition(buttonRef, isListOpen);
  const describedBy = [hasError ? errorId : void 0, description ? descriptionId : void 0].filter(Boolean);
  const options = {
    "aria-describedby": describedBy.length ? describedBy.join(" ") : void 0
  };
  const getItems = (filter) => filter ? matchSorter(items, filter, {
    keys: ["name"]
  }) : items;
  return jsx(InputBox, {
    hasError,
    sx: sxProps,
    children: jsx(Downshift, {
      ref: downshiftRef,
      itemToString: (item) => {
        var _a, _b;
        return (item == null ? void 0 : item.item) ? (_b = (_a = item == null ? void 0 : item.item) == null ? void 0 : _a.props) == null ? void 0 : _b.children : item == null ? void 0 : item.name;
      },
      stateReducer: (state, changes) => {
        var _a;
        switch (changes.type) {
          case Downshift.stateChangeTypes.keyDownEnter:
          case Downshift.stateChangeTypes.keyDownSpaceButton:
          case Downshift.stateChangeTypes.clickItem:
            dangerouslyOnChange((_a = changes.selectedItem) == null ? void 0 : _a.value);
            return __spreadProps(__spreadValues({}, changes), {
              highlightedIndex: state.highlightedIndex
            });
          default:
            return changes;
        }
      },
      onStateChange: (changes) => {
        if ("isOpen" in changes) {
          setIsListOpen(changes.isOpen);
        }
      },
      selectedItem: selectValueItem || null,
      onSelect: (selectedItem) => helpers.setValue(selectedItem == null ? void 0 : selectedItem.value),
      labelId,
      inputId,
      items,
      children: ({
        isOpen,
        selectedItem,
        getInputProps,
        getToggleButtonProps,
        getLabelProps,
        getMenuProps,
        inputValue,
        highlightedIndex,
        getItemProps
      }) => {
        const list = allowSearch ? getItems(inputValue) : items;
        const filterList = list.map((item, index) => jsx(Box, __spreadProps(__spreadValues({
          className: [highlightedIndex === index ? "active" : "", (selectedItem == null ? void 0 : selectedItem.value) === item.value ? "selected" : ""].join(" "),
          as: "li",
          role: "option",
          variant: "inputContainer.listItem"
        }, getItemProps({
          item,
          index
        })), {
          children: item.name || item.item
        }), item.value.replace(/ /g, "")));
        return jsxs("div", {
          children: [jsx("label", __spreadProps(__spreadValues({
            id: labelId,
            htmlFor: inputId
          }, getLabelProps({
            htmlFor: inputId,
            id: labelId
          })), {
            children: label
          })), tooltip && jsx(Tooltip$1, {
            children: tooltip
          }), description && jsx(Box, {
            variant: "inputContainer.description",
            id: descriptionId,
            children: description
          }), jsxs(Box, __spreadProps(__spreadValues(__spreadProps(__spreadValues({
            className: hasError ? "input-has-error" : "",
            as: "button",
            "aria-labelledby": labelId,
            type: "button"
          }, options), {
            disabled: readOnly,
            variant: "inputContainer.select",
            sx: {
              width
            }
          }), getToggleButtonProps({
            id: inputId,
            ref: buttonRef
          })), {
            children: [jsx("div", {
              children: (selectedItem == null ? void 0 : selectedItem.name) || (selectedItem == null ? void 0 : selectedItem.item) || placeholder
            }), jsx(Icon, {
              variant: "color-triangle",
              color: "primary.base",
              sx: {
                transform: isOpen ? "rotate(180deg)" : void 0
              }
            })]
          })), jsx(Box, __spreadProps(__spreadValues({
            as: "ul",
            variant: "inputContainer.dropzone",
            role: "listbox"
          }, getMenuProps(options)), {
            sx: !isOpen ? {
              border: "none",
              m: 0,
              boxShadow: 0,
              p: 0
            } : {
              width: listPosition == null ? void 0 : listPosition.width,
              top: listPosition == null ? void 0 : listPosition.top,
              left: listPosition == null ? void 0 : listPosition.left,
              zIndex: 99999
            },
            children: jsxs("div", {
              sx: !isOpen ? hiddenVisually : {},
              children: [allowSearch && jsx(SelectSearch, __spreadValues({}, getInputProps())), filterList.length ? filterList : jsx("div", {
                sx: {
                  px: 2
                },
                children: "No items found"
              })]
            })
          })), jsx(InputError, {
            id: errorId,
            errorMessage: meta.error
          })]
        });
      }
    })
  });
};
const countriesWithoutStates = ["PR"];
const stateMapping = {
  AL: "Alabama",
  AK: "Alaska",
  AZ: "Arizona",
  AR: "Arkansas",
  CA: "California",
  CO: "Colorado",
  CT: "Connecticut",
  DE: "Delaware",
  DC: "District Of Columbia",
  FL: "Florida",
  GA: "Georgia",
  HI: "Hawaii",
  ID: "Idaho",
  IL: "Illinois",
  IN: "Indiana",
  IA: "Iowa",
  KS: "Kansas",
  KY: "Kentucky",
  LA: "Louisiana",
  ME: "Maine",
  MD: "Maryland",
  MA: "Massachusetts",
  MI: "Michigan",
  MN: "Minnesota",
  MS: "Mississippi",
  MO: "Missouri",
  MT: "Montana",
  NE: "Nebraska",
  NV: "Nevada",
  NH: "New Hampshire",
  NJ: "New Jersey",
  NM: "New Mexico",
  NY: "New York",
  NC: "North Carolina",
  ND: "North Dakota",
  OH: "Ohio",
  OK: "Oklahoma",
  OR: "Oregon",
  PA: "Pennsylvania",
  PR: "Puerto Rico",
  RI: "Rhode Island",
  SC: "South Carolina",
  SD: "South Dakota",
  TN: "Tennessee",
  TX: "Texas",
  UT: "Utah",
  VT: "Vermont",
  VA: "Virginia",
  WA: "Washington",
  WV: "West Virginia",
  WI: "Wisconsin",
  WY: "Wyoming"
};
const stateSelection = Object.entries(stateMapping).map(([key, value]) => ({
  name: value,
  value: key
}));
const fillInAddress = (place) => {
  const placeTypes = {
    houseNumber: {
      valueType: "short_name",
      possibleTypes: ["street_number"]
    },
    zip: {
      valueType: "short_name",
      possibleTypes: ["postal_code"]
    },
    street: {
      valueType: "long_name",
      possibleTypes: ["street_address", "route"]
    },
    city: {
      valueType: "long_name",
      possibleTypes: [
        "locality",
        "sublocality",
        "sublocality_level_1",
        "sublocality_level_2",
        "sublocality_level_3"
      ]
    },
    state: {
      valueType: "short_name",
      possibleTypes: [
        "administrative_area_level_1",
        "administrative_area_level_2",
        "administrative_area_level_3"
      ]
    },
    country: {
      valueType: "short_name",
      possibleTypes: ["country"]
    }
  };
  const finalAddressEntries = Object.entries(placeTypes).map(([placeKey, placeValues]) => {
    var _a;
    let finalValue;
    (_a = place.address_components) == null ? void 0 : _a.forEach((addressComponent) => {
      if (placeValues.possibleTypes.includes(addressComponent.types[0])) {
        finalValue = addressComponent[placeValues.valueType];
      }
    });
    return [placeKey, finalValue];
  });
  const {
    houseNumber = "",
    street = "",
    city = "",
    state = "",
    country = "",
    zip = ""
  } = Object.fromEntries(finalAddressEntries);
  const isCountryWithoutStates = countriesWithoutStates.includes(country);
  return {
    street1: houseNumber ? `${houseNumber} ${street}` : street,
    street2: "",
    city,
    state: isCountryWithoutStates ? country : state,
    zip
  };
};
const useOnClickOutside = (ref, handler) => {
  useEffect(() => {
    const listener = (event) => {
      if (!ref.current || ref.current.contains(event.target)) {
        return;
      }
      handler(event);
    };
    document.addEventListener("mousedown", listener);
    document.addEventListener("touchstart", listener);
    return () => {
      document.removeEventListener("mousedown", listener);
      document.removeEventListener("touchstart", listener);
    };
  }, [ref, handler]);
};
const AddressInput = ({
  name,
  label,
  description,
  autoComplete,
  readOnly = false,
  statesArray = stateSelection,
  fieldsLabels
}) => {
  const [field, meta, helpers] = useField(name);
  const metaError = meta.error;
  const {
    prefix
  } = React.useContext(INTERNAL_ONLY_FORM_INFO);
  const hasError = Boolean(meta.error);
  const inputId = `${prefix}-${name}`;
  const street1Id = `${inputId}.street1`;
  const descriptionId = `${street1Id}-description`;
  const fieldValue = field.value || {};
  const defaultLabels = {
    street1: "Street address (no PO boxes)",
    street2: "Address line 2 (optional)",
    city: "City",
    zip: "Zip / Postal code"
  };
  const labels = __spreadValues(__spreadValues({}, defaultLabels), fieldsLabels);
  const preventEnter = (e) => {
    if (e.keyCode === 13) {
      e.preventDefault();
    }
  };
  useEffect(() => {
    if (window === void 0) {
      return void 0;
    }
    const {
      google
    } = window;
    if (google === void 0) {
      return void 0;
    }
    const input = document.getElementById(street1Id);
    const options2 = {
      componentRestrictions: {
        country: ["us", "pr"]
      }
    };
    if (input) {
      input.addEventListener("keypress", preventEnter);
    }
    const maps = new google.maps.places.Autocomplete(input, options2);
    maps.addListener("place_changed", () => {
      const place = maps.getPlace();
      const address = fillInAddress(place);
      helpers.setValue(address);
    });
    return () => {
      input == null ? void 0 : input.removeEventListener("keypress", preventEnter);
    };
  }, []);
  const street2Id = `${inputId}.street2`;
  const cityId = `${inputId}.city`;
  const stateId = `${inputId}.state`;
  const zipId = `${inputId}.zip`;
  const street1ErrorId = `${street1Id}-error`;
  const street2ErrorId = `${street2Id}-error`;
  const cityErrorId = `${cityId}-error`;
  const zipErrorId = `${zipId}-error`;
  const describedBy = [description ? descriptionId : void 0, hasError ? street1ErrorId : void 0].filter(Boolean);
  const options = {
    "aria-describedby": describedBy.length ? describedBy.join(" ") : void 0
  };
  const {
    street1,
    street2,
    city,
    state,
    zip
  } = fieldValue;
  return jsxs(InputFieldSet, __spreadProps(__spreadValues({
    hasError
  }, options), {
    children: [jsx("legend", {
      onClick: () => {
        var _a;
        return (_a = document.getElementById(street1Id)) == null ? void 0 : _a.focus();
      },
      children: label
    }), jsx(Box, {
      sx: {
        clear: "left"
      }
    }), description && jsx(Box, {
      variant: "inputContainer.description",
      id: descriptionId,
      children: description
    }), jsxs(Box, {
      children: [jsxs(InputBox, {
        children: [jsx("label", {
          htmlFor: street1Id,
          children: labels.street1
        }), jsx(InputContainer, {
          as: "input",
          readOnly,
          id: street1Id,
          inputMode: "text",
          name: `${name}.street1`,
          autoComplete,
          onChange: (e) => {
            helpers.setValue({
              street1: e.target.value,
              street2,
              city,
              state,
              zip
            });
          },
          value: street1,
          hasError: !!(metaError == null ? void 0 : metaError.street1),
          "aria-describedby": (metaError == null ? void 0 : metaError.street1) ? street1ErrorId : void 0
        }), jsx(InputError, {
          id: street1ErrorId,
          errorMessage: metaError == null ? void 0 : metaError.street1
        })]
      }), jsxs(InputBox, {
        children: [jsx("label", {
          htmlFor: street2Id,
          children: labels.street2
        }), jsx(InputContainer, {
          as: "input",
          readOnly,
          id: street2Id,
          inputMode: "text",
          name: `${name}.street2`,
          autoComplete,
          onChange: (e) => {
            helpers.setValue({
              street1,
              street2: e.target.value,
              city,
              state,
              zip
            });
          },
          value: street2,
          hasError: !!(metaError == null ? void 0 : metaError.street2),
          "aria-describedby": (metaError == null ? void 0 : metaError.street2) ? street2ErrorId : void 0
        }), jsx(InputError, {
          id: street2ErrorId,
          errorMessage: metaError == null ? void 0 : metaError.street2
        })]
      }), jsxs(InputBox, {
        children: [jsx("label", {
          htmlFor: cityId,
          children: labels.city
        }), jsx(InputContainer, {
          as: "input",
          readOnly,
          id: cityId,
          inputMode: "text",
          name: `${name}.city`,
          autoComplete,
          onChange: (e) => {
            helpers.setValue({
              street1,
              street2,
              city: e.target.value,
              state,
              zip
            });
          },
          sxProps: {
            maxWidth: "19rem"
          },
          value: city,
          hasError: !!(metaError == null ? void 0 : metaError.city),
          "aria-describedby": (metaError == null ? void 0 : metaError.city) ? cityErrorId : void 0
        }), jsx(InputError, {
          id: cityErrorId,
          errorMessage: metaError == null ? void 0 : metaError.city
        })]
      }), jsx(InputBox, {
        children: jsx(SingleSelect$1, {
          label: "State / Territory",
          readOnly,
          id: stateId,
          name: `${name}.state`,
          onChange: ({
            value
          }) => {
            helpers.setValue({
              street1,
              street2,
              city,
              state: value,
              zip
            });
          },
          sxProps: {
            mb: 0,
            pb: 0
          },
          items: statesArray,
          width: "250px"
        })
      }), jsxs(InputBox, {
        children: [jsx("label", {
          htmlFor: zipId,
          children: labels.zip
        }), jsx(InputContainer, {
          as: "input",
          readOnly,
          id: zipId,
          inputMode: "text",
          name: `${name}.zip`,
          autoComplete,
          onChange: (e) => {
            helpers.setValue({
              street1,
              street2,
              city,
              state,
              zip: e.target.value
            });
          },
          value: zip,
          size: 6,
          hasError: !!(metaError == null ? void 0 : metaError.zip),
          "aria-describedby": (metaError == null ? void 0 : metaError.zip) ? zipErrorId : void 0
        }), jsx(InputError, {
          id: zipErrorId,
          errorMessage: metaError == null ? void 0 : metaError.zip
        })]
      })]
    })]
  }));
};
const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
const buildYearsRange = (maxYearLimit) => range(new Date().getFullYear() + maxYearLimit, 1900);
const DatePickerHeader = ({
  date,
  changeYear,
  changeMonth,
  decreaseMonth,
  increaseMonth,
  maxYearLimit = 0
}) => {
  const monthsOptions = useMemo(() => months.map((month) => jsx("option", {
    value: month,
    children: month
  }, month)), []);
  const yearsOptions = useMemo(() => buildYearsRange(maxYearLimit).map((year) => jsx("option", {
    value: year,
    children: year
  }, year)), []);
  return jsxs("div", {
    style: {
      margin: 5,
      display: "flex",
      justifyContent: "center"
    },
    children: [jsx("button", {
      type: "button",
      style: {
        background: "transparent",
        border: "none",
        padding: "0"
      },
      onClick: (event) => {
        event.preventDefault();
        decreaseMonth();
      },
      children: jsx(Icon, {
        variant: "angle-left"
      })
    }), jsxs("div", {
      style: {
        display: "flex",
        alignItems: "center"
      },
      children: [jsx("div", {
        style: {
          flexGrow: 2
        },
        children: jsx("select", {
          value: format(new Date(date), "MMMM"),
          onChange: ({
            target: {
              value
            }
          }) => changeMonth(months.indexOf(value)),
          style: {
            borderRadius: "4px"
          },
          children: monthsOptions
        })
      }), jsx("div", {
        style: {
          flexGrow: 2
        },
        children: jsx("select", {
          value: new Date(date).getFullYear(),
          onChange: ({
            target: {
              value
            }
          }) => {
            changeYear(+value);
          },
          style: {
            padding: "0 0.3rem",
            marginLeft: "4px",
            borderRadius: "4px"
          },
          children: yearsOptions
        })
      })]
    }), jsx("button", {
      type: "button",
      style: {
        background: "transparent",
        border: "none",
        padding: "0"
      },
      onClick: (e) => {
        e.preventDefault();
        increaseMonth();
      },
      children: jsx(Icon, {
        variant: "angle-right"
      })
    })]
  });
};
const datePickerStyles = css`
  .react-datepicker__year-read-view--down-arrow,
  .react-datepicker__month-read-view--down-arrow,
  .react-datepicker__month-year-read-view--down-arrow,
  .react-datepicker__navigation-icon::before {
    border-color: #ccc;
    border-style: solid;
    border-width: 3px 3px 0 0;
    content: '';
    display: block;
    height: 9px;
    position: absolute;
    top: 6px;
    width: 9px;
  }
  .react-datepicker-popper[data-placement^='top'] .react-datepicker__triangle,
  .react-datepicker-popper[data-placement^='bottom']
    .react-datepicker__triangle {
    margin-left: -4px;
    position: absolute;
    width: 0;
  }
  .react-datepicker-popper[data-placement^='top']
    .react-datepicker__triangle::before,
  .react-datepicker-popper[data-placement^='bottom']
    .react-datepicker__triangle::before,
  .react-datepicker-popper[data-placement^='top']
    .react-datepicker__triangle::after,
  .react-datepicker-popper[data-placement^='bottom']
    .react-datepicker__triangle::after {
    box-sizing: content-box;
    position: absolute;
    border: 8px solid transparent;
    height: 0;
    width: 1px;
    content: '';
    z-index: -1;
    border-width: 8px;
    left: -8px;
  }
  .react-datepicker-popper[data-placement^='top']
    .react-datepicker__triangle::before,
  .react-datepicker-popper[data-placement^='bottom']
    .react-datepicker__triangle::before {
    border-bottom-color: #aeaeae;
  }

  .react-datepicker-popper[data-placement^='bottom']
    .react-datepicker__triangle {
    top: 0;
    margin-top: -8px;
  }
  .react-datepicker-popper[data-placement^='bottom']
    .react-datepicker__triangle::before,
  .react-datepicker-popper[data-placement^='bottom']
    .react-datepicker__triangle::after {
    border-top: none;
    border-bottom-color: #f0f0f0;
  }
  .react-datepicker-popper[data-placement^='bottom']
    .react-datepicker__triangle::after {
    top: 0;
  }
  .react-datepicker-popper[data-placement^='bottom']
    .react-datepicker__triangle::before {
    top: -1px;
    border-bottom-color: #aeaeae;
  }

  .react-datepicker-popper[data-placement^='top'] .react-datepicker__triangle {
    bottom: 0;
    margin-bottom: -8px;
  }
  .react-datepicker-popper[data-placement^='top']
    .react-datepicker__triangle::before,
  .react-datepicker-popper[data-placement^='top']
    .react-datepicker__triangle::after {
    border-bottom: none;
    border-top-color: #fff;
  }
  .react-datepicker-popper[data-placement^='top']
    .react-datepicker__triangle::after {
    bottom: 0;
  }
  .react-datepicker-popper[data-placement^='top']
    .react-datepicker__triangle::before {
    bottom: -1px;
    border-top-color: #aeaeae;
  }

  .react-datepicker-wrapper {
    display: inline-block;
    padding: 0;
    border: 0;
    width: 100%;
  }

  .react-datepicker {
    font-family: 'Helvetica Neue', helvetica, arial, sans-serif;
    font-size: 0.8rem;
    background-color: #fff;
    color: #000;
    border: 1px solid #aeaeae;
    border-radius: 0.3rem;
    display: inline-block;
    position: relative;
  }

  .react-datepicker--time-only .react-datepicker__triangle {
    left: 35px;
  }
  .react-datepicker--time-only .react-datepicker__time-container {
    border-left: 0;
  }
  .react-datepicker--time-only .react-datepicker__time,
  .react-datepicker--time-only .react-datepicker__time-box {
    border-bottom-left-radius: 0.3rem;
    border-bottom-right-radius: 0.3rem;
  }

  .react-datepicker__triangle {
    position: absolute;
    left: 50px;
  }

  .react-datepicker-popper {
    z-index: 1;
  }
  .react-datepicker-popper[data-placement^='bottom'] {
    padding-top: 10px;
  }
  .react-datepicker-popper[data-placement='bottom-end']
    .react-datepicker__triangle,
  .react-datepicker-popper[data-placement='top-end']
    .react-datepicker__triangle {
    left: auto;
    right: 50px;
  }
  .react-datepicker-popper[data-placement^='top'] {
    padding-bottom: 10px;
  }
  .react-datepicker-popper[data-placement^='right'] {
    padding-left: 8px;
  }
  .react-datepicker-popper[data-placement^='right']
    .react-datepicker__triangle {
    left: auto;
    right: 42px;
  }
  .react-datepicker-popper[data-placement^='left'] {
    padding-right: 8px;
  }
  .react-datepicker-popper[data-placement^='left'] .react-datepicker__triangle {
    left: 42px;
    right: auto;
  }

  .react-datepicker__header {
    text-align: center;
    background-color: #f0f0f0;
    border-bottom: 1px solid #aeaeae;
    border-top-left-radius: 0.3rem;
    padding: 8px 0;
    position: relative;
  }
  .react-datepicker__header--time {
    padding-bottom: 8px;
    padding-left: 5px;
    padding-right: 5px;
  }
  .react-datepicker__header--time:not(.react-datepicker__header--time--only) {
    border-top-left-radius: 0;
  }
  .react-datepicker__header:not(.react-datepicker__header--has-time-select) {
    border-top-right-radius: 0.3rem;
  }

  .react-datepicker__year-dropdown-container--select,
  .react-datepicker__month-dropdown-container--select,
  .react-datepicker__month-year-dropdown-container--select,
  .react-datepicker__year-dropdown-container--scroll,
  .react-datepicker__month-dropdown-container--scroll,
  .react-datepicker__month-year-dropdown-container--scroll {
    display: inline-block;
    margin: 0 2px;
  }

  .react-datepicker__current-month,
  .react-datepicker-time__header,
  .react-datepicker-year-header {
    margin-top: 0;
    color: #000;
    font-weight: bold;
    font-size: 0.944rem;
  }

  .react-datepicker-time__header {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }

  .react-datepicker__navigation {
    align-items: center;
    background: none;
    display: flex;
    justify-content: center;
    text-align: center;
    cursor: pointer;
    position: absolute;
    top: 2px;
    padding: 0;
    border: none;
    z-index: 1;
    height: 32px;
    width: 32px;
    text-indent: -999em;
    overflow: hidden;
  }
  .react-datepicker__navigation--previous {
    left: 2px;
  }
  .react-datepicker__navigation--next {
    right: 2px;
  }
  .react-datepicker__navigation--next--with-time:not(.react-datepicker__navigation--next--with-today-button) {
    right: 85px;
  }
  .react-datepicker__navigation--years {
    position: relative;
    top: 0;
    display: block;
    margin-left: auto;
    margin-right: auto;
  }
  .react-datepicker__navigation--years-previous {
    top: 4px;
  }
  .react-datepicker__navigation--years-upcoming {
    top: -4px;
  }
  .react-datepicker__navigation:hover *::before {
    border-color: #a6a6a6;
  }

  .react-datepicker__navigation-icon {
    position: relative;
    top: -1px;
    font-size: 20px;
    width: 0;
  }
  .react-datepicker__navigation-icon--next {
    left: -2px;
  }
  .react-datepicker__navigation-icon--next::before {
    transform: rotate(45deg);
    left: -7px;
  }
  .react-datepicker__navigation-icon--previous {
    right: -2px;
  }
  .react-datepicker__navigation-icon--previous::before {
    transform: rotate(225deg);
    right: -7px;
  }

  .react-datepicker__month-container {
    float: left;
  }

  .react-datepicker__year {
    margin: 0.4rem;
    text-align: center;
  }
  .react-datepicker__year-wrapper {
    display: flex;
    flex-wrap: wrap;
    max-width: 180px;
  }
  .react-datepicker__year .react-datepicker__year-text {
    display: inline-block;
    width: 4rem;
    margin: 2px;
  }

  .react-datepicker__month {
    margin: 0.4rem;
    text-align: center;
  }
  .react-datepicker__month .react-datepicker__month-text,
  .react-datepicker__month .react-datepicker__quarter-text {
    display: inline-block;
    width: 4rem;
    margin: 2px;
  }

  .react-datepicker__input-time-container {
    clear: both;
    width: 100%;
    float: left;
    margin: 5px 0 10px 15px;
    text-align: left;
  }
  .react-datepicker__input-time-container .react-datepicker-time__caption {
    display: inline-block;
  }
  .react-datepicker__input-time-container
    .react-datepicker-time__input-container {
    display: inline-block;
  }
  .react-datepicker__input-time-container
    .react-datepicker-time__input-container
    .react-datepicker-time__input {
    display: inline-block;
    margin-left: 10px;
  }
  .react-datepicker__input-time-container
    .react-datepicker-time__input-container
    .react-datepicker-time__input
    input {
    width: auto;
  }
  .react-datepicker__input-time-container
    .react-datepicker-time__input-container
    .react-datepicker-time__input
    input[type='time']::-webkit-inner-spin-button,
  .react-datepicker__input-time-container
    .react-datepicker-time__input-container
    .react-datepicker-time__input
    input[type='time']::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  .react-datepicker__input-time-container
    .react-datepicker-time__input-container
    .react-datepicker-time__input
    input[type='time'] {
    -moz-appearance: textfield;
  }
  .react-datepicker__input-time-container
    .react-datepicker-time__input-container
    .react-datepicker-time__delimiter {
    margin-left: 5px;
    display: inline-block;
  }

  .react-datepicker__time-container {
    float: right;
    border-left: 1px solid #aeaeae;
    width: 85px;
  }
  .react-datepicker__time-container--with-today-button {
    display: inline;
    border: 1px solid #aeaeae;
    border-radius: 0.3rem;
    position: absolute;
    right: -72px;
    top: 0;
  }
  .react-datepicker__time-container .react-datepicker__time {
    position: relative;
    background: white;
    border-bottom-right-radius: 0.3rem;
  }
  .react-datepicker__time-container
    .react-datepicker__time
    .react-datepicker__time-box {
    width: 85px;
    overflow-x: hidden;
    margin: 0 auto;
    text-align: center;
    border-bottom-right-radius: 0.3rem;
  }
  .react-datepicker__time-container
    .react-datepicker__time
    .react-datepicker__time-box
    ul.react-datepicker__time-list {
    list-style: none;
    margin: 0;
    height: calc(195px + (1.7rem / 2));
    overflow-y: scroll;
    padding-right: 0;
    padding-left: 0;
    width: 100%;
    box-sizing: content-box;
  }
  .react-datepicker__time-container
    .react-datepicker__time
    .react-datepicker__time-box
    ul.react-datepicker__time-list
    li.react-datepicker__time-list-item {
    height: 30px;
    padding: 5px 10px;
    white-space: nowrap;
  }
  .react-datepicker__time-container
    .react-datepicker__time
    .react-datepicker__time-box
    ul.react-datepicker__time-list
    li.react-datepicker__time-list-item:hover {
    cursor: pointer;
    background-color: #f0f0f0;
  }
  .react-datepicker__time-container
    .react-datepicker__time
    .react-datepicker__time-box
    ul.react-datepicker__time-list
    li.react-datepicker__time-list-item--selected {
    background-color: #216ba5;
    color: white;
    font-weight: bold;
  }
  .react-datepicker__time-container
    .react-datepicker__time
    .react-datepicker__time-box
    ul.react-datepicker__time-list
    li.react-datepicker__time-list-item--selected:hover {
    background-color: #216ba5;
  }
  .react-datepicker__time-container
    .react-datepicker__time
    .react-datepicker__time-box
    ul.react-datepicker__time-list
    li.react-datepicker__time-list-item--disabled {
    color: #ccc;
  }
  .react-datepicker__time-container
    .react-datepicker__time
    .react-datepicker__time-box
    ul.react-datepicker__time-list
    li.react-datepicker__time-list-item--disabled:hover {
    cursor: default;
    background-color: transparent;
  }

  .react-datepicker__week-number {
    color: #ccc;
    display: inline-block;
    width: 1.7rem;
    line-height: 1.7rem;
    text-align: center;
    margin: 0.166rem;
  }
  .react-datepicker__week-number.react-datepicker__week-number--clickable {
    cursor: pointer;
  }
  .react-datepicker__week-number.react-datepicker__week-number--clickable:hover {
    border-radius: 0.3rem;
    background-color: #f0f0f0;
  }

  .react-datepicker__day-names,
  .react-datepicker__week {
    white-space: nowrap;
  }

  .react-datepicker__day-names {
    margin-bottom: -8px;
  }

  .react-datepicker__day-name,
  .react-datepicker__day,
  .react-datepicker__time-name {
    color: #000;
    display: inline-block;
    width: 1.7rem;
    line-height: 1.7rem;
    text-align: center;
    margin: 0.166rem;
  }

  .react-datepicker__month--selected,
  .react-datepicker__month--in-selecting-range,
  .react-datepicker__month--in-range,
  .react-datepicker__quarter--selected,
  .react-datepicker__quarter--in-selecting-range,
  .react-datepicker__quarter--in-range {
    border-radius: 0.3rem;
    background-color: #216ba5;
    color: #fff;
  }
  .react-datepicker__month--selected:hover,
  .react-datepicker__month--in-selecting-range:hover,
  .react-datepicker__month--in-range:hover,
  .react-datepicker__quarter--selected:hover,
  .react-datepicker__quarter--in-selecting-range:hover,
  .react-datepicker__quarter--in-range:hover {
    background-color: #1d5d90;
  }
  .react-datepicker__month--disabled,
  .react-datepicker__quarter--disabled {
    color: #ccc;
    pointer-events: none;
  }
  .react-datepicker__month--disabled:hover,
  .react-datepicker__quarter--disabled:hover {
    cursor: default;
    background-color: transparent;
  }

  .react-datepicker__day,
  .react-datepicker__month-text,
  .react-datepicker__quarter-text,
  .react-datepicker__year-text {
    cursor: pointer;
  }
  .react-datepicker__day:hover,
  .react-datepicker__month-text:hover,
  .react-datepicker__quarter-text:hover,
  .react-datepicker__year-text:hover {
    border-radius: 0.3rem;
    background-color: #f0f0f0;
  }
  .react-datepicker__day--today,
  .react-datepicker__month-text--today,
  .react-datepicker__quarter-text--today,
  .react-datepicker__year-text--today {
    font-weight: bold;
  }
  .react-datepicker__day--highlighted,
  .react-datepicker__month-text--highlighted,
  .react-datepicker__quarter-text--highlighted,
  .react-datepicker__year-text--highlighted {
    border-radius: 0.3rem;
    background-color: #3dcc4a;
    color: #fff;
  }
  .react-datepicker__day--highlighted:hover,
  .react-datepicker__month-text--highlighted:hover,
  .react-datepicker__quarter-text--highlighted:hover,
  .react-datepicker__year-text--highlighted:hover {
    background-color: #32be3f;
  }
  .react-datepicker__day--highlighted-custom-1,
  .react-datepicker__month-text--highlighted-custom-1,
  .react-datepicker__quarter-text--highlighted-custom-1,
  .react-datepicker__year-text--highlighted-custom-1 {
    color: magenta;
  }
  .react-datepicker__day--highlighted-custom-2,
  .react-datepicker__month-text--highlighted-custom-2,
  .react-datepicker__quarter-text--highlighted-custom-2,
  .react-datepicker__year-text--highlighted-custom-2 {
    color: green;
  }
  .react-datepicker__day--selected,
  .react-datepicker__day--in-selecting-range,
  .react-datepicker__day--in-range,
  .react-datepicker__month-text--selected,
  .react-datepicker__month-text--in-selecting-range,
  .react-datepicker__month-text--in-range,
  .react-datepicker__quarter-text--selected,
  .react-datepicker__quarter-text--in-selecting-range,
  .react-datepicker__quarter-text--in-range,
  .react-datepicker__year-text--selected,
  .react-datepicker__year-text--in-selecting-range,
  .react-datepicker__year-text--in-range {
    border-radius: 0.3rem;
    background-color: #216ba5;
    color: #fff;
  }
  .react-datepicker__day--selected:hover,
  .react-datepicker__day--in-selecting-range:hover,
  .react-datepicker__day--in-range:hover,
  .react-datepicker__month-text--selected:hover,
  .react-datepicker__month-text--in-selecting-range:hover,
  .react-datepicker__month-text--in-range:hover,
  .react-datepicker__quarter-text--selected:hover,
  .react-datepicker__quarter-text--in-selecting-range:hover,
  .react-datepicker__quarter-text--in-range:hover,
  .react-datepicker__year-text--selected:hover,
  .react-datepicker__year-text--in-selecting-range:hover,
  .react-datepicker__year-text--in-range:hover {
    background-color: #1d5d90;
  }
  .react-datepicker__month-text--keyboard-selected,
  .react-datepicker__quarter-text--keyboard-selected,
  .react-datepicker__year-text--keyboard-selected {
    border-radius: 0.3rem;
    background-color: #2579ba;
    color: #fff;
  }
  .react-datepicker__month-text--keyboard-selected:hover,
  .react-datepicker__quarter-text--keyboard-selected:hover,
  .react-datepicker__year-text--keyboard-selected:hover {
    background-color: #1d5d90;
  }
  .react-datepicker__day--in-selecting-range:not(.react-datepicker__day--in-range, .react-datepicker__month-text--in-range, .react-datepicker__quarter-text--in-range, .react-datepicker__year-text--in-range),
  .react-datepicker__month-text--in-selecting-range:not(.react-datepicker__day--in-range, .react-datepicker__month-text--in-range, .react-datepicker__quarter-text--in-range, .react-datepicker__year-text--in-range),
  .react-datepicker__quarter-text--in-selecting-range:not(.react-datepicker__day--in-range, .react-datepicker__month-text--in-range, .react-datepicker__quarter-text--in-range, .react-datepicker__year-text--in-range),
  .react-datepicker__year-text--in-selecting-range:not(.react-datepicker__day--in-range, .react-datepicker__month-text--in-range, .react-datepicker__quarter-text--in-range, .react-datepicker__year-text--in-range) {
    background-color: rgba(33, 107, 165, 0.5);
  }
  .react-datepicker__month--selecting-range
    .react-datepicker__day--in-range:not(.react-datepicker__day--in-selecting-range, .react-datepicker__month-text--in-selecting-range, .react-datepicker__quarter-text--in-selecting-range, .react-datepicker__year-text--in-selecting-range),
  .react-datepicker__month--selecting-range
    .react-datepicker__month-text--in-range:not(.react-datepicker__day--in-selecting-range, .react-datepicker__month-text--in-selecting-range, .react-datepicker__quarter-text--in-selecting-range, .react-datepicker__year-text--in-selecting-range),
  .react-datepicker__month--selecting-range
    .react-datepicker__quarter-text--in-range:not(.react-datepicker__day--in-selecting-range, .react-datepicker__month-text--in-selecting-range, .react-datepicker__quarter-text--in-selecting-range, .react-datepicker__year-text--in-selecting-range),
  .react-datepicker__month--selecting-range
    .react-datepicker__year-text--in-range:not(.react-datepicker__day--in-selecting-range, .react-datepicker__month-text--in-selecting-range, .react-datepicker__quarter-text--in-selecting-range, .react-datepicker__year-text--in-selecting-range) {
    background-color: #f0f0f0;
    color: #000;
  }
  .react-datepicker__day--disabled,
  .react-datepicker__month-text--disabled,
  .react-datepicker__quarter-text--disabled,
  .react-datepicker__year-text--disabled {
    cursor: default;
    color: #ccc;
  }
  .react-datepicker__day--disabled:hover,
  .react-datepicker__month-text--disabled:hover,
  .react-datepicker__quarter-text--disabled:hover,
  .react-datepicker__year-text--disabled:hover {
    background-color: transparent;
  }

  .react-datepicker__month-text.react-datepicker__month--selected:hover,
  .react-datepicker__month-text.react-datepicker__month--in-range:hover,
  .react-datepicker__month-text.react-datepicker__quarter--selected:hover,
  .react-datepicker__month-text.react-datepicker__quarter--in-range:hover,
  .react-datepicker__quarter-text.react-datepicker__month--selected:hover,
  .react-datepicker__quarter-text.react-datepicker__month--in-range:hover,
  .react-datepicker__quarter-text.react-datepicker__quarter--selected:hover,
  .react-datepicker__quarter-text.react-datepicker__quarter--in-range:hover {
    background-color: #216ba5;
  }
  .react-datepicker__month-text:hover,
  .react-datepicker__quarter-text:hover {
    background-color: #f0f0f0;
  }

  .react-datepicker__input-container {
    position: relative;
    display: inline-block;
    width: 100%;
  }

  .react-datepicker__year-read-view,
  .react-datepicker__month-read-view,
  .react-datepicker__month-year-read-view {
    border: 1px solid transparent;
    border-radius: 0.3rem;
    position: relative;
  }
  .react-datepicker__year-read-view:hover,
  .react-datepicker__month-read-view:hover,
  .react-datepicker__month-year-read-view:hover {
    cursor: pointer;
  }
  .react-datepicker__year-read-view:hover
    .react-datepicker__year-read-view--down-arrow,
  .react-datepicker__year-read-view:hover
    .react-datepicker__month-read-view--down-arrow,
  .react-datepicker__month-read-view:hover
    .react-datepicker__year-read-view--down-arrow,
  .react-datepicker__month-read-view:hover
    .react-datepicker__month-read-view--down-arrow,
  .react-datepicker__month-year-read-view:hover
    .react-datepicker__year-read-view--down-arrow,
  .react-datepicker__month-year-read-view:hover
    .react-datepicker__month-read-view--down-arrow {
    border-top-color: #b3b3b3;
  }
  .react-datepicker__year-read-view--down-arrow,
  .react-datepicker__month-read-view--down-arrow,
  .react-datepicker__month-year-read-view--down-arrow {
    transform: rotate(135deg);
    right: -16px;
    top: 0;
  }

  .react-datepicker__year-dropdown,
  .react-datepicker__month-dropdown,
  .react-datepicker__month-year-dropdown {
    background-color: #f0f0f0;
    position: absolute;
    width: 50%;
    left: 25%;
    top: 30px;
    z-index: 1;
    text-align: center;
    border-radius: 0.3rem;
    border: 1px solid #aeaeae;
  }
  .react-datepicker__year-dropdown:hover,
  .react-datepicker__month-dropdown:hover,
  .react-datepicker__month-year-dropdown:hover {
    cursor: pointer;
  }
  .react-datepicker__year-dropdown--scrollable,
  .react-datepicker__month-dropdown--scrollable,
  .react-datepicker__month-year-dropdown--scrollable {
    height: 150px;
    overflow-y: scroll;
  }

  .react-datepicker__year-option,
  .react-datepicker__month-option,
  .react-datepicker__month-year-option {
    line-height: 20px;
    width: 100%;
    display: block;
    margin-left: auto;
    margin-right: auto;
  }
  .react-datepicker__year-option:first-of-type,
  .react-datepicker__month-option:first-of-type,
  .react-datepicker__month-year-option:first-of-type {
    border-top-left-radius: 0.3rem;
    border-top-right-radius: 0.3rem;
  }
  .react-datepicker__year-option:last-of-type,
  .react-datepicker__month-option:last-of-type,
  .react-datepicker__month-year-option:last-of-type {
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    border-bottom-left-radius: 0.3rem;
    border-bottom-right-radius: 0.3rem;
  }
  .react-datepicker__year-option:hover,
  .react-datepicker__month-option:hover,
  .react-datepicker__month-year-option:hover {
    background-color: #ccc;
  }
  .react-datepicker__year-option:hover
    .react-datepicker__navigation--years-upcoming,
  .react-datepicker__month-option:hover
    .react-datepicker__navigation--years-upcoming,
  .react-datepicker__month-year-option:hover
    .react-datepicker__navigation--years-upcoming {
    border-bottom-color: #b3b3b3;
  }
  .react-datepicker__year-option:hover
    .react-datepicker__navigation--years-previous,
  .react-datepicker__month-option:hover
    .react-datepicker__navigation--years-previous,
  .react-datepicker__month-year-option:hover
    .react-datepicker__navigation--years-previous {
    border-top-color: #b3b3b3;
  }
  .react-datepicker__year-option--selected,
  .react-datepicker__month-option--selected,
  .react-datepicker__month-year-option--selected {
    position: absolute;
    left: 15px;
  }

  .react-datepicker__close-icon {
    cursor: pointer;
    background-color: transparent;
    border: 0;
    outline: 0;
    padding: 0 6px 0 0;
    position: absolute;
    top: 0;
    right: 0;
    height: 100%;
    display: table-cell;
    vertical-align: middle;
  }
  .react-datepicker__close-icon::after {
    cursor: pointer;
    background-color: #216ba5;
    color: #fff;
    border-radius: 50%;
    height: 16px;
    width: 16px;
    padding: 2px;
    font-size: 12px;
    line-height: 1;
    text-align: center;
    display: table-cell;
    vertical-align: middle;
    content: '×';
  }

  .react-datepicker__today-button {
    background: #f0f0f0;
    border-top: 1px solid #aeaeae;
    cursor: pointer;
    text-align: center;
    font-weight: bold;
    padding: 5px 0;
    clear: left;
  }

  .react-datepicker__portal {
    position: fixed;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.8);
    left: 0;
    top: 0;
    justify-content: center;
    align-items: center;
    display: flex;
    z-index: 2147483647;
  }
  .react-datepicker__portal .react-datepicker__day-name,
  .react-datepicker__portal .react-datepicker__day,
  .react-datepicker__portal .react-datepicker__time-name {
    width: 3rem;
    line-height: 3rem;
  }
  @media (max-width: 400px), (max-height: 550px) {
    .react-datepicker__portal .react-datepicker__day-name,
    .react-datepicker__portal .react-datepicker__day,
    .react-datepicker__portal .react-datepicker__time-name {
      width: 2rem;
      line-height: 2rem;
    }
  }
  .react-datepicker__portal .react-datepicker__current-month,
  .react-datepicker__portal .react-datepicker-time__header {
    font-size: 1.44rem;
  }
`;
const substractTimezone = (date) => new Date(date.valueOf() + date.getTimezoneOffset() * 60 * 1e3);
const substractYears = (numOfYears, date = new Date()) => {
  if (!numOfYears || numOfYears > 0)
    return null;
  date.setFullYear(date.getFullYear() + numOfYears);
  return date;
};
const validateMaxDate = (numOfYears, date) => {
  if (!date)
    return null;
  if (date.getFullYear() > new Date().getFullYear() + numOfYears) {
    date.setFullYear(new Date().getFullYear() + numOfYears);
  }
  return substractTimezone(date);
};
const DatePicker = ({
  autoComplete,
  description,
  label,
  maxYearLimit = 0,
  name,
  readOnly = false,
  showTodayButton,
  tooltip
}) => {
  const [field, meta, helpers] = useField(name);
  const [isCalendarOpen, setIsCalendarOpen] = useState(false);
  const datePickerRef = useRef(null);
  const {
    prefix
  } = React.useContext(INTERNAL_ONLY_FORM_INFO);
  const hasError = Boolean(meta.error);
  const inputId = `${prefix}-${name}`;
  const descriptionId = `${inputId}-description`;
  const errorId = `${inputId}-error`;
  const describedBy = [description ? descriptionId : void 0, hasError ? errorId : void 0].filter(Boolean);
  const options = {
    "aria-describedby": describedBy.length ? describedBy.join(" ") : void 0
  };
  const validDateLength = 10;
  const selectedValue = (field == null ? void 0 : field.value) && field.value.length === validDateLength && isMatch(field.value, "yyyy-MM-dd") ? validateMaxDate(maxYearLimit, new Date(field.value)) : substractYears(maxYearLimit);
  const onChange = (nextValue) => {
    const date = format(nextValue, "yyyy-MM-dd");
    helpers.setValue(date);
    if (isCalendarOpen)
      setIsCalendarOpen(false);
  };
  useOnClickOutside(datePickerRef, () => setIsCalendarOpen(false));
  const onCalendarClick = () => setIsCalendarOpen(!isCalendarOpen);
  return jsxs(InputFieldSet, __spreadProps(__spreadValues({
    hasError
  }, options), {
    sx: {
      display: "flex",
      flexDirection: "column"
    },
    children: [jsxs("legend", {
      children: [label, tooltip && jsx(Tooltip$1, {
        children: tooltip
      })]
    }), description && jsx("div", {
      sx: {
        variant: "inputContainer.description"
      },
      id: descriptionId,
      children: description
    }), jsxs("div", {
      ref: datePickerRef,
      sx: {
        alignItems: "end",
        display: "flex",
        flexFlow: "row nowrap",
        "& label": {
          fontSize: 1
        },
        mt: 1,
        ".react-datepicker-wrapper": {
          width: "auto"
        },
        ".react-datepicker__day--selected": {
          bg: "primary.l1"
        }
      },
      children: [jsx(Global, {
        styles: datePickerStyles
      }), jsx(ReactDatePicker, {
        id: name,
        name,
        selected: selectedValue,
        onChange,
        onChangeRaw: (e) => e.preventDefault(),
        open: isCalendarOpen,
        todayButton: showTodayButton && maxYearLimit >= 0 && "Today",
        renderCustomHeader: ({
          date,
          changeYear,
          changeMonth,
          decreaseMonth,
          increaseMonth
        }) => jsx(DatePickerHeader, {
          date,
          changeYear,
          changeMonth,
          decreaseMonth,
          increaseMonth,
          maxYearLimit
        }),
        customInput: jsx("div", {
          style: {
            display: "flex"
          },
          children: jsx(DateInputContainers, {
            name,
            helpers,
            field,
            inputId,
            autoComplete,
            readOnly
          })
        })
      }), jsx(Button, {
        variant: "secondary",
        sx: {
          bg: "transparent",
          border: "none",
          padding: "0"
        },
        onClick: onCalendarClick,
        disabled: readOnly,
        children: jsx(Icon, {
          variant: "calendar",
          color: "primary.l1"
        })
      })]
    }), jsx(InputError, {
      id: errorId,
      errorMessage: meta.error
    })]
  }));
};
const SingleSelect = ({
  width = "100%",
  name,
  label,
  description,
  items: inputItems,
  placeholder = "Select",
  allowSearch = false,
  readOnly = false,
  sx = {},
  tooltip
}) => {
  const items = inputItems.concat([{
    name: "Other",
    value: "other"
  }]);
  const [field, meta, helpers] = useField(name);
  const downshiftRef = React.useRef();
  const {
    value
  } = field;
  const selectValueItem = React.useMemo(() => {
    if (!field.value)
      return void 0;
    const foundItem = items.find((item) => item.value === field.value.toString());
    if (!foundItem)
      return {
        name: "Other",
        value: "other"
      };
    return foundItem;
  }, [field.value, items]);
  const [useOther, setOther] = React.useState((selectValueItem == null ? void 0 : selectValueItem.value) === "other");
  React.useEffect(() => {
    var _a;
    if (!allowSearch)
      (_a = downshiftRef.current) == null ? void 0 : _a._rootNode.removeAttribute("role");
  }, [downshiftRef, allowSearch]);
  const {
    prefix
  } = React.useContext(INTERNAL_ONLY_FORM_INFO);
  const inputId = `${prefix}-${name}`;
  const labelId = `${inputId}-label`;
  const descriptionId = `${inputId}-description`;
  const errorId = `${inputId}-error`;
  const hasError = Boolean(meta.error);
  const describedBy = [hasError && !useOther ? errorId : void 0, description ? descriptionId : void 0].filter(Boolean);
  const describedByOther = [hasError && useOther ? errorId : void 0];
  const options = {
    "aria-describedby": describedBy.length ? describedBy.join(" ") : void 0
  };
  const otherOptions = {
    "aria-describedby": describedByOther.length ? describedByOther.join(" ") : void 0
  };
  const getItems = (filter) => filter ? matchSorter(items, filter, {
    keys: ["name"]
  }) : items;
  return jsxs(Grid, {
    gap: [0, 2],
    columns: [1, "minmax(0, 416px) minmax(0, 416px)"],
    children: [jsx(InputBox, {
      hasError: hasError && !useOther,
      sx,
      children: jsx(Downshift, {
        ref: downshiftRef,
        itemToString: (item) => {
          var _a, _b;
          return (item == null ? void 0 : item.item) ? (_b = (_a = item == null ? void 0 : item.item) == null ? void 0 : _a.props) == null ? void 0 : _b.children : item == null ? void 0 : item.name;
        },
        selectedItem: useOther ? {
          value: "other",
          name: "Other"
        } : selectValueItem || null,
        onSelect: (selectedItem) => {
          if ((selectedItem == null ? void 0 : selectedItem.value) === "other") {
            setOther(true);
            helpers.setValue("");
          } else {
            setOther(false);
            helpers.setValue(selectedItem == null ? void 0 : selectedItem.value);
          }
        },
        labelId,
        inputId,
        items,
        children: ({
          isOpen,
          selectedItem,
          getInputProps,
          getToggleButtonProps,
          getLabelProps,
          getMenuProps,
          inputValue,
          highlightedIndex,
          getItemProps
        }) => {
          const list = allowSearch ? getItems(inputValue) : items;
          const filterList = list.map((item, index) => jsx(Box, __spreadProps(__spreadValues({
            className: [highlightedIndex === index ? "active" : "", (selectedItem == null ? void 0 : selectedItem.value) === item.value ? "selected" : ""].join(" "),
            as: "li",
            role: "option",
            variant: "inputContainer.listItem"
          }, getItemProps({
            item,
            index
          })), {
            children: item.name || item.item
          }), item.value.replace(/ /g, "")));
          return jsxs("div", {
            children: [jsx("label", __spreadProps(__spreadValues({
              id: labelId,
              htmlFor: inputId
            }, getLabelProps({
              htmlFor: inputId,
              id: labelId
            })), {
              children: label
            })), tooltip && jsx(Tooltip$1, {
              children: tooltip
            }), description && jsx(Box, {
              variant: "inputContainer.description",
              id: descriptionId,
              children: description
            }), jsxs(Box, __spreadProps(__spreadValues(__spreadProps(__spreadValues({
              className: hasError && !useOther ? "input-has-error" : "",
              as: "button",
              "aria-labelledby": labelId,
              type: "button"
            }, options), {
              disabled: readOnly,
              variant: "inputContainer.select",
              sx: {
                width
              }
            }), getToggleButtonProps({
              id: inputId
            })), {
              children: [jsx("div", {
                children: (selectedItem == null ? void 0 : selectedItem.name) || (selectedItem == null ? void 0 : selectedItem.item) || placeholder
              }), jsx(Icon, {
                variant: "color-triangle",
                sx: {
                  transform: isOpen ? "rotate(180deg)" : void 0
                }
              })]
            })), jsx("div", {
              sx: {
                position: "relative"
              },
              children: jsx(Box, __spreadProps(__spreadValues({
                as: "ul",
                variant: "inputContainer.dropzone",
                role: "listbox"
              }, getMenuProps(options)), {
                sx: !isOpen ? {
                  border: "none",
                  m: 0,
                  boxShadow: 0,
                  p: 0
                } : {
                  width,
                  zIndex: 99999
                },
                children: jsxs("div", {
                  sx: !isOpen ? hiddenVisually : {},
                  children: [allowSearch && jsx(SelectSearch, __spreadValues({}, getInputProps())), filterList.length ? filterList : jsx("div", {
                    sx: {
                      px: 2
                    },
                    children: "No items found"
                  })]
                })
              }))
            }), !useOther && jsx(InputError, {
              id: errorId,
              errorMessage: meta.error
            })]
          });
        }
      })
    }), useOther && jsxs(InputBox, {
      hasError: hasError && useOther,
      sx,
      children: [jsxs("label", {
        htmlFor: `${inputId}-other`,
        children: [label, " (Other)"]
      }), jsx(InputContainer, __spreadProps(__spreadValues({
        as: "input",
        id: `${inputId}-other`,
        name: `${name}.other`,
        hasError: hasError && useOther,
        onChange: (e) => {
          helpers.setValue(e.target.value);
        }
      }, otherOptions), {
        value: useOther ? value || "" : ""
      })), useOther && jsx(InputError, {
        id: errorId,
        errorMessage: meta.error
      })]
    })]
  });
};
const Tag = React.forwardRef((_K, ref) => {
  var _L = _K, {
    onDismiss,
    children,
    variant = "neutral"
  } = _L, props = __objRest(_L, [
    "onDismiss",
    "children",
    "variant"
  ]);
  return jsxs("div", __spreadProps(__spreadValues({
    sx: {
      variant: `tag.${variant}`
    }
  }, props), {
    ref,
    children: [children, onDismiss && jsx("div", {
      role: "button",
      tabIndex: 0,
      sx: {
        variant: "buttons.ghost",
        padding: 0,
        height: 18,
        minHeight: "auto",
        marginLeft: "2px",
        color: "neutral.base",
        "&:hover": {
          bg: "primary.l2"
        }
      },
      onClick: onDismiss,
      "aria-label": "Remove",
      children: jsx(Icon, {
        variant: "times",
        "aria-hidden": "true",
        role: "presentation",
        size: "sm"
      })
    })]
  }));
});
const MultiSelect = ({
  width = "100%",
  name,
  label,
  description,
  readOnly = false,
  items,
  tooltip
}) => {
  const [inputText, setInputValue] = React.useState("");
  const [field, meta, helpers] = useField(name);
  const selectValueItem = React.useMemo(() => {
    if (!field.value)
      return [];
    return items.filter((item) => field.value.includes(item.value));
  }, [field.value, items]);
  const {
    prefix
  } = React.useContext(INTERNAL_ONLY_FORM_INFO);
  const inputId = `${prefix}-${name}`;
  const labelId = `${inputId}-label`;
  const descriptionId = `${inputId}-description`;
  const errorId = `${inputId}-error`;
  const menuId = `${inputId}-menu`;
  const hasError = Boolean(meta.error);
  const {
    getSelectedItemProps,
    getDropdownProps,
    addSelectedItem,
    removeSelectedItem,
    reset,
    setSelectedItems,
    selectedItems
  } = useMultipleSelection({
    initialSelectedItems: selectValueItem,
    itemToString: (item) => item == null ? void 0 : item.name,
    onSelectedItemsChange: (e) => {
      var _a;
      helpers.setValue(((_a = e.selectedItems) == null ? void 0 : _a.map((x) => x.value)) || []);
    }
  });
  useEffect(() => {
    if (!isequal(selectedItems, selectValueItem))
      setSelectedItems(selectValueItem);
  }, [selectValueItem]);
  const getFilterItems = (filterItems) => {
    const remainingItems = filterItems.filter((item) => !selectedItems.some((x) => x.value === item.value));
    if (!inputText)
      return remainingItems;
    return matchSorter(remainingItems, inputText, {
      keys: ["name"]
    });
  };
  const {
    isOpen,
    getToggleButtonProps,
    getLabelProps,
    getMenuProps,
    highlightedIndex,
    getItemProps
  } = useSelect({
    items: getFilterItems(items),
    menuId,
    labelId,
    stateReducer: (state, {
      changes,
      type
    }) => {
      switch (type) {
        case useSelect.stateChangeTypes.MenuKeyDownEnter:
        case useSelect.stateChangeTypes.MenuKeyDownSpaceButton:
        case useSelect.stateChangeTypes.ItemClick:
          return __spreadProps(__spreadValues({}, changes), {
            isOpen: true,
            highlightedIndex: state.highlightedIndex
          });
        default:
          return changes;
      }
    },
    onStateChange: ({
      type,
      selectedItem
    }) => {
      switch (type) {
        case useSelect.stateChangeTypes.MenuKeyDownEnter:
        case useSelect.stateChangeTypes.MenuKeyDownSpaceButton:
        case useSelect.stateChangeTypes.ItemClick:
          if (selectedItem) {
            addSelectedItem(selectedItem);
          }
          break;
      }
    }
  });
  const describedBy = [hasError ? errorId : void 0, description ? descriptionId : void 0].filter(Boolean);
  const options = {
    "aria-describedby": describedBy.length ? describedBy.join(" ") : void 0
  };
  const tagList = selectedItems.map((selectedItem, index) => jsx(Tag, __spreadProps(__spreadValues({
    onDismiss: () => removeSelectedItem(selectedItem),
    sx: {
      m: "2px"
    },
    variant: "primary"
  }, getSelectedItemProps({
    selectedItem,
    index
  })), {
    children: selectedItem.name
  }), selectedItem.value.replace(/ /g, "")));
  const filteredList = getFilterItems(items).map((item, index) => jsx(Box, __spreadProps(__spreadValues({
    className: highlightedIndex === index ? "active" : void 0,
    as: "li",
    role: "option",
    variant: "inputContainer.listItem"
  }, getItemProps({
    item,
    index
  })), {
    children: item.name
  }), item.value.replace(/ /g, "")));
  return jsxs(InputBox, {
    hasError,
    children: [jsx("label", __spreadProps(__spreadValues({
      htmlFor: inputId
    }, getLabelProps({
      htmlFor: inputId
    })), {
      children: label
    })), tooltip && jsx(Tooltip$1, {
      children: tooltip
    }), description && jsx(Box, {
      variant: "inputContainer.description",
      id: descriptionId,
      children: description
    }), jsx(InputError, {
      id: errorId,
      errorMessage: meta.error
    }), jsxs(Box, __spreadProps(__spreadValues({
      className: hasError ? "input-has-error" : "",
      as: "button",
      type: "button",
      disabled: readOnly,
      variant: "inputContainer.select",
      sx: {
        width
      }
    }, getToggleButtonProps(getDropdownProps({
      preventKeyAction: isOpen,
      id: inputId
    }))), {
      children: [jsx("div", {
        sx: {
          ml: -1,
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-start",
          flexFlow: "row wrap"
        },
        children: selectedItems.length ? tagList : jsx("div", {
          sx: {
            p: "2px"
          },
          children: "Select"
        })
      }), jsx(Icon, {
        variant: "color-triangle",
        color: "primary.base",
        sx: {
          transform: isOpen ? "rotate(180deg)" : void 0,
          width: "40px"
        }
      })]
    })), jsx("div", {
      sx: {
        position: "relative"
      },
      children: jsx(Box, __spreadProps(__spreadValues({
        as: "ul",
        variant: "inputContainer.dropzone",
        role: "listbox"
      }, getMenuProps(options)), {
        sx: !isOpen ? {
          border: "none",
          m: 0,
          boxShadow: 0,
          p: 0
        } : {
          zIndex: 99999
        },
        children: jsxs("div", {
          sx: !isOpen ? hiddenVisually : {},
          children: [jsx(SelectSearch, {
            onChange: ({
              target
            }) => setInputValue(target.value),
            value: inputText,
            "aria-controls": menuId,
            "aria-readonly": "false",
            "aria-autocomplete": "list",
            "aria-labelledby": labelId
          }), jsxs(Box, {
            children: [selectedItems.length !== items.length && jsx(ButtonLink, {
              onClick: () => setSelectedItems(items),
              sx: {
                mr: 2,
                borderRight: "1px solid",
                borderRightColor: selectedItems.length ? "neutral.base" : "transparent",
                pr: 2,
                minHeight: "auto",
                borderRadius: 0,
                py: 0,
                my: 2
              },
              children: "Select All"
            }), Boolean(selectedItems.length) && jsx(ButtonLink, {
              onClick: reset,
              children: "Clear"
            })]
          }), filteredList.length ? filteredList : jsx("div", {
            sx: {
              px: 2
            },
            children: "No items found"
          })]
        })
      }))
    })]
  });
};
const SELECT_HORIZONTAL_PADDING = 8;
const SELECT_ARROW_WIDTH = 40;
const TAG_HORIZONTAL_PADDING = 8;
const TAG_CROSS_WIDTH = 20;
const TAG_INSIDE_GAP = 2;
const TAG_GAP = 4;
const TAG_MAX_TEXT_WIDTH = 150;
const CHAR_WIDTH = 7;
const Tags = ({
  selectedItems,
  selectRef,
  name,
  removeSelectedItem
}) => {
  const [tagListItems, setTagListItems] = React.useState([]);
  const fitableItemsList = React.useRef([]);
  const tags = useMemo(() => tagListItems.length ? tagListItems : selectedItems, [tagListItems, selectedItems]);
  const removeItem = (e, tag) => {
    e.stopPropagation();
    removeSelectedItem(tag);
  };
  const customTag = (count) => ({
    name: `+${count} more ${name}`,
    value: "more"
  });
  useEffect(() => {
    var _a;
    const selectButtonWidth = ((_a = selectRef.current) == null ? void 0 : _a.getBoundingClientRect().width) || 300;
    const selectButtonReservedSpace = SELECT_HORIZONTAL_PADDING * 2 + SELECT_ARROW_WIDTH;
    const tagReservedWidth = TAG_HORIZONTAL_PADDING * 2 + TAG_CROSS_WIDTH + TAG_INSIDE_GAP + TAG_GAP;
    const contentWidth = selectButtonWidth - selectButtonReservedSpace;
    let leftSpace = contentWidth;
    let currentRow = 1;
    let isCrossed = false;
    let tagsAmountRemoved = 2;
    const fitableList = selectedItems.reduce((acc, selectedItem) => {
      let selectedItemTextWidth = selectedItem.name.length * CHAR_WIDTH;
      if (selectedItemTextWidth > TAG_MAX_TEXT_WIDTH) {
        selectedItemTextWidth = TAG_MAX_TEXT_WIDTH;
      }
      const tagWidth = tagReservedWidth + selectedItemTextWidth;
      if (leftSpace - tagWidth < 0) {
        currentRow += 1;
        leftSpace = contentWidth;
      }
      leftSpace -= tagWidth;
      if (currentRow <= 2) {
        acc.push(selectedItem);
      } else if (isCrossed) {
        tagsAmountRemoved += 1;
        acc.pop();
        acc.push(customTag(tagsAmountRemoved));
      } else {
        acc.pop();
        acc.push(customTag(tagsAmountRemoved));
        isCrossed = true;
      }
      return acc;
    }, []);
    setTagListItems(fitableList);
  }, [selectedItems, fitableItemsList, name, selectRef]);
  if (!tags.length) {
    return jsx("span", {
      sx: {
        color: "neutral.l1"
      },
      children: "Select"
    });
  }
  return jsx(Fragment, {
    children: tags.map((tag) => jsx(Tag, {
      onDismiss: tag.value === "more" ? void 0 : (e) => removeItem(e, tag),
      variant: "primary",
      children: tag.name
    }, tag.value))
  });
};
var Tags$1 = React.memo(Tags);
const InputCheckbox$1 = (_M) => {
  var _N = _M, {
    isChecked
  } = _N, rest = __objRest(_N, [
    "isChecked"
  ]);
  const {
    theme
  } = useThemeUI();
  const svgProps = __spreadValues({
    "aria-hidden": true,
    focusable: true,
    sx: {
      pointerEvents: "none"
    },
    height: theme.isAccessibleMode ? 24 : 16,
    width: theme.isAccessibleMode ? 24 : 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, rest);
  const fill = "primary.base";
  if (isChecked) {
    return jsx("svg", __spreadProps(__spreadValues({}, svgProps), {
      children: jsx("g", {
        sx: {
          fill
        },
        children: jsx("path", {
          d: "M14,0H2A2,2,0,0,0,0,2V14a2,2,0,0,0,2,2H14a2,2,0,0,0,2-2V2A2,2,0,0,0,14,0Zm-.293,5.207-7,7a1,1,0,0,1-1.414,0l-3-3A1,1,0,1,1,3.707,7.793L6,10.086l6.293-6.293a1,1,0,1,1,1.414,1.414Z"
        })
      })
    }));
  }
  return jsx("svg", __spreadProps(__spreadValues({}, svgProps), {
    children: jsx("g", {
      sx: {
        fill
      },
      children: jsx("path", {
        d: "M14,16H2a2,2,0,0,1-2-2V2A2,2,0,0,1,2,0H14a2,2,0,0,1,2,2V14A2,2,0,0,1,14,16ZM2,2V14H14V2Z"
      })
    })
  }));
};
const Checkbox = (_O) => {
  var _P = _O, {
    checked
  } = _P, props = __objRest(_P, [
    "checked"
  ]);
  return jsxs("div", {
    children: [jsx("input", __spreadProps(__spreadValues({
      type: "checkbox"
    }, props), {
      sx: __spreadProps(__spreadValues({}, hiddenVisually), {
        "&:focus + svg": {
          outline: ".25rem solid",
          outlineColor: "effects.outline"
        }
      })
    })), jsx(InputCheckbox$1, {
      className: "inputImage",
      isChecked: checked,
      sx: {
        mt: "3px",
        ml: "1px"
      }
    })]
  });
};
const MenuItem = ({
  item,
  getItemProps,
  index,
  isSelected: isSelected2,
  isHighlighted
}) => jsxs("li", __spreadProps(__spreadValues({
  role: "option",
  "aria-selected": isSelected2,
  className: classNames({
    active: isHighlighted,
    selected: isSelected2
  }),
  sx: {
    variant: "inputContainer.listItem"
  }
}, getItemProps({
  item,
  index
})), {
  children: [jsx(Checkbox, {
    checked: isSelected2
  }), jsx("span", {
    sx: {
      marginLeft: "8px"
    },
    children: item.name
  })]
}));
const isSelected = (selected, selectedItems) => {
  if (!selected || !selectedItems) {
    return false;
  }
  return selectedItems.some((i) => i.value === selected.value);
};
const Menu$1 = ({
  items,
  selectedItems,
  isOpen,
  menuOptions,
  getMenuProps,
  getItemProps,
  highlightedIndex,
  setSelectedItems,
  reset,
  menuId,
  labelId,
  onSearchChange = noop,
  onSearchLoading,
  searchDelay = 750
}) => {
  const [searchValue, setSearchValue] = React.useState("");
  const debouncedChangeHandler = useRef(debounce(onSearchChange, searchDelay)).current;
  const changeHandler = (event) => {
    setSearchValue(event.target.value);
    debouncedChangeHandler(event.target.value);
  };
  const MenuContent = useMemo(() => {
    if (onSearchLoading) {
      return jsxs("div", {
        sx: {
          display: "flex",
          alignItems: "center",
          p: 3
        },
        children: [jsx(Spinner, {
          color: "secondary.base",
          sx: {
            mr: 2
          },
          size: 30
        }), "Searching..."]
      });
    }
    if (isEmpty(items)) {
      return jsx("p", {
        sx: {
          px: 2
        },
        children: "No items found"
      });
    }
    return items.map((item, index) => jsx(MenuItem, {
      getItemProps,
      item,
      index,
      isSelected: isSelected(item, selectedItems),
      isHighlighted: highlightedIndex === index
    }, item.value));
  }, [getItemProps, highlightedIndex, items, onSearchLoading, selectedItems]);
  useEffect(() => () => {
    debouncedChangeHandler.cancel();
  }, [debouncedChangeHandler]);
  return jsx("div", {
    sx: __spreadValues({
      position: "absolute",
      width: "100%",
      marginTop: "4px"
    }, !isOpen && hiddenVisually),
    children: jsxs("ul", __spreadProps(__spreadValues({
      role: "listbox",
      "aria-multiselectable": "true"
    }, getMenuProps(menuOptions)), {
      sx: {
        variant: "inputContainer.dropzone"
      },
      children: [jsx(SelectSearch, {
        onChange: changeHandler,
        value: searchValue,
        "aria-controls": menuId,
        "aria-readonly": "false",
        "aria-autocomplete": "list",
        "aria-labelledby": labelId
      }), jsxs("div", {
        children: [selectedItems.length !== items.length && jsx(ButtonLink, {
          onClick: () => setSelectedItems(items),
          sx: {
            mr: 2,
            borderRight: "1px solid",
            borderRightColor: selectedItems.length ? "neutral.base" : "transparent",
            pr: 2,
            minHeight: "auto",
            borderRadius: 0,
            py: 0,
            my: 2
          },
          children: "Select All"
        }), Boolean(selectedItems.length) && jsx(ButtonLink, {
          onClick: reset,
          sx: {
            minHeight: "auto",
            py: 0
          },
          children: "Clear"
        })]
      }), MenuContent]
    }))
  });
};
var Menu$2 = memo(Menu$1);
const MultiSelectDynamic = ({
  width = "100%",
  name,
  label,
  description,
  readOnly = false,
  items,
  tooltip,
  searchDelay,
  onSearchChange,
  onSearchLoading,
  sxProp
}) => {
  const selectRef = useRef(null);
  const [field, meta, helpers] = useField(name);
  const initialSelectedItems = React.useMemo(() => {
    if (!field.value) {
      return null;
    }
    return field.value.map((item) => ({
      name: item.label || item.name,
      value: item.value
    }));
  }, []);
  const {
    prefix
  } = React.useContext(INTERNAL_ONLY_FORM_INFO);
  const inputId = `${prefix}-${name}`;
  const labelId = `${inputId}-label`;
  const descriptionId = `${inputId}-description`;
  const errorId = `${inputId}-error`;
  const menuId = `${inputId}-menu`;
  const hasError = Boolean(meta.error);
  const {
    getDropdownProps,
    addSelectedItem,
    removeSelectedItem,
    reset,
    setSelectedItems,
    selectedItems
  } = useMultipleSelection({
    initialSelectedItems: initialSelectedItems || [],
    itemToString: (item) => item == null ? void 0 : item.name,
    onSelectedItemsChange: (e) => {
      helpers.setValue(e.selectedItems);
    }
  });
  const {
    isOpen,
    getToggleButtonProps,
    getLabelProps,
    getMenuProps,
    highlightedIndex,
    getItemProps
  } = useSelect({
    items,
    menuId,
    labelId,
    stateReducer: (_, actionAndChanges) => {
      const {
        type,
        changes
      } = actionAndChanges;
      switch (type) {
        case useSelect.stateChangeTypes.MenuKeyDownEnter:
        case useSelect.stateChangeTypes.MenuKeyDownSpaceButton:
        case useSelect.stateChangeTypes.ItemClick:
          if (changes.selectedItem) {
            if (isSelected(changes.selectedItem, selectedItems)) {
              const item = selectedItems.find((i) => {
                var _a;
                return i.value === ((_a = changes.selectedItem) == null ? void 0 : _a.value);
              });
              if (item) {
                removeSelectedItem(item);
              }
            } else {
              addSelectedItem(changes.selectedItem);
            }
          }
          return __spreadProps(__spreadValues({}, changes), {
            isOpen: true
          });
        default:
          return changes;
      }
    }
  });
  useEffect(() => {
    if (!field.value) {
      reset();
    }
  }, [field.value, reset]);
  const describedBy = useMemo(() => [hasError ? errorId : void 0, description ? descriptionId : void 0].filter(Boolean), [hasError, errorId, description, descriptionId]);
  const options = useMemo(() => ({
    "aria-describedby": describedBy.length ? describedBy.join(" ") : void 0
  }), [describedBy]);
  return jsxs(InputBox, {
    hasError,
    sx: sxProp,
    children: [jsx("label", __spreadProps(__spreadValues({
      htmlFor: inputId
    }, getLabelProps({
      htmlFor: inputId
    })), {
      children: label
    })), tooltip && jsx(Tooltip$1, {
      children: tooltip
    }), description && jsx("div", {
      sx: {
        variant: "inputContainer.description"
      },
      id: descriptionId,
      children: description
    }), jsx(InputError, {
      id: errorId,
      errorMessage: meta.error
    }), jsxs("button", __spreadProps(__spreadValues({
      ref: selectRef,
      className: hasError ? "input-has-error" : "",
      type: "button",
      disabled: readOnly,
      sx: {
        variant: "inputContainer.select",
        width
      }
    }, getToggleButtonProps(getDropdownProps({
      preventKeyAction: isOpen,
      id: inputId,
      ref: selectRef
    }))), {
      children: [jsx("div", {
        sx: {
          display: "flex",
          flexWrap: "wrap",
          gap: "4px"
        },
        children: jsx(Tags$1, {
          selectedItems,
          selectRef,
          name,
          removeSelectedItem
        })
      }), jsx(Icon, {
        variant: "color-triangle",
        color: "primary.base",
        sx: {
          transform: isOpen ? "rotate(180deg)" : "none",
          width: "40px",
          flexShrink: 0
        }
      })]
    })), jsx(Menu$2, {
      items,
      selectedItems,
      isOpen,
      menuOptions: options,
      getMenuProps,
      getItemProps,
      highlightedIndex,
      setSelectedItems,
      reset,
      menuId,
      labelId,
      searchDelay,
      onSearchChange,
      onSearchLoading
    })]
  });
};
const ConfirmInput = (_Q) => {
  var _R = _Q, {
    name,
    label,
    description
  } = _R, props = __objRest(_R, [
    "name",
    "label",
    "description"
  ]);
  const [field, meta] = useField(name);
  const {
    prefix
  } = React.useContext(INTERNAL_ONLY_FORM_INFO);
  const hasError = Boolean(meta.error);
  const inputId = `${prefix}-${name}`;
  const descriptionId = `${inputId}-description`;
  const errorId = `${inputId}-error`;
  const describedBy = [description ? descriptionId : void 0, hasError ? errorId : void 0].filter(Boolean);
  const options = {
    "aria-describedby": describedBy.length ? describedBy.join(" ") : void 0
  };
  return jsxs(InputBox, {
    hasError,
    children: [jsxs("label", __spreadProps(__spreadValues(__spreadProps(__spreadValues({
      htmlFor: inputId
    }, options), {
      "aria-invalid": hasError
    }), props), {
      sx: {
        display: "grid",
        gridTemplateColumns: "25px 1fr",
        py: 1,
        alignItems: "flex-start",
        cursor: "pointer"
      },
      children: [jsx("input", __spreadProps(__spreadValues({
        type: "checkbox",
        id: inputId
      }, field), {
        name,
        checked: field.value,
        sx: __spreadProps(__spreadValues({}, hiddenVisually), {
          "&:focus + svg": {
            outline: ".25rem solid",
            outlineColor: "effects.outline"
          }
        })
      })), jsx(InputCheckbox$1, {
        className: "inputImage",
        isChecked: Boolean(field.value),
        sx: {
          mt: "2px"
        }
      }), jsx("div", {
        className: "label",
        sx: {
          display: "inline-block"
        },
        children: label
      })]
    })), jsxs("div", {
      className: "descriptionContainer",
      sx: {
        ml: "22px"
      },
      children: [description && jsx(Box, {
        sx: {
          ml: 1,
          mt: 1
        },
        variant: "inputContainer.description",
        id: descriptionId,
        children: description
      }), jsx(InputError, {
        id: errorId,
        errorMessage: meta.error
      })]
    })]
  });
};
const InputRadio = (_S) => {
  var _T = _S, {
    isChecked
  } = _T, rest = __objRest(_T, [
    "isChecked"
  ]);
  const {
    theme
  } = useThemeUI();
  const svgProps = __spreadValues({
    "aria-hidden": true,
    focusable: true,
    sx: {
      pointerEvents: "none"
    },
    height: theme.isAccessibleMode ? 24 : 16,
    width: theme.isAccessibleMode ? 24 : 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, rest);
  if (isChecked) {
    return jsx("svg", __spreadProps(__spreadValues({}, svgProps), {
      children: jsxs("g", {
        strokeWidth: "1",
        sx: {
          fill: "primary.base"
        },
        children: [jsx("circle", {
          cx: "8",
          cy: "8",
          r: "3.5",
          stroke: "none"
        }), jsx("path", {
          d: "M8,16a8,8,0,1,1,8-8A8.009,8.009,0,0,1,8,16ZM8,2a6,6,0,1,0,6,6A6.006,6.006,0,0,0,8,2Z"
        })]
      })
    }));
  }
  return jsx("svg", __spreadProps(__spreadValues({}, svgProps), {
    children: jsx("g", {
      strokeWidth: "1",
      sx: {
        fill: "primary.base"
      },
      children: jsx("path", {
        d: "M8,16a8,8,0,1,1,8-8A8.009,8.009,0,0,1,8,16ZM8,2a6,6,0,1,0,6,6A6.006,6.006,0,0,0,8,2Z"
      })
    })
  }));
};
const RadioInput$1 = (_U) => {
  var _V = _U, {
    name,
    label,
    description,
    items,
    tooltip
  } = _V, props = __objRest(_V, [
    "name",
    "label",
    "description",
    "items",
    "tooltip"
  ]);
  const [field, meta] = useField(name);
  const {
    prefix
  } = React.useContext(INTERNAL_ONLY_FORM_INFO);
  const hasError = Boolean(meta.error);
  const inputId = `${prefix}-${name}`;
  const errorId = `${inputId}-error`;
  const descriptionId = `${inputId}-fieldsetDescription`;
  const describedBy = [hasError ? errorId : void 0, description ? descriptionId : void 0].filter(Boolean);
  const options = {
    "aria-describedby": describedBy.length ? describedBy.join(" ") : void 0
  };
  return jsxs(InputFieldSet, __spreadProps(__spreadValues({
    hasError
  }, options), {
    children: [jsxs("legend", {
      children: [label, tooltip && jsx(Tooltip$1, {
        children: tooltip
      })]
    }), jsx("div", {
      sx: {
        clear: "left"
      }
    }), description && jsx(Box, {
      variant: "inputContainer.description",
      id: descriptionId,
      children: description
    }), jsx(InputError, {
      errorMessage: meta.error,
      id: errorId
    }), jsx("div", {
      sx: {
        mt: "2px"
      },
      children: items.map((x, index) => {
        const radioId = index === 0 ? inputId : `${inputId}-${x.value.replace(/ /g, "")}`;
        const isChecked = field.value === x.value;
        const describeId = `${radioId}-list-description`;
        return jsxs("label", {
          htmlFor: radioId,
          "aria-invalid": hasError,
          "aria-describedby": x.description ? describeId : void 0,
          sx: {
            display: "grid",
            gridTemplateColumns: "24px 1fr",
            alignItems: "flex-start",
            py: 1,
            cursor: "pointer"
          },
          children: [jsxs("div", {
            children: [jsx("input", __spreadProps(__spreadValues(__spreadValues({
              type: "radio",
              id: radioId
            }, field), props), {
              value: x.value,
              checked: isChecked,
              sx: __spreadProps(__spreadValues({}, hiddenVisually), {
                "&:focus + svg": {
                  outline: ".25rem solid",
                  outlineColor: "effects.outline"
                }
              })
            })), jsx(InputRadio, {
              className: "inputImage",
              hasError,
              isChecked,
              sx: {
                mt: "3px",
                ml: "1px"
              }
            })]
          }), jsxs("div", {
            className: "descriptionContainer",
            sx: {
              pt: "1px"
            },
            children: [jsx("div", {
              sx: {
                display: "inline-block"
              },
              children: x.label
            }), x.description && jsx(Box, {
              variant: "inputContainer.description",
              id: describeId,
              children: x.description
            })]
          })]
        }, radioId);
      })
    })]
  }));
};
const CheckboxInput = (_W) => {
  var _X = _W, {
    name,
    label,
    description,
    items,
    tooltip
  } = _X, props = __objRest(_X, [
    "name",
    "label",
    "description",
    "items",
    "tooltip"
  ]);
  const [field, meta] = useField(name);
  const {
    prefix
  } = React.useContext(INTERNAL_ONLY_FORM_INFO);
  const hasError = Boolean(meta.error);
  const inputId = `${prefix}-${name}`;
  const errorId = `${inputId}-error`;
  const descriptionId = `${inputId}-fieldsetDescription`;
  const describedBy = [hasError ? errorId : void 0, description ? descriptionId : void 0].filter(Boolean);
  const options = {
    "aria-describedby": describedBy.length ? describedBy.join(" ") : void 0
  };
  return jsxs(InputFieldSet, __spreadProps(__spreadValues({
    hasError
  }, options), {
    children: [jsxs("legend", {
      children: [label, tooltip && jsx(Tooltip$1, {
        children: tooltip
      })]
    }), jsx("div", {
      sx: {
        clear: "left"
      }
    }), description && jsx(Box, {
      variant: "inputContainer.description",
      id: descriptionId,
      children: description
    }), jsx(InputError, {
      errorMessage: meta.error,
      id: errorId
    }), jsx("div", {
      sx: {
        mt: "2px"
      },
      children: items.map((x, index) => {
        var _a;
        const checkboxId = index === 0 ? inputId : `${inputId}-${x.value.replace(/ /g, "")}`;
        const isChecked = (_a = field.value) == null ? void 0 : _a.includes(x.value);
        const describeId = `${checkboxId}-list-description`;
        return jsxs("label", {
          htmlFor: checkboxId,
          "aria-invalid": hasError,
          "aria-describedby": x.description ? describeId : void 0,
          sx: {
            display: "grid",
            gridTemplateColumns: "24px 1fr",
            py: 1,
            alignItems: "flex-start",
            cursor: "pointer"
          },
          children: [jsx(Checkbox, __spreadProps(__spreadValues(__spreadValues({
            id: checkboxId
          }, field), props), {
            checked: isChecked,
            value: x.value
          })), jsxs("div", {
            className: "descriptionContainer",
            sx: {
              pt: "1px"
            },
            children: [jsx("div", {
              sx: {
                display: "inline-block"
              },
              children: x.label
            }), x.description && jsx(Box, {
              variant: "inputContainer.description",
              id: describeId,
              children: x.description
            })]
          })]
        }, checkboxId);
      })
    })]
  }));
};
const ChoiceInput = (_Y) => {
  var _Z = _Y, {
    allowMultiple
  } = _Z, props = __objRest(_Z, [
    "allowMultiple"
  ]);
  if (allowMultiple)
    return jsx(CheckboxInput, __spreadValues({}, props));
  return jsx(RadioInput$1, __spreadValues({}, props));
};
const CheckboxItem = (__) => {
  var _$ = __, {
    checkboxId,
    hasError,
    describeId,
    isChecked,
    field,
    item
  } = _$, props = __objRest(_$, [
    "checkboxId",
    "hasError",
    "describeId",
    "isChecked",
    "field",
    "item"
  ]);
  return jsxs("label", {
    htmlFor: checkboxId,
    "aria-invalid": hasError,
    "aria-describedby": item.description ? describeId : void 0,
    sx: {
      display: "grid",
      gridTemplateColumns: "24px 1fr",
      py: 1,
      alignItems: "flex-start",
      cursor: "pointer"
    },
    children: [jsxs("div", {
      children: [jsx("input", __spreadProps(__spreadValues(__spreadValues({
        type: "checkbox",
        id: checkboxId
      }, field), props), {
        checked: isChecked,
        value: item.value,
        sx: __spreadProps(__spreadValues({}, hiddenVisually), {
          "&:focus + svg": {
            outline: ".25rem solid",
            outlineColor: "effects.outline"
          }
        })
      })), jsx(InputCheckbox$1, {
        className: "inputImage",
        isChecked,
        sx: {
          mt: "3px",
          ml: "1px"
        }
      })]
    }), jsxs("div", {
      className: "descriptionContainer",
      sx: {
        pt: "1px"
      },
      children: [jsx("div", {
        sx: {
          display: "inline-block"
        },
        children: item.label
      }), item.description && jsx(Box, {
        variant: "inputContainer.description",
        id: describeId,
        children: item.description
      })]
    })]
  }, checkboxId);
};
const CheckboxWithOther = (_aa) => {
  var _ba = _aa, {
    name,
    label,
    items,
    tooltip,
    readOnly,
    description,
    autoComplete,
    otherInputType = "input",
    inputBoxSx,
    otherLabel = "Other"
  } = _ba, props = __objRest(_ba, [
    "name",
    "label",
    "items",
    "tooltip",
    "readOnly",
    "description",
    "autoComplete",
    "otherInputType",
    "inputBoxSx",
    "otherLabel"
  ]);
  const [field, meta, helpers] = useField(name);
  let initialOtherValue = "";
  if (Array.isArray(field.value) && field.value.length && items.length) {
    const itemsValues = items.map((x) => x.value);
    [initialOtherValue] = field.value.filter((x) => !itemsValues.includes(x));
  }
  const hasInitialOtherValue = Boolean(initialOtherValue == null ? void 0 : initialOtherValue.length);
  const [isOtherChecked, setIsOtherChecked] = useState(hasInitialOtherValue);
  const [otherValue, setOtherValue] = useState(initialOtherValue || "");
  useEffect(() => {
    setIsOtherChecked(hasInitialOtherValue);
    setOtherValue(initialOtherValue || "");
  }, [hasInitialOtherValue]);
  const {
    prefix
  } = React.useContext(INTERNAL_ONLY_FORM_INFO);
  const hasError = Boolean(meta.error);
  const inputId = `${prefix}-${name}`;
  const errorId = `${inputId}-error`;
  const otherId = `${prefix}-other`;
  const descriptionId = `${inputId}-fieldsetDescription`;
  const describedBy = [hasError ? errorId : void 0, description ? descriptionId : void 0].filter(Boolean);
  const options = {
    "aria-describedby": describedBy.length ? describedBy.join(" ") : void 0
  };
  return jsxs(InputFieldSet, __spreadProps(__spreadValues({
    hasError
  }, options), {
    children: [jsxs("legend", {
      children: [label, tooltip && jsx(Tooltip$1, {
        children: tooltip
      })]
    }), jsx("div", {
      sx: {
        clear: "left"
      }
    }), description && jsx(Box, {
      variant: "inputContainer.description",
      id: descriptionId,
      children: description
    }), jsx(InputError, {
      errorMessage: meta.error,
      id: errorId
    }), jsxs("div", {
      sx: {
        mt: "2px"
      },
      children: [items.map((x, index) => {
        var _a;
        const checkboxId = index === 0 ? inputId : `${inputId}-${x.value.replace(/ /g, "")}`;
        const isChecked = (_a = field.value) == null ? void 0 : _a.includes(x.value);
        const describeId = `${checkboxId}-list-description`;
        return jsx(CheckboxItem, __spreadValues({
          item: x,
          field,
          checkboxId,
          describeId,
          hasError,
          isChecked
        }, props), checkboxId);
      }), jsx(CheckboxItem, __spreadValues({
        item: {
          label: otherLabel,
          value: null
        },
        field,
        checkboxId: `${inputId}-other-checkbox`,
        describeId: `${inputId}-other-checkbox-list-description`,
        hasError,
        isChecked: isOtherChecked,
        onChange: (e) => {
          var _a;
          if (e.target.checked) {
            const otherOrNull = (otherValue == null ? void 0 : otherValue.length) ? otherValue : null;
            helpers.setValue(((_a = field.value) == null ? void 0 : _a.length) ? field.value.concat([otherOrNull]) : [null]);
          } else {
            helpers.setValue(field.value.filter((v) => v !== null && v !== otherValue));
          }
          setIsOtherChecked(e.target.checked);
        }
      }, props))]
    }), isOtherChecked && jsxs(InputBox, {
      pl: 24,
      sx: __spreadValues({}, inputBoxSx),
      children: [jsxs("label", {
        htmlFor: otherId,
        sx: __spreadValues({}, hiddenVisually),
        children: [label, " (Other)"]
      }), jsx(InputContainer, __spreadValues({
        as: otherInputType,
        id: otherId,
        inputMode: "text",
        rows: 3,
        readOnly,
        name: `${name}.other`,
        autoComplete,
        onChange: (e) => {
          const fieldValue = field.value.filter((v) => v !== null && v !== otherValue);
          setOtherValue(e.target.value);
          const uniqueValues = new Set(fieldValue.concat([e.target.value || null]));
          const newValue = Array.from(uniqueValues);
          helpers.setValue(newValue);
        },
        value: otherValue,
        hasError
      }, props))]
    })]
  }));
};
const InputCheckbox = (_ca) => {
  var _da = _ca, {
    isChecked
  } = _da, rest = __objRest(_da, [
    "isChecked"
  ]);
  const {
    theme
  } = useThemeUI();
  const id = React.useMemo(() => v4(), []);
  const backgoundVariants = {
    checked: {
      fill: "#00838F"
    },
    unchecked: {
      fill: "#DDDDDD"
    }
  };
  const circleVariants = {
    checked: {
      cx: 22
    },
    unchecked: {
      cx: 10
    }
  };
  const animate = isChecked ? "checked" : "unchecked";
  return jsx("svg", __spreadProps(__spreadValues({
    height: theme.isAccessibleMode ? 32 : 24,
    width: theme.isAccessibleMode ? 40 : 32,
    viewBox: "0 0 32 24",
    focusable: false,
    "aria-hidden": true,
    xmlns: "http://www.w3.org/2000/svg",
    sx: {
      pointerEvents: "none"
    }
  }, rest), {
    children: jsxs("g", {
      id: `${id}-toggle-switch`,
      stroke: "none",
      strokeWidth: "1",
      fill: "none",
      fillRule: "evenodd",
      children: [jsx(motion.rect, {
        x: "0",
        y: "2",
        rx: "10",
        width: "32",
        height: "20",
        animate,
        initial: "unchecked",
        variants: backgoundVariants,
        transition: {
          duration: 0.25
        }
      }), jsx(motion.circle, {
        r: "6",
        cy: "12",
        fill: "#FFFFFF",
        animate,
        initial: "unchecked",
        variants: circleVariants,
        transition: {
          duration: 0.25
        }
      })]
    })
  }));
};
const ToggleSwitch = (_ea) => {
  var _fa = _ea, {
    name,
    label,
    description
  } = _fa, props = __objRest(_fa, [
    "name",
    "label",
    "description"
  ]);
  const [field, meta] = useField(name);
  const {
    prefix
  } = React.useContext(INTERNAL_ONLY_FORM_INFO);
  const hasError = Boolean(meta.error);
  const inputId = `${prefix}-${name}`;
  const descriptionId = `${inputId}-description`;
  const errorId = `${inputId}-error`;
  const describedBy = [description ? descriptionId : void 0, hasError ? errorId : void 0].filter(Boolean);
  const options = {
    "aria-describedby": describedBy.length ? describedBy.join(" ") : void 0
  };
  return jsxs(InputBox, {
    hasError,
    children: [jsxs("label", __spreadProps(__spreadValues(__spreadProps(__spreadValues({
      htmlFor: inputId
    }, options), {
      "aria-invalid": hasError
    }), props), {
      sx: {
        display: "grid",
        gridTemplateColumns: "43px 1fr",
        py: 1,
        alignItems: "flex-start",
        cursor: "pointer"
      },
      children: [jsx("input", __spreadProps(__spreadValues({
        type: "checkbox",
        id: inputId
      }, field), {
        name,
        checked: field.value,
        sx: __spreadProps(__spreadValues({}, hiddenVisually), {
          "&:focus + svg": {
            outline: ".25rem solid",
            outlineColor: "effects.outline"
          }
        })
      })), jsx(InputCheckbox, {
        hasError,
        isChecked: Boolean(field.value)
      }), jsx("div", {
        className: "label",
        sx: {
          display: "inline-block"
        },
        children: label
      })]
    })), jsxs("div", {
      className: "descriptionContainer",
      sx: {
        ml: "22px"
      },
      children: [description && jsx(Box, {
        sx: {
          ml: 1,
          mt: 1
        },
        variant: "inputContainer.description",
        id: descriptionId,
        children: description
      }), jsx(InputError, {
        id: errorId,
        errorMessage: meta.error
      })]
    })]
  });
};
const ApprovalBox = ({
  isChecked
}) => jsx(Box, {
  sx: {
    bg: isChecked ? "success.base" : "neutral.l4",
    border: "1px solid",
    borderColor: "neutral.l3",
    borderRadius: "rounded",
    width: 40,
    height: 32,
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  title: "Approve",
  children: jsx(Icon, {
    variant: isChecked ? "check" : "check-circle",
    color: isChecked ? "white" : "neutral.base"
  })
});
const DenyBox = ({
  isChecked
}) => jsx(Box, {
  sx: {
    bg: isChecked ? "danger.base" : "neutral.l4",
    border: "1px solid",
    borderColor: "neutral.l3",
    borderRadius: "rounded",
    width: 40,
    height: 32,
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  title: "Deny",
  children: jsx(Icon, {
    variant: isChecked ? "times" : "times-circle",
    color: isChecked ? "white" : "neutral.base"
  })
});
const MissingBox = ({
  isChecked
}) => jsx(Box, {
  sx: {
    bg: isChecked ? "neutral.base" : "neutral.l4",
    border: "1px solid",
    borderColor: "neutral.l3",
    borderRadius: "rounded",
    width: 40,
    height: 32,
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  title: "Missing",
  children: jsx(Icon, {
    variant: isChecked ? "minus" : "minus-circle",
    color: isChecked ? "white" : "neutral.base"
  })
});
const RadioInput = (_ga) => {
  var _ha = _ga, {
    name,
    label,
    description,
    allowMissing,
    handleSelect,
    allowPass = true,
    allowFail = true,
    disabled = false
  } = _ha, props = __objRest(_ha, [
    "name",
    "label",
    "description",
    "allowMissing",
    "handleSelect",
    "allowPass",
    "allowFail",
    "disabled"
  ]);
  const [field, meta] = useField(name);
  const {
    prefix
  } = React.useContext(INTERNAL_ONLY_FORM_INFO);
  const hasError = Boolean(meta.error);
  const inputId = `${prefix}-${name}`;
  const errorId = `${inputId}-error`;
  const descriptionId = `${inputId}-fieldsetDescription`;
  const describedBy = [hasError ? errorId : void 0, description ? descriptionId : void 0].filter(Boolean);
  const options = {
    "aria-describedby": describedBy.length ? describedBy.join(" ") : void 0
  };
  const items = [];
  if (allowPass)
    items.push({
      label: "Approve",
      value: "approve"
    });
  if (allowFail)
    items.push({
      label: "Deny",
      value: "deny"
    });
  if (allowMissing)
    items.push({
      label: "Missing",
      value: "missing"
    });
  const handleChange = (event) => {
    field.onChange(event);
    if (handleSelect)
      handleSelect(event.target.checked, name);
  };
  return jsxs(InputFieldSet, __spreadProps(__spreadValues({
    hasError
  }, options), {
    children: [jsx(VisuallyHidden, {
      children: jsx("legend", {
        children: label
      })
    }), jsx("div", {
      sx: {
        clear: "left"
      }
    }), description && jsx(Box, {
      variant: "inputContainer.description",
      id: descriptionId,
      children: description
    }), jsx(InputError, {
      errorMessage: meta.error,
      id: errorId
    }), jsx(Grid, {
      columns: "40px 40px 40px",
      gap: 1,
      sx: {
        mt: "2px"
      },
      children: items.map((x, index) => {
        const radioId = index === 0 ? inputId : `${inputId}-${x.value.replace(/ /g, "")}`;
        const isChecked = field.value === x.value;
        return jsxs("label", {
          htmlFor: radioId,
          "aria-invalid": hasError,
          sx: {
            display: "grid",
            gridTemplateColumns: "24px 1fr",
            alignItems: "flex-start",
            py: 1,
            cursor: disabled ? "not-allowed" : "pointer"
          },
          children: [jsxs("div", {
            children: [jsx("input", __spreadProps(__spreadValues(__spreadValues({
              type: "radio",
              id: radioId
            }, field), props), {
              onChange: handleChange,
              disabled,
              value: x.value,
              sx: __spreadProps(__spreadValues({}, hiddenVisually), {
                "&:focus + div": {
                  outline: ".25rem solid",
                  outlineColor: "effects.outline"
                }
              })
            })), x.value === "approve" && jsx(ApprovalBox, {
              isChecked
            }), x.value === "deny" && jsx(DenyBox, {
              isChecked
            }), x.value === "missing" && jsx(MissingBox, {
              isChecked
            })]
          }), jsx(VisuallyHidden, {
            children: x.label
          })]
        }, radioId);
      })
    })]
  }));
};
const Signature = ({
  name,
  label,
  description,
  tooltip
}) => {
  const canvasRef = React.useRef(null);
  const [pad, setPad] = React.useState();
  const [, meta, helpers] = useField(name);
  const {
    prefix
  } = React.useContext(INTERNAL_ONLY_FORM_INFO);
  const hasError = Boolean(meta.error);
  const inputId = `${prefix}-${name}`;
  const descriptionId = `${inputId}-description`;
  const errorId = `${inputId}-error`;
  const isClient = typeof window === "object";
  const handleResize = () => {
    var _a;
    const canvas = canvasRef.current;
    if (!canvas || !pad)
      return;
    const ratio = Math.max(window.devicePixelRatio || 1, 1);
    canvas.width = canvas.offsetWidth * ratio;
    canvas.height = canvas.offsetHeight * ratio;
    (_a = canvas.getContext("2d")) == null ? void 0 : _a.scale(ratio, ratio);
    pad.clear();
  };
  React.useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas)
      return;
    const signaturePad = new SignaturePad(canvas, {
      backgroundColor: "#fff"
    });
    setPad(signaturePad);
  }, [canvasRef]);
  React.useEffect(() => {
    if (!isClient)
      return () => {
      };
    handleResize();
    const debounceSize = debounce$1(handleResize, 250);
    window.addEventListener("resize", debounceSize);
    return () => window.removeEventListener("resize", debounceSize);
  }, [pad]);
  const describedBy = [description ? descriptionId : void 0, hasError ? errorId : void 0].filter(Boolean);
  const options = {
    id: inputId,
    "aria-describedby": describedBy.length ? describedBy.join(" ") : void 0
  };
  const saveDrawing = () => {
    const data = pad == null ? void 0 : pad.toDataURL();
    helpers.setValue(data);
  };
  return jsxs(InputBox, {
    hasError,
    children: [jsxs("div", {
      children: [jsx("label", {
        onClick: () => {
          var _a;
          return (_a = canvasRef.current) == null ? void 0 : _a.focus();
        },
        htmlFor: inputId,
        children: label
      }), tooltip && jsx(Tooltip$1, {
        children: tooltip
      }), description && jsx(Box, {
        variant: "inputContainer.description",
        id: descriptionId,
        children: description
      })]
    }), jsxs("div", {
      sx: {
        position: "relative"
      },
      children: [jsx(Box, __spreadProps(__spreadValues({
        as: "canvas",
        className: hasError ? "input-has-error" : "",
        variant: "inputContainer.base",
        tabIndex: 0,
        ref: canvasRef,
        height: 250,
        onClick: saveDrawing,
        onTouchEnd: saveDrawing,
        width: 400
      }, options), {
        sx: {
          width: "100%",
          height: 250,
          mt: 2,
          bg: "white"
        }
      })), jsx("div", {
        sx: {
          position: "absolute",
          left: 16,
          bottom: 16,
          pointerEvents: "none"
        },
        children: jsx(Icon, {
          variant: "edit",
          color: "neutral.l1"
        })
      })]
    }), jsxs("div", {
      sx: {
        display: "flex",
        alignItems: "flex-start"
      },
      children: [jsx(InputError, {
        id: errorId,
        errorMessage: meta.error
      }), jsx(Button, {
        type: "button",
        variant: "ghost",
        onClick: () => {
          pad == null ? void 0 : pad.clear();
          helpers.setValue(void 0);
        },
        sx: {
          color: "primary.base",
          ml: "auto"
        },
        children: "Clear Signature"
      })]
    })]
  });
};
const Divider = (props) => jsx(Box, __spreadValues({
  as: "hr",
  sx: {
    border: "1px solid",
    borderColor: "neutral.l3"
  }
}, props));
const Badge = (_ia) => {
  var _ja = _ia, {
    variant = "neutral",
    children
  } = _ja, props = __objRest(_ja, [
    "variant",
    "children"
  ]);
  const prefix = {
    neutral: null,
    primary: null,
    success: "Success: ",
    danger: "Critical: ",
    warning: "Warning: ",
    info: "Info: "
  };
  return jsxs(Box, __spreadProps(__spreadValues({
    variant: `badge.${variant}`
  }, props), {
    children: [prefix[variant] && jsx(VisuallyHidden, {
      children: prefix[variant]
    }), children]
  }));
};
const CardHeader = ({
  children,
  cardVariant,
  actions
}) => jsxs(Box, {
  as: "header",
  sx: {
    m: -3,
    mb: 3,
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    justifyContent: "space-between",
    py: 2,
    px: 3,
    borderTopLeftRadius: "rounded",
    borderTopRightRadius: "rounded",
    bg: cardVariant === "focus" ? "primary.l3" : "neutral.l4"
  },
  children: [jsx(Box, {
    children
  }), actions && jsx(Box, {
    sx: {
      ml: "auto"
    },
    children: actions.map(({
      title,
      onClick,
      id
    }) => jsx(Button, {
      my: -2,
      ml: [0, 1],
      variant: "ghost",
      onClick,
      children: title
    }, id))
  })]
});
const Card = React.forwardRef((_ka, ref) => {
  var _la = _ka, {
    variant = "primary",
    children,
    header,
    footer
  } = _la, props = __objRest(_la, [
    "variant",
    "children",
    "header",
    "footer"
  ]);
  return jsxs(Card$1, __spreadProps(__spreadValues({
    variant
  }, props), {
    ref,
    children: [header && jsx(CardHeader, {
      actions: header.actions,
      cardVariant: variant,
      children: jsxs(Heading, {
        as: header.as,
        variant: "h6",
        sx: {
          display: "flex",
          alignItems: "center"
        },
        children: [(header == null ? void 0 : header.icon) && jsx(Icon, {
          variant: header.icon,
          size: "sm",
          sx: {
            mr: 2
          }
        }), header.title]
      })
    }), children, footer && jsx("footer", {
      sx: {
        m: -3,
        mt: 3,
        py: 2,
        px: 3,
        bg: variant === "focus" ? "primary.l3" : "neutral.l4"
      },
      children: footer
    })]
  }));
});
const DEFAULT_DEBOUNCE_DELAY_MS = 250;
const FORM_KEY = {
  ADDRESS: "borrowerAddress",
  EMAIL: "borrowerEmail",
  FIRST_NAME: "borrowerFirstName",
  LAST_NAME: "borrowerLastName",
  LOAN_ID: "loanId",
  PHONE: "phone",
  REFERENCE_NUMBER: "referenceNumber",
  SSN: "SSN"
};
const formInitialValues = {
  [FORM_KEY.ADDRESS]: "",
  [FORM_KEY.EMAIL]: "",
  [FORM_KEY.FIRST_NAME]: "",
  [FORM_KEY.LAST_NAME]: "",
  [FORM_KEY.LOAN_ID]: "",
  [FORM_KEY.PHONE]: "",
  [FORM_KEY.REFERENCE_NUMBER]: "",
  [FORM_KEY.SSN]: ""
};
const itemDefaultStringGetter = (item) => {
  var _a;
  return (_a = item == null ? void 0 : item.id) != null ? _a : "";
};
const AdvancedSearch = ({
  initialInputValue,
  isInternalUser = false,
  isLoading,
  itemToString = itemDefaultStringGetter,
  onChange,
  onSelect,
  onSubmit,
  overflow = false,
  placeholder,
  position = "left",
  renderNode,
  results,
  searchDelay = DEFAULT_DEBOUNCE_DELAY_MS,
  clearAll = () => {
  }
}) => {
  const [isAdvancedSearchOpen, setIsAdvancedSearchOpen] = useState(false);
  const [badgeCount, setBadgeCount] = useState(0);
  const [formValues, setFormValues] = useState(formInitialValues);
  const debouncedChange = useMemo(() => debounce$1(onChange, searchDelay), [onChange, searchDelay]);
  const {
    getComboboxProps,
    getInputProps,
    getItemProps,
    getMenuProps,
    highlightedIndex,
    isOpen
  } = useCombobox({
    initialInputValue,
    items: results,
    itemToString,
    onInputValueChange: ({
      inputValue
    }) => debouncedChange(inputValue),
    onSelectedItemChange: ({
      selectedItem
    }) => onSelect(selectedItem)
  });
  useEffect(() => () => debouncedChange.cancel(), [debouncedChange]);
  useEffect(() => setBadgeCount(Object.values(formValues).filter((value) => !!value.length).length), [formValues]);
  const handleChange = useCallback(({
    target: {
      name,
      value
    }
  }) => {
    setFormValues(__spreadProps(__spreadValues({}, formValues), {
      [name]: value
    }));
  }, [formValues]);
  const {
    loanId,
    borrowerFirstName,
    borrowerLastName,
    borrowerAddress,
    borrowerEmail,
    phone,
    referenceNumber,
    SSN
  } = formValues;
  const showResults = Boolean(!isLoading && (results == null ? void 0 : results.length));
  const showNoResults = Boolean(!isLoading && !(results == null ? void 0 : results.length));
  const style = useMemo(() => position === "left" ? {
    left: 0
  } : {
    right: 0
  }, [position]);
  return jsxs("div", {
    children: [jsx("div", __spreadProps(__spreadValues({}, getComboboxProps()), {
      children: jsx(Box, {
        variant: "inputContainer.box",
        sx: {
          m: 0,
          p: 0
        },
        children: jsxs(Box, {
          sx: {
            display: "flex",
            width: ["100%", 500]
          },
          children: [jsx(Box, {
            variant: "inputContainer.prefix",
            sx: {
              alignItems: "center",
              display: "flex",
              maxHeight: 25,
              px: 0,
              width: "5%"
            },
            children: jsx(Icon, {
              color: "primary.base",
              size: "sm",
              sx: {
                "i::before": {
                  mx: 0
                },
                ml: 1
              },
              variant: "search"
            })
          }), jsx(Box, __spreadProps(__spreadValues({
            variant: "inputContainer.base",
            as: "input"
          }, getInputProps()), {
            placeholder,
            sx: {
              borderBottomLeftRadius: 0,
              borderBottomRightRadius: 0,
              borderLeft: 0,
              borderRight: 0,
              borderTopLeftRadius: 0,
              borderTopRightRadius: 0,
              maxHeight: 25,
              width: badgeCount ? "67%" : "71%"
            }
          })), !!badgeCount && jsx(Box, {
            variant: "inputContainer.base",
            sx: {
              alignItems: "center",
              borderBottomLeftRadius: 0,
              borderBottomRightRadius: 0,
              borderLeft: 0,
              borderRight: 0,
              borderTopLeftRadius: 0,
              borderTopRightRadius: 0,
              color: "primary.base",
              display: "flex",
              justifyContent: "right",
              maxHeight: 25,
              px: 0
            },
            children: jsx(Badge, {
              variant: "primary",
              sx: {
                minWidth: 24,
                textAlign: "center",
                mr: 1
              },
              children: badgeCount
            })
          }), jsx(Box, {
            variant: "inputContainer.base",
            sx: {
              alignItems: "center",
              borderBottomLeftRadius: 0,
              borderBottomRightRadius: 0,
              borderLeft: 0,
              borderRight: 0,
              borderTopLeftRadius: 0,
              borderTopRightRadius: 0,
              color: "primary.base",
              display: "flex",
              justifyContent: "right",
              maxHeight: 25,
              px: 0,
              width: "30%",
              "@media screen and (max-width: 80em)": {
                display: "none"
              }
            },
            children: "Advanced search"
          }), jsx(Box, {
            variant: "inputContainer.suffix",
            sx: {
              alignItems: "center",
              display: "flex",
              justifyContent: "right",
              maxHeight: 25,
              px: 0,
              width: "10%",
              ":hover": {
                cursor: "pointer"
              }
            },
            onClick: () => setIsAdvancedSearchOpen(!isAdvancedSearchOpen),
            children: jsx(Icon, {
              color: "primary.base",
              size: "md",
              sx: {
                ml: 2,
                mr: 1
              },
              variant: "filter"
            })
          })]
        })
      })
    })), jsx(Box, __spreadProps(__spreadValues({
      as: "ul"
    }, getMenuProps()), {
      sx: {
        position: overflow ? "absolute" : "relative"
      },
      children: isOpen && jsxs(Card, {
        variant: "float",
        sx: __spreadValues({
          maxHeight: 300,
          overflowY: "scroll",
          p: 0,
          position: "absolute",
          width: ["100%", 600],
          zIndex: 99999,
          li: {
            "&:first-of-type": {
              borderTopLeftRadius: "rounded",
              borderTopRightRadius: "rounded"
            },
            "&:last-of-type": {
              borderBottomLeftRadius: "rounded",
              borderBottomRightRadius: "rounded"
            }
          }
        }, style),
        children: [isLoading && jsxs(Box, {
          sx: {
            alignItems: "center",
            display: "flex",
            p: 3
          },
          children: [jsx(Spinner, {
            color: "secondary.base",
            sx: {
              mr: 2
            },
            size: 30
          }), "Searching..."]
        }), showNoResults && jsx(Box, {
          sx: {
            alignItems: "center",
            bg: "primary.l4",
            border: "1px dashed",
            borderColor: "primary.l2",
            display: "flex",
            m: 3,
            p: 3
          },
          children: "No results found"
        }), showResults && results.map((item, index) => jsx(Box, __spreadProps(__spreadValues({
          as: "li",
          sx: {
            bg: highlightedIndex === index ? "primary.l4" : "white",
            cursor: "pointer",
            listStyleType: "none",
            p: 2
          }
        }, getItemProps({
          item,
          index
        })), {
          children: jsx(Grid, {
            children: jsx(Box, {
              children: renderNode(item)
            })
          })
        }), item.id))]
      })
    })), isAdvancedSearchOpen && jsx(Box, __spreadProps(__spreadValues({
      as: "ul"
    }, getMenuProps()), {
      sx: {
        position: overflow ? "absolute" : "relative"
      },
      children: jsxs(Card, {
        variant: "float",
        sx: __spreadValues({
          maxHeight: 1e3,
          overflowY: "scroll",
          p: 3,
          position: "absolute",
          width: ["100%", 600],
          zIndex: 99999,
          li: {
            "&:first-of-type": {
              borderTopLeftRadius: "rounded",
              borderTopRightRadius: "rounded"
            },
            "&:last-of-type": {
              borderBottomLeftRadius: "rounded",
              borderBottomRightRadius: "rounded"
            }
          }
        }, style),
        children: [jsxs(Grid, {
          sx: {
            display: "flex",
            justifyContent: "space-between"
          },
          children: [jsx(Heading, {
            variant: "h4",
            sx: {
              display: "flex",
              alignItems: "center"
            },
            children: "Advanced search"
          }), jsx(ButtonLink, {
            clean: true,
            onClick: () => {
              setFormValues(formInitialValues);
              clearAll();
            },
            children: "Clear all"
          })]
        }), jsx(Divider, {
          my: 1
        }), jsxs(Form, {
          showSummary: false,
          initialValues: formInitialValues,
          onSubmit: () => {
            onSubmit(formValues);
            setIsAdvancedSearchOpen(false);
          },
          children: [jsxs(Box, {
            sx: {
              p: 1
            },
            children: [jsx("label", {
              htmlFor: FORM_KEY.LOAN_ID,
              children: "Loan ID"
            }), jsx(InputContainer, {
              as: "input",
              hasError: false,
              name: FORM_KEY.LOAN_ID,
              onChange: handleChange,
              sx: {
                maxWidth: 150
              },
              value: loanId
            })]
          }), jsxs(Box, {
            sx: {
              p: 1
            },
            children: [jsx("label", {
              htmlFor: FORM_KEY.FIRST_NAME,
              children: "First name"
            }), jsx(InputContainer, {
              as: "input",
              hasError: false,
              name: FORM_KEY.FIRST_NAME,
              onChange: handleChange,
              sx: {
                maxWidth: 300
              },
              value: borrowerFirstName
            })]
          }), jsxs(Box, {
            sx: {
              p: 1
            },
            children: [jsx("label", {
              htmlFor: FORM_KEY.LAST_NAME,
              children: "Last name"
            }), jsx(InputContainer, {
              as: "input",
              hasError: false,
              name: FORM_KEY.LAST_NAME,
              onChange: handleChange,
              sx: {
                maxWidth: 300
              },
              value: borrowerLastName
            })]
          }), jsxs(Box, {
            sx: {
              p: 1
            },
            children: [jsx("label", {
              htmlFor: FORM_KEY.ADDRESS,
              children: "Address"
            }), jsx(InputContainer, {
              as: "input",
              hasError: false,
              name: FORM_KEY.ADDRESS,
              onChange: handleChange,
              sx: {
                maxWidth: 300
              },
              value: borrowerAddress
            })]
          }), jsxs(Box, {
            sx: {
              p: 1
            },
            children: [jsx("label", {
              htmlFor: FORM_KEY.PHONE,
              children: "Phone"
            }), jsx(InputContainer, {
              as: "input",
              hasError: false,
              name: FORM_KEY.PHONE,
              onChange: handleChange,
              sx: {
                maxWidth: 150
              },
              value: phone
            })]
          }), jsxs(Box, {
            sx: {
              p: 1
            },
            children: [jsx("label", {
              htmlFor: FORM_KEY.EMAIL,
              children: "Email"
            }), jsx(InputContainer, {
              as: "input",
              hasError: false,
              name: FORM_KEY.EMAIL,
              onChange: handleChange,
              sx: {
                maxWidth: 300
              },
              value: borrowerEmail
            })]
          }), jsxs(Box, {
            sx: {
              p: 1
            },
            children: [jsx("label", {
              htmlFor: FORM_KEY.SSN,
              children: "Reference ID"
            }), jsx(InputContainer, {
              as: "input",
              hasError: false,
              name: FORM_KEY.REFERENCE_NUMBER,
              onChange: handleChange,
              sx: {
                maxWidth: 150
              },
              value: referenceNumber
            })]
          }), isInternalUser && jsxs(Box, {
            sx: {
              p: 1
            },
            children: [jsx("label", {
              htmlFor: FORM_KEY.SSN,
              children: "SSN last 4"
            }), jsx(InputContainer, {
              as: "input",
              hasError: false,
              name: FORM_KEY.SSN,
              onChange: handleChange,
              sx: {
                maxWidth: 150
              },
              value: SSN
            })]
          }), jsxs(Grid, {
            sx: {
              display: "flex",
              justifyContent: "end",
              p: 1
            },
            children: [jsx(Button, {
              variant: "secondary",
              onClick: () => setIsAdvancedSearchOpen(false),
              children: "Close"
            }), jsx(Button, {
              type: "submit",
              disabled: !badgeCount,
              children: "Search"
            })]
          })]
        })]
      })
    }))]
  });
};
const AlertBanner = ({
  variant,
  children,
  showIcon = true,
  textOnly = true
}) => {
  const alertId = React.useMemo(() => v4(), []);
  const iconMapping2 = {
    danger: "color-danger",
    warning: "color-warning",
    info: "color-info"
  };
  const iconType = iconMapping2[variant];
  const message = {
    danger: "Critical: ",
    warning: "Warning: ",
    info: "Info: "
  };
  const isCritical = Boolean(variant === "danger" || variant === "warning");
  return jsxs(Box, {
    "aria-describedby": alertId,
    tabIndex: 0,
    variant: `alert.banner-${variant}`,
    role: isCritical ? "alert" : "status",
    "aria-live": isCritical ? "assertive" : "polite",
    sx: {
      gridTemplateColumns: showIcon ? "25px 1fr" : "1fr"
    },
    children: [showIcon && jsx(Icon, {
      "aria-hidden": true,
      variant: iconType
    }), jsxs(Box, {
      id: alertId,
      sx: textOnly ? {
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        overflow: "hidden"
      } : {},
      children: [jsx(VisuallyHidden, {
        children: message[variant]
      }), children]
    })]
  });
};
const AlertInline = (_ma) => {
  var _na = _ma, {
    autoFocus = false,
    children,
    className,
    onDismiss,
    sxProps,
    variant = "info"
  } = _na, props = __objRest(_na, [
    "autoFocus",
    "children",
    "className",
    "onDismiss",
    "sxProps",
    "variant"
  ]);
  const ref = useRef(null);
  const alertId = useMemo(() => v4(), []);
  useEffect(() => {
    if (ref.current && autoFocus)
      ref.current.focus();
  }, [ref.current]);
  const isCritical = Boolean(variant === "danger" || variant === "warning");
  const iconVariant = `color-${variant}`;
  const themeUIStyle = useMemo(() => __spreadProps(__spreadValues({}, sxProps), {
    bg: `${variant}.l2`,
    borderColor: `${variant}.base`
  }), [variant, sxProps]);
  return jsxs(Box, __spreadProps(__spreadValues({
    className,
    "aria-describedby": alertId,
    tabIndex: 0,
    ref,
    role: isCritical ? "alert" : "status",
    "aria-live": isCritical ? "assertive" : "polite"
  }, props), {
    variant: "alert.inline",
    sx: themeUIStyle,
    children: [jsx(Icon, {
      "aria-hidden": true,
      variant: iconVariant,
      color: `${variant}.base`
    }), jsx("div", {
      id: alertId,
      children
    }), onDismiss && jsx(Button, {
      onClick: onDismiss,
      variant: "ghost",
      sx: {
        height: "40px",
        px: 0,
        width: "40px",
        color: `${variant}.d1`,
        ":hover": {
          bg: `${variant}.l15`
        }
      },
      "aria-label": "Dismiss",
      children: jsx(Icon, {
        variant: "times",
        size: "md",
        "aria-hidden": true
      })
    })]
  }));
};
const NotifyAlert = (_oa) => {
  var _pa = _oa, {
    variant = "info",
    type,
    message,
    onDismiss,
    action
  } = _pa, rest = __objRest(_pa, [
    "variant",
    "type",
    "message",
    "onDismiss",
    "action"
  ]);
  const alertId = React.useMemo(() => v4(), []);
  const isCritical = Boolean(variant === "danger" || variant === "warning");
  const prefixMessage = {
    info: "Info: ",
    success: "Success: ",
    warning: "Warning: ",
    danger: "Danger: "
  };
  const _a = action || {}, {
    label
  } = _a, actionProps = __objRest(_a, [
    "label"
  ]);
  const snackbar = {
    container: {
      maxWidth: "600px",
      width: "100%"
    },
    content: {
      display: "grid",
      gridTemplateColumns: "1fr max-content",
      flexWrap: "wrap",
      alignItems: "center"
    }
  };
  const toast = {
    container: {
      maxWidth: ["auto", "450px"],
      width: "100%",
      mx: [0, 2],
      mb: 1
    },
    content: {
      display: "flex",
      flexFlow: "column wrap",
      alignItems: "flex-start",
      "& .action": {
        mt: 2
      }
    }
  };
  const style = type === "toast" ? toast : snackbar;
  return jsxs(Box, __spreadProps(__spreadValues({
    variant: "alert.toast",
    className: onDismiss ? "on-dismiss" : "",
    "aria-describedby": alertId,
    tabIndex: 0,
    role: isCritical ? "alert" : "status",
    "aria-live": isCritical ? "assertive" : "polite",
    sx: __spreadValues({
      py: action && [3, 2],
      zIndex: 99999
    }, style.container)
  }, rest), {
    children: [jsx(Icon, {
      "aria-hidden": true,
      variant: `color-${variant}`,
      color: `${variant}.base`
    }), jsxs(Box, {
      sx: style.content,
      children: [jsxs("div", {
        id: alertId,
        children: [jsx(VisuallyHidden, {
          children: prefixMessage[variant]
        }), message]
      }), action && jsx(Box, {
        sx: {
          mt: [2, 0]
        },
        children: jsx(Button, __spreadProps(__spreadValues({
          className: "action",
          as: "button"
        }, actionProps), {
          sx: {
            ml: "2px"
          },
          children: label
        }))
      })]
    }), onDismiss && jsx(Button, {
      onClick: onDismiss,
      className: "button-dismiss",
      variant: "ghost",
      sx: {
        height: 40,
        px: 0,
        width: 40,
        color: "inherit"
      },
      "aria-label": "Dismiss",
      children: jsx(Icon, {
        variant: "times",
        size: "md",
        "aria-hidden": true
      })
    })]
  }));
};
const notifyContext = React.createContext(void 0);
const useNotify = () => {
  const context = React.useContext(notifyContext);
  if (!context)
    throw new Error("no context provider for notify");
  return context;
};
const NotifyProvider = ({
  children
}) => {
  const [activeSnack, setSnack] = React.useState();
  const [toasts, updateToast] = React.useState([]);
  const [snackbar, addSnack] = React.useState({});
  const snackAnimation = {
    initial: {
      opacity: 0,
      y: 50,
      scale: 0.3
    },
    animate: {
      opacity: 1,
      y: 0,
      scale: 1
    },
    exit: {
      opacity: 0,
      scale: 0.5,
      transition: {
        duration: 0.2
      }
    }
  };
  const removeToast = (id) => {
    updateToast((list) => list.filter((x) => x.id !== id));
  };
  const value = useMemo(() => ({
    addSnack: (snack) => {
      const id = v4();
      addSnack(Object.assign({}, snackbar, {
        [id]: snack
      }));
      setSnack(id);
      setTimeout(() => {
        addSnack((snacks) => Object.assign({}, snacks, {
          [id]: void 0
        }));
      }, snack.duration || 6e3);
    },
    clearSnack: () => {
      setSnack(void 0);
      addSnack({});
    },
    clearToasts: () => updateToast([]),
    addToast: (toast) => {
      const id = v4();
      updateToast(toasts.concat([__spreadProps(__spreadValues({}, toast), {
        id
      })]));
      setTimeout(() => removeToast(id), toast.duration || 6e3);
      return id;
    },
    removeToast
  }), [snackbar, toasts]);
  const activeSnackbar = activeSnack ? snackbar[activeSnack] : void 0;
  return jsxs(notifyContext.Provider, {
    value,
    children: [children, jsx(AnimatePresence, {
      children: activeSnackbar && jsx(motion.div, __spreadProps(__spreadValues({
        style: {
          position: "fixed",
          bottom: "24px",
          width: "100vw",
          display: "flex",
          justifyContent: "center",
          left: 0,
          zIndex: 999999
        }
      }, snackAnimation), {
        children: jsx(NotifyAlert, __spreadProps(__spreadValues({}, activeSnackbar), {
          type: "snackbar"
        }))
      }))
    }), jsx(AnimatePresence, {
      children: jsx(Box, {
        as: "ul",
        sx: {
          position: "fixed",
          top: 3,
          right: [0, 3],
          listStyleType: "none",
          p: 0,
          zIndex: 999999,
          m: 0
        },
        children: toasts.map((_a) => {
          var _b = _a, {
            id
          } = _b, toast = __objRest(_b, [
            "id"
          ]);
          return jsx(motion.li, __spreadProps(__spreadValues({
            positionTransition: true
          }, snackAnimation), {
            children: jsx(NotifyAlert, __spreadProps(__spreadValues({
              type: "toast"
            }, toast), {
              onDismiss: () => removeToast(id)
            }))
          }), id);
        })
      })
    })]
  });
};
const confetti = {
  v: "5.6.5",
  fr: 29.9700012207031,
  ip: 0,
  op: 150.000006109625,
  w: 500,
  h: 1024,
  nm: "Confetti",
  ddd: 0,
  assets: [],
  layers: [
    {
      ddd: 0,
      ind: 1,
      ty: 4,
      nm: "Shape Layer 54",
      sr: 1,
      ks: {
        o: {
          a: 1,
          k: [
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 0, s: [100] },
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 30, s: [82] },
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 54, s: [100] },
            { t: 150.000006109625, s: [0] }
          ],
          ix: 11
        },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.833, y: 0.833 },
              o: { x: 0.167, y: 0.167 },
              t: 0,
              s: [308.135, -819, 0],
              to: [0, 195.333, 0],
              ti: [0, -195.333, 0]
            },
            { t: 150.000006109625, s: [308.135, 353, 0] }
          ],
          ix: 2
        },
        a: { a: 0, k: [0.135, 1.485, 0], ix: 1 },
        s: {
          a: 1,
          k: [
            {
              i: { x: [0.833, 0.833, 0.833], y: [0.833, 0.833, 0.833] },
              o: { x: [0.167, 0.167, 0.167], y: [0.167, 0.167, 0.167] },
              t: 0,
              s: [15, 15, 100]
            },
            {
              i: { x: [0.833, 0.833, 0.833], y: [0.833, 0.833, 0.833] },
              o: { x: [0.167, 0.167, 0.167], y: [0.167, 0.167, 0.167] },
              t: 30,
              s: [42.8, 42.8, 100]
            },
            {
              i: { x: [0.833, 0.833, 0.833], y: [0.833, 0.833, 0.833] },
              o: { x: [0.167, 0.167, 0.167], y: [0.167, 0.167, 0.167] },
              t: 70,
              s: [19.2, 19.2, 100]
            },
            {
              i: { x: [0.833, 0.833, 0.833], y: [0.833, 0.833, 0.833] },
              o: { x: [0.167, 0.167, 0.167], y: [0.167, 0.167, 0.167] },
              t: 108,
              s: [30.005, 30.005, 100]
            },
            { t: 150.000006109625, s: [19, 19, 100] }
          ],
          ix: 6
        }
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              ty: "rc",
              d: 1,
              s: { a: 0, k: [7.582, 47.299], ix: 2 },
              p: { a: 0, k: [0, 0], ix: 3 },
              r: { a: 0, k: 0, ix: 4 },
              nm: "Rectangle Path 1",
              mn: "ADBE Vector Shape - Rect",
              hd: false
            },
            {
              ty: "st",
              c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 0, ix: 5 },
              lc: 1,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: "Stroke 1",
              mn: "ADBE Vector Graphic - Stroke",
              hd: false
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 0.611764705882, 0.2, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [-34.998, 1.043], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 90, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Rectangle 5",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false
        },
        {
          ty: "gr",
          it: [
            {
              ty: "rc",
              d: 1,
              s: { a: 0, k: [7.582, 47.299], ix: 2 },
              p: { a: 0, k: [0, 0], ix: 3 },
              r: { a: 0, k: 0, ix: 4 },
              nm: "Rectangle Path 1",
              mn: "ADBE Vector Shape - Rect",
              hd: false
            },
            {
              ty: "st",
              c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 0, ix: 5 },
              lc: 1,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: "Stroke 1",
              mn: "ADBE Vector Graphic - Stroke",
              hd: false
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 0.611764705882, 0.2, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [0.25, 36.72], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Rectangle 3",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 2,
          mn: "ADBE Vector Group",
          hd: false
        },
        {
          ty: "gr",
          it: [
            {
              ty: "rc",
              d: 1,
              s: { a: 0, k: [7.582, 47.299], ix: 2 },
              p: { a: 0, k: [0, 0], ix: 3 },
              r: { a: 0, k: 0, ix: 4 },
              nm: "Rectangle Path 1",
              mn: "ADBE Vector Shape - Rect",
              hd: false
            },
            {
              ty: "st",
              c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 0, ix: 5 },
              lc: 1,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: "Stroke 1",
              mn: "ADBE Vector Graphic - Stroke",
              hd: false
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 0.611764705882, 0.2, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [35.269, 1.06], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 90, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Rectangle 4",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 3,
          mn: "ADBE Vector Group",
          hd: false
        },
        {
          ty: "gr",
          it: [
            {
              ty: "rc",
              d: 1,
              s: { a: 0, k: [7.582, 47.299], ix: 2 },
              p: { a: 0, k: [0, 0], ix: 3 },
              r: { a: 0, k: 0, ix: 4 },
              nm: "Rectangle Path 1",
              mn: "ADBE Vector Shape - Rect",
              hd: false
            },
            {
              ty: "st",
              c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 0, ix: 5 },
              lc: 1,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: "Stroke 1",
              mn: "ADBE Vector Graphic - Stroke",
              hd: false
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 0.611764705882, 0.2, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [0.25, -33.75], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Rectangle 2",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 4,
          mn: "ADBE Vector Group",
          hd: false
        }
      ],
      ip: 0,
      op: 150.000006109625,
      st: 0,
      bm: 0
    },
    {
      ddd: 0,
      ind: 2,
      ty: 4,
      nm: "Shape Layer 53",
      sr: 1,
      ks: {
        o: {
          a: 1,
          k: [
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 0, s: [100] },
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 30, s: [82] },
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 54, s: [100] },
            { t: 150.000006109625, s: [0] }
          ],
          ix: 11
        },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.833, y: 0.833 },
              o: { x: 0.167, y: 0.167 },
              t: 0,
              s: [360.135, -305, 0],
              to: [0, 195.333, 0],
              ti: [0, -195.333, 0]
            },
            { t: 150.000006109625, s: [360.135, 867, 0] }
          ],
          ix: 2
        },
        a: { a: 0, k: [0.135, 1.485, 0], ix: 1 },
        s: {
          a: 1,
          k: [
            {
              i: { x: [0.833, 0.833, 0.833], y: [0.833, 0.833, 0.833] },
              o: { x: [0.167, 0.167, 0.167], y: [0.167, 0.167, 0.167] },
              t: 0,
              s: [15, 15, 100]
            },
            {
              i: { x: [0.833, 0.833, 0.833], y: [0.833, 0.833, 0.833] },
              o: { x: [0.167, 0.167, 0.167], y: [0.167, 0.167, 0.167] },
              t: 30,
              s: [42.8, 42.8, 100]
            },
            {
              i: { x: [0.833, 0.833, 0.833], y: [0.833, 0.833, 0.833] },
              o: { x: [0.167, 0.167, 0.167], y: [0.167, 0.167, 0.167] },
              t: 70,
              s: [19.2, 19.2, 100]
            },
            {
              i: { x: [0.833, 0.833, 0.833], y: [0.833, 0.833, 0.833] },
              o: { x: [0.167, 0.167, 0.167], y: [0.167, 0.167, 0.167] },
              t: 108,
              s: [30.005, 30.005, 100]
            },
            { t: 150.000006109625, s: [19, 19, 100] }
          ],
          ix: 6
        }
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              ty: "rc",
              d: 1,
              s: { a: 0, k: [7.582, 47.299], ix: 2 },
              p: { a: 0, k: [0, 0], ix: 3 },
              r: { a: 0, k: 0, ix: 4 },
              nm: "Rectangle Path 1",
              mn: "ADBE Vector Shape - Rect",
              hd: false
            },
            {
              ty: "st",
              c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 0, ix: 5 },
              lc: 1,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: "Stroke 1",
              mn: "ADBE Vector Graphic - Stroke",
              hd: false
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 0.611764705882, 0.2, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [-34.998, 1.043], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 90, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Rectangle 5",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false
        },
        {
          ty: "gr",
          it: [
            {
              ty: "rc",
              d: 1,
              s: { a: 0, k: [7.582, 47.299], ix: 2 },
              p: { a: 0, k: [0, 0], ix: 3 },
              r: { a: 0, k: 0, ix: 4 },
              nm: "Rectangle Path 1",
              mn: "ADBE Vector Shape - Rect",
              hd: false
            },
            {
              ty: "st",
              c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 0, ix: 5 },
              lc: 1,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: "Stroke 1",
              mn: "ADBE Vector Graphic - Stroke",
              hd: false
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 0.611764705882, 0.2, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [0.25, 36.72], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Rectangle 3",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 2,
          mn: "ADBE Vector Group",
          hd: false
        },
        {
          ty: "gr",
          it: [
            {
              ty: "rc",
              d: 1,
              s: { a: 0, k: [7.582, 47.299], ix: 2 },
              p: { a: 0, k: [0, 0], ix: 3 },
              r: { a: 0, k: 0, ix: 4 },
              nm: "Rectangle Path 1",
              mn: "ADBE Vector Shape - Rect",
              hd: false
            },
            {
              ty: "st",
              c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 0, ix: 5 },
              lc: 1,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: "Stroke 1",
              mn: "ADBE Vector Graphic - Stroke",
              hd: false
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 0.611764705882, 0.2, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [35.269, 1.06], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 90, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Rectangle 4",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 3,
          mn: "ADBE Vector Group",
          hd: false
        },
        {
          ty: "gr",
          it: [
            {
              ty: "rc",
              d: 1,
              s: { a: 0, k: [7.582, 47.299], ix: 2 },
              p: { a: 0, k: [0, 0], ix: 3 },
              r: { a: 0, k: 0, ix: 4 },
              nm: "Rectangle Path 1",
              mn: "ADBE Vector Shape - Rect",
              hd: false
            },
            {
              ty: "st",
              c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 0, ix: 5 },
              lc: 1,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: "Stroke 1",
              mn: "ADBE Vector Graphic - Stroke",
              hd: false
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 0.611764705882, 0.2, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [0.25, -33.75], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Rectangle 2",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 4,
          mn: "ADBE Vector Group",
          hd: false
        }
      ],
      ip: 0,
      op: 150.000006109625,
      st: 0,
      bm: 0
    },
    {
      ddd: 0,
      ind: 3,
      ty: 4,
      nm: "Shape Layer 52",
      sr: 1,
      ks: {
        o: {
          a: 1,
          k: [
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 0, s: [100] },
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 30, s: [82] },
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 54, s: [100] },
            { t: 150.000006109625, s: [0] }
          ],
          ix: 11
        },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.833, y: 0.833 },
              o: { x: 0.167, y: 0.167 },
              t: 0,
              s: [426.135, -49, 0],
              to: [0, 195.333, 0],
              ti: [0, -195.333, 0]
            },
            { t: 150.000006109625, s: [426.135, 1123, 0] }
          ],
          ix: 2
        },
        a: { a: 0, k: [0.135, 1.485, 0], ix: 1 },
        s: {
          a: 1,
          k: [
            {
              i: { x: [0.833, 0.833, 0.833], y: [0.833, 0.833, 0.833] },
              o: { x: [0.167, 0.167, 0.167], y: [0.167, 0.167, 0.167] },
              t: 0,
              s: [6, 6, 100]
            },
            {
              i: { x: [0.833, 0.833, 0.833], y: [0.833, 0.833, 0.833] },
              o: { x: [0.167, 0.167, 0.167], y: [0.167, 0.167, 0.167] },
              t: 30,
              s: [13.8, 13.8, 100]
            },
            {
              i: { x: [0.833, 0.833, 0.833], y: [0.833, 0.833, 0.833] },
              o: { x: [0.167, 0.167, 0.167], y: [0.167, 0.167, 0.167] },
              t: 70,
              s: [4.2, 4.2, 100]
            },
            {
              i: { x: [0.833, 0.833, 0.833], y: [0.833, 0.833, 0.833] },
              o: { x: [0.167, 0.167, 0.167], y: [0.167, 0.167, 0.167] },
              t: 108,
              s: [10.005, 10.005, 100]
            },
            { t: 150.000006109625, s: [19, 19, 100] }
          ],
          ix: 6
        }
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              ty: "rc",
              d: 1,
              s: { a: 0, k: [7.582, 47.299], ix: 2 },
              p: { a: 0, k: [0, 0], ix: 3 },
              r: { a: 0, k: 0, ix: 4 },
              nm: "Rectangle Path 1",
              mn: "ADBE Vector Shape - Rect",
              hd: false
            },
            {
              ty: "st",
              c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 0, ix: 5 },
              lc: 1,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: "Stroke 1",
              mn: "ADBE Vector Graphic - Stroke",
              hd: false
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 0.611764705882, 0.2, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [-34.998, 1.043], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 90, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Rectangle 5",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false
        },
        {
          ty: "gr",
          it: [
            {
              ty: "rc",
              d: 1,
              s: { a: 0, k: [7.582, 47.299], ix: 2 },
              p: { a: 0, k: [0, 0], ix: 3 },
              r: { a: 0, k: 0, ix: 4 },
              nm: "Rectangle Path 1",
              mn: "ADBE Vector Shape - Rect",
              hd: false
            },
            {
              ty: "st",
              c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 0, ix: 5 },
              lc: 1,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: "Stroke 1",
              mn: "ADBE Vector Graphic - Stroke",
              hd: false
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 0.611764705882, 0.2, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [0.25, 36.72], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Rectangle 3",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 2,
          mn: "ADBE Vector Group",
          hd: false
        },
        {
          ty: "gr",
          it: [
            {
              ty: "rc",
              d: 1,
              s: { a: 0, k: [7.582, 47.299], ix: 2 },
              p: { a: 0, k: [0, 0], ix: 3 },
              r: { a: 0, k: 0, ix: 4 },
              nm: "Rectangle Path 1",
              mn: "ADBE Vector Shape - Rect",
              hd: false
            },
            {
              ty: "st",
              c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 0, ix: 5 },
              lc: 1,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: "Stroke 1",
              mn: "ADBE Vector Graphic - Stroke",
              hd: false
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 0.611764705882, 0.2, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [35.269, 1.06], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 90, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Rectangle 4",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 3,
          mn: "ADBE Vector Group",
          hd: false
        },
        {
          ty: "gr",
          it: [
            {
              ty: "rc",
              d: 1,
              s: { a: 0, k: [7.582, 47.299], ix: 2 },
              p: { a: 0, k: [0, 0], ix: 3 },
              r: { a: 0, k: 0, ix: 4 },
              nm: "Rectangle Path 1",
              mn: "ADBE Vector Shape - Rect",
              hd: false
            },
            {
              ty: "st",
              c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 0, ix: 5 },
              lc: 1,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: "Stroke 1",
              mn: "ADBE Vector Graphic - Stroke",
              hd: false
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 0.611764705882, 0.2, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [0.25, -33.75], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Rectangle 2",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 4,
          mn: "ADBE Vector Group",
          hd: false
        }
      ],
      ip: 0,
      op: 150.000006109625,
      st: 0,
      bm: 0
    },
    {
      ddd: 0,
      ind: 4,
      ty: 4,
      nm: "Shape Layer 51",
      sr: 1,
      ks: {
        o: {
          a: 1,
          k: [
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 0, s: [100] },
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 30, s: [100] },
            { t: 150.000006109625, s: [0] }
          ],
          ix: 11
        },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.833, y: 0.833 },
              o: { x: 0.167, y: 0.167 },
              t: 0,
              s: [266.135, -515, 0],
              to: [0, 167.333, 0],
              ti: [0, -167.333, 0]
            },
            { t: 150.000006109625, s: [266.135, 489, 0] }
          ],
          ix: 2
        },
        a: { a: 0, k: [0.135, 1.485, 0], ix: 1 },
        s: {
          a: 1,
          k: [
            {
              i: { x: [0.833, 0.833, 0.833], y: [0.833, 0.833, 0.833] },
              o: { x: [0.167, 0.167, 0.167], y: [0.167, 0.167, 0.167] },
              t: 15,
              s: [11, 11, 100]
            },
            {
              i: { x: [0.833, 0.833, 0.833], y: [0.833, 0.833, 0.833] },
              o: { x: [0.167, 0.167, 0.167], y: [0.167, 0.167, 0.167] },
              t: 20,
              s: [36, 36, 100]
            },
            { t: 133.000005417201, s: [19, 19, 100] }
          ],
          ix: 6
        }
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              ty: "rc",
              d: 1,
              s: { a: 0, k: [7.582, 47.299], ix: 2 },
              p: { a: 0, k: [0, 0], ix: 3 },
              r: { a: 0, k: 0, ix: 4 },
              nm: "Rectangle Path 1",
              mn: "ADBE Vector Shape - Rect",
              hd: false
            },
            {
              ty: "st",
              c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 0, ix: 5 },
              lc: 1,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: "Stroke 1",
              mn: "ADBE Vector Graphic - Stroke",
              hd: false
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 0.611764705882, 0.2, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [-34.998, 1.043], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 90, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Rectangle 5",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false
        },
        {
          ty: "gr",
          it: [
            {
              ty: "rc",
              d: 1,
              s: { a: 0, k: [7.582, 47.299], ix: 2 },
              p: { a: 0, k: [0, 0], ix: 3 },
              r: { a: 0, k: 0, ix: 4 },
              nm: "Rectangle Path 1",
              mn: "ADBE Vector Shape - Rect",
              hd: false
            },
            {
              ty: "st",
              c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 0, ix: 5 },
              lc: 1,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: "Stroke 1",
              mn: "ADBE Vector Graphic - Stroke",
              hd: false
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 0.611764705882, 0.2, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [0.25, 36.72], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Rectangle 3",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 2,
          mn: "ADBE Vector Group",
          hd: false
        },
        {
          ty: "gr",
          it: [
            {
              ty: "rc",
              d: 1,
              s: { a: 0, k: [7.582, 47.299], ix: 2 },
              p: { a: 0, k: [0, 0], ix: 3 },
              r: { a: 0, k: 0, ix: 4 },
              nm: "Rectangle Path 1",
              mn: "ADBE Vector Shape - Rect",
              hd: false
            },
            {
              ty: "st",
              c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 0, ix: 5 },
              lc: 1,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: "Stroke 1",
              mn: "ADBE Vector Graphic - Stroke",
              hd: false
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 0.611764705882, 0.2, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [35.269, 1.06], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 90, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Rectangle 4",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 3,
          mn: "ADBE Vector Group",
          hd: false
        },
        {
          ty: "gr",
          it: [
            {
              ty: "rc",
              d: 1,
              s: { a: 0, k: [7.582, 47.299], ix: 2 },
              p: { a: 0, k: [0, 0], ix: 3 },
              r: { a: 0, k: 0, ix: 4 },
              nm: "Rectangle Path 1",
              mn: "ADBE Vector Shape - Rect",
              hd: false
            },
            {
              ty: "st",
              c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 0, ix: 5 },
              lc: 1,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: "Stroke 1",
              mn: "ADBE Vector Graphic - Stroke",
              hd: false
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 0.611764705882, 0.2, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [0.25, -33.75], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Rectangle 2",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 4,
          mn: "ADBE Vector Group",
          hd: false
        }
      ],
      ip: 0,
      op: 150.000006109625,
      st: 0,
      bm: 0
    },
    {
      ddd: 0,
      ind: 5,
      ty: 4,
      nm: "Shape Layer 50",
      sr: 1,
      ks: {
        o: {
          a: 1,
          k: [
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 0, s: [100] },
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 30, s: [100] },
            { t: 149.000006068894, s: [0] }
          ],
          ix: 11
        },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.833, y: 0.833 },
              o: { x: 0.167, y: 0.167 },
              t: 0,
              s: [284.135, -119, 0],
              to: [0, 173.667, 0],
              ti: [0, -173.667, 0]
            },
            { t: 174.000007087165, s: [284.135, 923, 0] }
          ],
          ix: 2
        },
        a: { a: 0, k: [0.135, 1.485, 0], ix: 1 },
        s: {
          a: 1,
          k: [
            {
              i: { x: [0.833, 0.833, 0.833], y: [0.833, 0.833, 0.833] },
              o: { x: [0.167, 0.167, 0.167], y: [0.167, 0.167, 0.167] },
              t: 15,
              s: [11, 11, 100]
            },
            {
              i: { x: [0.833, 0.833, 0.833], y: [0.833, 0.833, 0.833] },
              o: { x: [0.167, 0.167, 0.167], y: [0.167, 0.167, 0.167] },
              t: 25,
              s: [17.678, 17.678, 100]
            },
            {
              i: { x: [0.833, 0.833, 0.833], y: [0.833, 0.833, 0.833] },
              o: { x: [0.167, 0.167, 0.167], y: [0.167, 0.167, 0.167] },
              t: 37,
              s: [10.825, 10.825, 100]
            },
            { t: 133.000005417201, s: [19, 19, 100] }
          ],
          ix: 6
        }
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              ty: "rc",
              d: 1,
              s: { a: 0, k: [7.582, 47.299], ix: 2 },
              p: { a: 0, k: [0, 0], ix: 3 },
              r: { a: 0, k: 0, ix: 4 },
              nm: "Rectangle Path 1",
              mn: "ADBE Vector Shape - Rect",
              hd: false
            },
            {
              ty: "st",
              c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 0, ix: 5 },
              lc: 1,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: "Stroke 1",
              mn: "ADBE Vector Graphic - Stroke",
              hd: false
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 0.611764705882, 0.2, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [-34.998, 1.043], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 90, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Rectangle 5",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false
        },
        {
          ty: "gr",
          it: [
            {
              ty: "rc",
              d: 1,
              s: { a: 0, k: [7.582, 47.299], ix: 2 },
              p: { a: 0, k: [0, 0], ix: 3 },
              r: { a: 0, k: 0, ix: 4 },
              nm: "Rectangle Path 1",
              mn: "ADBE Vector Shape - Rect",
              hd: false
            },
            {
              ty: "st",
              c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 0, ix: 5 },
              lc: 1,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: "Stroke 1",
              mn: "ADBE Vector Graphic - Stroke",
              hd: false
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 0.611764705882, 0.2, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [0.25, 36.72], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Rectangle 3",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 2,
          mn: "ADBE Vector Group",
          hd: false
        },
        {
          ty: "gr",
          it: [
            {
              ty: "rc",
              d: 1,
              s: { a: 0, k: [7.582, 47.299], ix: 2 },
              p: { a: 0, k: [0, 0], ix: 3 },
              r: { a: 0, k: 0, ix: 4 },
              nm: "Rectangle Path 1",
              mn: "ADBE Vector Shape - Rect",
              hd: false
            },
            {
              ty: "st",
              c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 0, ix: 5 },
              lc: 1,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: "Stroke 1",
              mn: "ADBE Vector Graphic - Stroke",
              hd: false
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 0.611764705882, 0.2, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [35.269, 1.06], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 90, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Rectangle 4",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 3,
          mn: "ADBE Vector Group",
          hd: false
        },
        {
          ty: "gr",
          it: [
            {
              ty: "rc",
              d: 1,
              s: { a: 0, k: [7.582, 47.299], ix: 2 },
              p: { a: 0, k: [0, 0], ix: 3 },
              r: { a: 0, k: 0, ix: 4 },
              nm: "Rectangle Path 1",
              mn: "ADBE Vector Shape - Rect",
              hd: false
            },
            {
              ty: "st",
              c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 0, ix: 5 },
              lc: 1,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: "Stroke 1",
              mn: "ADBE Vector Graphic - Stroke",
              hd: false
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 0.611764705882, 0.2, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [0.25, -33.75], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Rectangle 2",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 4,
          mn: "ADBE Vector Group",
          hd: false
        }
      ],
      ip: 0,
      op: 150.000006109625,
      st: 0,
      bm: 0
    },
    {
      ddd: 0,
      ind: 6,
      ty: 4,
      nm: "Shape Layer 49",
      sr: 1,
      ks: {
        o: {
          a: 1,
          k: [
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 0, s: [100] },
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 30, s: [100] },
            { t: 150.000006109625, s: [0] }
          ],
          ix: 11
        },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.833, y: 0.833 },
              o: { x: 0.167, y: 0.167 },
              t: 0,
              s: [420.135, -583, 0],
              to: [0, 167.333, 0],
              ti: [0, -167.333, 0]
            },
            { t: 150.000006109625, s: [420.135, 421, 0] }
          ],
          ix: 2
        },
        a: { a: 0, k: [0.135, 1.485, 0], ix: 1 },
        s: {
          a: 1,
          k: [
            {
              i: { x: [0.833, 0.833, 0.833], y: [0.833, 0.833, 0.833] },
              o: { x: [0.167, 0.167, 0.167], y: [0.167, 0.167, 0.167] },
              t: 15,
              s: [11, 11, 100]
            },
            {
              i: { x: [0.833, 0.833, 0.833], y: [0.833, 0.833, 0.833] },
              o: { x: [0.167, 0.167, 0.167], y: [0.167, 0.167, 0.167] },
              t: 20,
              s: [36, 36, 100]
            },
            { t: 133.000005417201, s: [19, 19, 100] }
          ],
          ix: 6
        }
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              ty: "rc",
              d: 1,
              s: { a: 0, k: [7.582, 47.299], ix: 2 },
              p: { a: 0, k: [0, 0], ix: 3 },
              r: { a: 0, k: 0, ix: 4 },
              nm: "Rectangle Path 1",
              mn: "ADBE Vector Shape - Rect",
              hd: false
            },
            {
              ty: "st",
              c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 0, ix: 5 },
              lc: 1,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: "Stroke 1",
              mn: "ADBE Vector Graphic - Stroke",
              hd: false
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 0.611764705882, 0.2, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [-34.998, 1.043], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 90, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Rectangle 5",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false
        },
        {
          ty: "gr",
          it: [
            {
              ty: "rc",
              d: 1,
              s: { a: 0, k: [7.582, 47.299], ix: 2 },
              p: { a: 0, k: [0, 0], ix: 3 },
              r: { a: 0, k: 0, ix: 4 },
              nm: "Rectangle Path 1",
              mn: "ADBE Vector Shape - Rect",
              hd: false
            },
            {
              ty: "st",
              c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 0, ix: 5 },
              lc: 1,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: "Stroke 1",
              mn: "ADBE Vector Graphic - Stroke",
              hd: false
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 0.611764705882, 0.2, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [0.25, 36.72], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Rectangle 3",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 2,
          mn: "ADBE Vector Group",
          hd: false
        },
        {
          ty: "gr",
          it: [
            {
              ty: "rc",
              d: 1,
              s: { a: 0, k: [7.582, 47.299], ix: 2 },
              p: { a: 0, k: [0, 0], ix: 3 },
              r: { a: 0, k: 0, ix: 4 },
              nm: "Rectangle Path 1",
              mn: "ADBE Vector Shape - Rect",
              hd: false
            },
            {
              ty: "st",
              c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 0, ix: 5 },
              lc: 1,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: "Stroke 1",
              mn: "ADBE Vector Graphic - Stroke",
              hd: false
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 0.611764705882, 0.2, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [35.269, 1.06], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 90, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Rectangle 4",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 3,
          mn: "ADBE Vector Group",
          hd: false
        },
        {
          ty: "gr",
          it: [
            {
              ty: "rc",
              d: 1,
              s: { a: 0, k: [7.582, 47.299], ix: 2 },
              p: { a: 0, k: [0, 0], ix: 3 },
              r: { a: 0, k: 0, ix: 4 },
              nm: "Rectangle Path 1",
              mn: "ADBE Vector Shape - Rect",
              hd: false
            },
            {
              ty: "st",
              c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 0, ix: 5 },
              lc: 1,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: "Stroke 1",
              mn: "ADBE Vector Graphic - Stroke",
              hd: false
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 0.611764705882, 0.2, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [0.25, -33.75], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Rectangle 2",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 4,
          mn: "ADBE Vector Group",
          hd: false
        }
      ],
      ip: 0,
      op: 150.000006109625,
      st: 0,
      bm: 0
    },
    {
      ddd: 0,
      ind: 7,
      ty: 4,
      nm: "Shape Layer 48",
      sr: 1,
      ks: {
        o: {
          a: 1,
          k: [
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 0, s: [80] },
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 20, s: [100] },
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 40, s: [100] },
            { t: 150.000006109625, s: [0] }
          ],
          ix: 11
        },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.833, y: 0.833 },
              o: { x: 0.167, y: 0.167 },
              t: 0,
              s: [364, -758.25, 0],
              to: [0, 8.18, 0],
              ti: [0, -166.487, 0]
            },
            { t: 150.000006109625, s: [364, 645.75, 0] }
          ],
          ix: 2
        },
        a: { a: 0, k: [0, 0, 0], ix: 1 },
        s: { a: 0, k: [0.72, 1.263, 100], ix: 6 }
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              d: 1,
              ty: "el",
              s: { a: 0, k: [1820, 1024], ix: 2 },
              p: { a: 0, k: [0, 0], ix: 3 },
              nm: "Ellipse Path 1",
              mn: "ADBE Vector Shape - Ellipse",
              hd: false
            },
            {
              ty: "st",
              c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 0, ix: 5 },
              lc: 1,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: "Stroke 1",
              mn: "ADBE Vector Graphic - Stroke",
              hd: false
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 0.611764705882, 0.2, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [0, 0], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Ellipse 1",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false
        }
      ],
      ip: 0,
      op: 150.000006109625,
      st: 0,
      bm: 0
    },
    {
      ddd: 0,
      ind: 8,
      ty: 4,
      nm: "Shape Layer 47",
      sr: 1,
      ks: {
        o: {
          a: 1,
          k: [
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 0, s: [80] },
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 20, s: [100] },
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 40, s: [100] },
            { t: 150.000006109625, s: [0] }
          ],
          ix: 11
        },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.833, y: 0.833 },
              o: { x: 0.167, y: 0.167 },
              t: 0,
              s: [418, -712.25, 0],
              to: [0, 8.18, 0],
              ti: [0, -166.487, 0]
            },
            { t: 150.000006109625, s: [418, 335.75, 0] }
          ],
          ix: 2
        },
        a: { a: 0, k: [0, 0, 0], ix: 1 },
        s: { a: 0, k: [0.72, 1.263, 100], ix: 6 }
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              d: 1,
              ty: "el",
              s: { a: 0, k: [1820, 1024], ix: 2 },
              p: { a: 0, k: [0, 0], ix: 3 },
              nm: "Ellipse Path 1",
              mn: "ADBE Vector Shape - Ellipse",
              hd: false
            },
            {
              ty: "st",
              c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 0, ix: 5 },
              lc: 1,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: "Stroke 1",
              mn: "ADBE Vector Graphic - Stroke",
              hd: false
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 0.611764705882, 0.2, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [0, 0], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Ellipse 1",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false
        }
      ],
      ip: 0,
      op: 150.000006109625,
      st: 0,
      bm: 0
    },
    {
      ddd: 0,
      ind: 9,
      ty: 4,
      nm: "Shape Layer 46",
      sr: 1,
      ks: {
        o: {
          a: 1,
          k: [
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 0, s: [80] },
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 20, s: [100] },
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 40, s: [100] },
            { t: 150.000006109625, s: [0] }
          ],
          ix: 11
        },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.833, y: 0.833 },
              o: { x: 0.167, y: 0.167 },
              t: 0,
              s: [312, -48.25, 0],
              to: [0, 8.18, 0],
              ti: [0, -166.487, 0]
            },
            { t: 150.000006109625, s: [312, 999.75, 0] }
          ],
          ix: 2
        },
        a: { a: 0, k: [0, 0, 0], ix: 1 },
        s: { a: 0, k: [0.72, 1.263, 100], ix: 6 }
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              d: 1,
              ty: "el",
              s: { a: 0, k: [1820, 1024], ix: 2 },
              p: { a: 0, k: [0, 0], ix: 3 },
              nm: "Ellipse Path 1",
              mn: "ADBE Vector Shape - Ellipse",
              hd: false
            },
            {
              ty: "st",
              c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 0, ix: 5 },
              lc: 1,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: "Stroke 1",
              mn: "ADBE Vector Graphic - Stroke",
              hd: false
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 0.611764705882, 0.2, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [0, 0], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Ellipse 1",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false
        }
      ],
      ip: 0,
      op: 150.000006109625,
      st: 0,
      bm: 0
    },
    {
      ddd: 0,
      ind: 10,
      ty: 4,
      nm: "Shape Layer 45",
      sr: 1,
      ks: {
        o: {
          a: 1,
          k: [
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 0, s: [80] },
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 20, s: [100] },
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 40, s: [100] },
            { t: 150.000006109625, s: [0] }
          ],
          ix: 11
        },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.833, y: 0.833 },
              o: { x: 0.167, y: 0.167 },
              t: 0,
              s: [314, -528.25, 0],
              to: [0, 9.163, 0],
              ti: [0, -186.503, 0]
            },
            { t: 150.000006109625, s: [314, 645.75, 0] }
          ],
          ix: 2
        },
        a: { a: 0, k: [0, 0, 0], ix: 1 },
        s: { a: 0, k: [1.71, 3, 100], ix: 6 }
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              d: 1,
              ty: "el",
              s: { a: 0, k: [1820, 1024], ix: 2 },
              p: { a: 0, k: [0, 0], ix: 3 },
              nm: "Ellipse Path 1",
              mn: "ADBE Vector Shape - Ellipse",
              hd: false
            },
            {
              ty: "st",
              c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 0, ix: 5 },
              lc: 1,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: "Stroke 1",
              mn: "ADBE Vector Graphic - Stroke",
              hd: false
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 0.611764705882, 0.2, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [0, 0], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Ellipse 1",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false
        }
      ],
      ip: 0,
      op: 150.000006109625,
      st: 0,
      bm: 0
    },
    {
      ddd: 0,
      ind: 11,
      ty: 4,
      nm: "Shape Layer 44",
      sr: 1,
      ks: {
        o: {
          a: 1,
          k: [
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 0, s: [80] },
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 20, s: [100] },
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 40, s: [100] },
            { t: 150.000006109625, s: [0] }
          ],
          ix: 11
        },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.833, y: 0.833 },
              o: { x: 0.167, y: 0.167 },
              t: 4,
              s: [342, -112.942, 0],
              to: [0, 236.455, 0],
              ti: [0, -186.503, 0]
            },
            { t: 150.000006109625, s: [342, 1029.75, 0] }
          ],
          ix: 2
        },
        a: { a: 0, k: [0, 0, 0], ix: 1 },
        s: { a: 0, k: [1.71, 3, 100], ix: 6 }
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              d: 1,
              ty: "el",
              s: { a: 0, k: [1820, 1024], ix: 2 },
              p: { a: 0, k: [0, 0], ix: 3 },
              nm: "Ellipse Path 1",
              mn: "ADBE Vector Shape - Ellipse",
              hd: false
            },
            {
              ty: "st",
              c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 0, ix: 5 },
              lc: 1,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: "Stroke 1",
              mn: "ADBE Vector Graphic - Stroke",
              hd: false
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 0.611764705882, 0.2, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [0, 0], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Ellipse 1",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false
        }
      ],
      ip: 0,
      op: 150.000006109625,
      st: 0,
      bm: 0
    },
    {
      ddd: 0,
      ind: 12,
      ty: 4,
      nm: "Shape Layer 43",
      sr: 1,
      ks: {
        o: {
          a: 1,
          k: [
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 0, s: [80] },
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 10, s: [100] },
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 61, s: [100] },
            { t: 134.000005457932, s: [0] }
          ],
          ix: 11
        },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.833, y: 0.833 },
              o: { x: 0.167, y: 0.167 },
              t: 4,
              s: [254, -292.25, 0],
              to: [0, 152.333, 0],
              ti: [0, -152.333, 0]
            },
            { t: 136.000005539394, s: [254, 621.75, 0] }
          ],
          ix: 2
        },
        a: { a: 0, k: [0, 0, 0], ix: 1 },
        s: { a: 0, k: [1.425, 2.5, 100], ix: 6 }
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              d: 1,
              ty: "el",
              s: { a: 0, k: [1820, 1024], ix: 2 },
              p: { a: 0, k: [0, 0], ix: 3 },
              nm: "Ellipse Path 1",
              mn: "ADBE Vector Shape - Ellipse",
              hd: false
            },
            {
              ty: "st",
              c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 0, ix: 5 },
              lc: 1,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: "Stroke 1",
              mn: "ADBE Vector Graphic - Stroke",
              hd: false
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 0.611764705882, 0.2, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [0, 0], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Ellipse 1",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false
        }
      ],
      ip: 0,
      op: 150.000006109625,
      st: 0,
      bm: 0
    },
    {
      ddd: 0,
      ind: 13,
      ty: 4,
      nm: "Shape Layer 42",
      sr: 1,
      ks: {
        o: {
          a: 1,
          k: [
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 0, s: [80] },
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 10, s: [100] },
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 61, s: [100] },
            { t: 134.000005457932, s: [0] }
          ],
          ix: 11
        },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.833, y: 0.833 },
              o: { x: 0.167, y: 0.167 },
              t: 4,
              s: [436, -386.25, 0],
              to: [0, 152.333, 0],
              ti: [0, -152.333, 0]
            },
            { t: 136.000005539394, s: [436, 527.75, 0] }
          ],
          ix: 2
        },
        a: { a: 0, k: [0, 0, 0], ix: 1 },
        s: { a: 0, k: [1.425, 2.5, 100], ix: 6 }
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              d: 1,
              ty: "el",
              s: { a: 0, k: [1820, 1024], ix: 2 },
              p: { a: 0, k: [0, 0], ix: 3 },
              nm: "Ellipse Path 1",
              mn: "ADBE Vector Shape - Ellipse",
              hd: false
            },
            {
              ty: "st",
              c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 0, ix: 5 },
              lc: 1,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: "Stroke 1",
              mn: "ADBE Vector Graphic - Stroke",
              hd: false
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 0.611764705882, 0.2, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [0, 0], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Ellipse 1",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false
        }
      ],
      ip: 0,
      op: 150.000006109625,
      st: 0,
      bm: 0
    },
    {
      ddd: 0,
      ind: 14,
      ty: 4,
      nm: "Shape Layer 41",
      sr: 1,
      ks: {
        o: {
          a: 1,
          k: [
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 0, s: [80] },
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 10, s: [100] },
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 61, s: [100] },
            { t: 134.000005457932, s: [0] }
          ],
          ix: 11
        },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.833, y: 0.833 },
              o: { x: 0.167, y: 0.167 },
              t: 4,
              s: [284, -790.25, 0],
              to: [0, 152.333, 0],
              ti: [0, -152.333, 0]
            },
            { t: 136.000005539394, s: [284, 123.75, 0] }
          ],
          ix: 2
        },
        a: { a: 0, k: [0, 0, 0], ix: 1 },
        s: { a: 0, k: [1.425, 2.5, 100], ix: 6 }
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              d: 1,
              ty: "el",
              s: { a: 0, k: [1820, 1024], ix: 2 },
              p: { a: 0, k: [0, 0], ix: 3 },
              nm: "Ellipse Path 1",
              mn: "ADBE Vector Shape - Ellipse",
              hd: false
            },
            {
              ty: "st",
              c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 0, ix: 5 },
              lc: 1,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: "Stroke 1",
              mn: "ADBE Vector Graphic - Stroke",
              hd: false
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 0.611764705882, 0.2, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [0, 0], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Ellipse 1",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false
        }
      ],
      ip: 0,
      op: 150.000006109625,
      st: 0,
      bm: 0
    },
    {
      ddd: 0,
      ind: 15,
      ty: 4,
      nm: "Shape Layer 40",
      sr: 1,
      ks: {
        o: {
          a: 1,
          k: [
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 0, s: [80] },
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 20, s: [100] },
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 40, s: [100] },
            { t: 150.000006109625, s: [0] }
          ],
          ix: 11
        },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.833, y: 0.833 },
              o: { x: 0.167, y: 0.167 },
              t: 0,
              s: [396, -302.25, 0],
              to: [0, 8.18, 0],
              ti: [0, -166.487, 0]
            },
            { t: 150.000006109625, s: [396, 745.75, 0] }
          ],
          ix: 2
        },
        a: { a: 0, k: [0, 0, 0], ix: 1 },
        s: { a: 0, k: [0.72, 1.263, 100], ix: 6 }
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              d: 1,
              ty: "el",
              s: { a: 0, k: [1820, 1024], ix: 2 },
              p: { a: 0, k: [0, 0], ix: 3 },
              nm: "Ellipse Path 1",
              mn: "ADBE Vector Shape - Ellipse",
              hd: false
            },
            {
              ty: "st",
              c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 0, ix: 5 },
              lc: 1,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: "Stroke 1",
              mn: "ADBE Vector Graphic - Stroke",
              hd: false
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 0.611764705882, 0.2, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [0, 0], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Ellipse 1",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false
        }
      ],
      ip: 0,
      op: 150.000006109625,
      st: 0,
      bm: 0
    },
    {
      ddd: 0,
      ind: 16,
      ty: 4,
      nm: "Shape Layer 39",
      sr: 1,
      ks: {
        o: {
          a: 1,
          k: [
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 0, s: [80] },
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 20, s: [80] },
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 40, s: [50] },
            { t: 150.000006109625, s: [0] }
          ],
          ix: 11
        },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.833, y: 0.833 },
              o: { x: 0.167, y: 0.167 },
              t: 0,
              s: [416, -218.25, 0],
              to: [0, 9.866, 0],
              ti: [0, -200.801, 0]
            },
            { t: 150.000006109625, s: [416, 449.75, 0] }
          ],
          ix: 2
        },
        a: { a: 0, k: [0, 0, 0], ix: 1 },
        s: { a: 0, k: [1.71, 3, 100], ix: 6 }
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              d: 1,
              ty: "el",
              s: { a: 0, k: [1820, 1024], ix: 2 },
              p: { a: 0, k: [0, 0], ix: 3 },
              nm: "Ellipse Path 1",
              mn: "ADBE Vector Shape - Ellipse",
              hd: false
            },
            {
              ty: "st",
              c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 0, ix: 5 },
              lc: 1,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: "Stroke 1",
              mn: "ADBE Vector Graphic - Stroke",
              hd: false
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 0.611764705882, 0.2, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [0, 0], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Ellipse 1",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false
        }
      ],
      ip: 0,
      op: 150.000006109625,
      st: 0,
      bm: 0
    },
    {
      ddd: 0,
      ind: 17,
      ty: 4,
      nm: "Shape Layer 38",
      sr: 1,
      ks: {
        o: {
          a: 1,
          k: [
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 0, s: [80] },
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 20, s: [80] },
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 40, s: [50] },
            { t: 150.000006109625, s: [0] }
          ],
          ix: 11
        },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.833, y: 0.833 },
              o: { x: 0.167, y: 0.167 },
              t: 0,
              s: [428, -246.25, 0],
              to: [0, 9.866, 0],
              ti: [0, -200.801, 0]
            },
            { t: 150.000006109625, s: [428, 1017.75, 0] }
          ],
          ix: 2
        },
        a: { a: 0, k: [0, 0, 0], ix: 1 },
        s: { a: 0, k: [1.71, 3, 100], ix: 6 }
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              d: 1,
              ty: "el",
              s: { a: 0, k: [1820, 1024], ix: 2 },
              p: { a: 0, k: [0, 0], ix: 3 },
              nm: "Ellipse Path 1",
              mn: "ADBE Vector Shape - Ellipse",
              hd: false
            },
            {
              ty: "st",
              c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 0, ix: 5 },
              lc: 1,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: "Stroke 1",
              mn: "ADBE Vector Graphic - Stroke",
              hd: false
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 0.611764705882, 0.2, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [0, 0], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Ellipse 1",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false
        }
      ],
      ip: 0,
      op: 150.000006109625,
      st: 0,
      bm: 0
    },
    {
      ddd: 0,
      ind: 18,
      ty: 4,
      nm: "Shape Layer 37",
      sr: 1,
      ks: {
        o: {
          a: 1,
          k: [
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 0, s: [80] },
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 20, s: [80] },
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 40, s: [50] },
            { t: 150.000006109625, s: [0] }
          ],
          ix: 11
        },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.833, y: 0.833 },
              o: { x: 0.167, y: 0.167 },
              t: 0,
              s: [300, -450.25, 0],
              to: [0, 9.866, 0],
              ti: [0, -200.801, 0]
            },
            { t: 150.000006109625, s: [300, 813.75, 0] }
          ],
          ix: 2
        },
        a: { a: 0, k: [0, 0, 0], ix: 1 },
        s: { a: 0, k: [1.71, 3, 100], ix: 6 }
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              d: 1,
              ty: "el",
              s: { a: 0, k: [1820, 1024], ix: 2 },
              p: { a: 0, k: [0, 0], ix: 3 },
              nm: "Ellipse Path 1",
              mn: "ADBE Vector Shape - Ellipse",
              hd: false
            },
            {
              ty: "st",
              c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 0, ix: 5 },
              lc: 1,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: "Stroke 1",
              mn: "ADBE Vector Graphic - Stroke",
              hd: false
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 0.611764705882, 0.2, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [0, 0], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Ellipse 1",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false
        }
      ],
      ip: 0,
      op: 150.000006109625,
      st: 0,
      bm: 0
    },
    {
      ddd: 0,
      ind: 19,
      ty: 4,
      nm: "Shape Layer 36",
      sr: 1,
      ks: {
        o: {
          a: 1,
          k: [
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 0, s: [80] },
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 20, s: [80] },
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 40, s: [50] },
            { t: 150.000006109625, s: [0] }
          ],
          ix: 11
        },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.833, y: 0.833 },
              o: { x: 0.167, y: 0.167 },
              t: 0,
              s: [324, -756.25, 0],
              to: [0, 9.866, 0],
              ti: [0, -200.801, 0]
            },
            { t: 150.000006109625, s: [324, 507.75, 0] }
          ],
          ix: 2
        },
        a: { a: 0, k: [0, 0, 0], ix: 1 },
        s: { a: 0, k: [1.71, 3, 100], ix: 6 }
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              d: 1,
              ty: "el",
              s: { a: 0, k: [1820, 1024], ix: 2 },
              p: { a: 0, k: [0, 0], ix: 3 },
              nm: "Ellipse Path 1",
              mn: "ADBE Vector Shape - Ellipse",
              hd: false
            },
            {
              ty: "st",
              c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 0, ix: 5 },
              lc: 1,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: "Stroke 1",
              mn: "ADBE Vector Graphic - Stroke",
              hd: false
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 0.611764705882, 0.2, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [0, 0], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Ellipse 1",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false
        }
      ],
      ip: 0,
      op: 150.000006109625,
      st: 0,
      bm: 0
    },
    {
      ddd: 0,
      ind: 20,
      ty: 4,
      nm: "Shape Layer 35",
      sr: 1,
      ks: {
        o: {
          a: 1,
          k: [
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 0, s: [80] },
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 47, s: [80] },
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 92, s: [100] },
            { t: 150.000006109625, s: [0] }
          ],
          ix: 11
        },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.833, y: 0.833 },
              o: { x: 0.167, y: 0.167 },
              t: 4,
              s: [372, -498.25, 0],
              to: [0, 178, 0],
              ti: [0, -178, 0]
            },
            { t: 150.000006109625, s: [372, 569.75, 0] }
          ],
          ix: 2
        },
        a: { a: 0, k: [0, 0, 0], ix: 1 },
        s: { a: 0, k: [1.14, 2, 100], ix: 6 }
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              d: 1,
              ty: "el",
              s: { a: 0, k: [1820, 1024], ix: 2 },
              p: { a: 0, k: [0, 0], ix: 3 },
              nm: "Ellipse Path 1",
              mn: "ADBE Vector Shape - Ellipse",
              hd: false
            },
            {
              ty: "st",
              c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 0, ix: 5 },
              lc: 1,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: "Stroke 1",
              mn: "ADBE Vector Graphic - Stroke",
              hd: false
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 0.611764705882, 0.2, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [0, 0], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Ellipse 1",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false
        }
      ],
      ip: 0,
      op: 150.000006109625,
      st: 0,
      bm: 0
    },
    {
      ddd: 0,
      ind: 21,
      ty: 4,
      nm: "Shape Layer 34",
      sr: 1,
      ks: {
        o: {
          a: 1,
          k: [
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 0, s: [80] },
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 47, s: [80] },
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 92, s: [100] },
            { t: 150.000006109625, s: [0] }
          ],
          ix: 11
        },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.833, y: 0.833 },
              o: { x: 0.167, y: 0.167 },
              t: 4,
              s: [194, -898.25, 0],
              to: [0, 178, 0],
              ti: [0, -178, 0]
            },
            { t: 150.000006109625, s: [194, 169.75, 0] }
          ],
          ix: 2
        },
        a: { a: 0, k: [0, 0, 0], ix: 1 },
        s: { a: 0, k: [1.14, 2, 100], ix: 6 }
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              d: 1,
              ty: "el",
              s: { a: 0, k: [1820, 1024], ix: 2 },
              p: { a: 0, k: [0, 0], ix: 3 },
              nm: "Ellipse Path 1",
              mn: "ADBE Vector Shape - Ellipse",
              hd: false
            },
            {
              ty: "st",
              c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 0, ix: 5 },
              lc: 1,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: "Stroke 1",
              mn: "ADBE Vector Graphic - Stroke",
              hd: false
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 0.611764705882, 0.2, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [0, 0], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Ellipse 1",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false
        }
      ],
      ip: 0,
      op: 150.000006109625,
      st: 0,
      bm: 0
    },
    {
      ddd: 0,
      ind: 22,
      ty: 4,
      nm: "Shape Layer 33",
      sr: 1,
      ks: {
        o: {
          a: 1,
          k: [
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 0, s: [80] },
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 47, s: [80] },
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 92, s: [100] },
            { t: 150.000006109625, s: [0] }
          ],
          ix: 11
        },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.833, y: 0.833 },
              o: { x: 0.167, y: 0.167 },
              t: 4,
              s: [382, -824.25, 0],
              to: [0, 178, 0],
              ti: [0, -178, 0]
            },
            { t: 150.000006109625, s: [382, 243.75, 0] }
          ],
          ix: 2
        },
        a: { a: 0, k: [0, 0, 0], ix: 1 },
        s: { a: 0, k: [1.14, 2, 100], ix: 6 }
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              d: 1,
              ty: "el",
              s: { a: 0, k: [1820, 1024], ix: 2 },
              p: { a: 0, k: [0, 0], ix: 3 },
              nm: "Ellipse Path 1",
              mn: "ADBE Vector Shape - Ellipse",
              hd: false
            },
            {
              ty: "st",
              c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 0, ix: 5 },
              lc: 1,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: "Stroke 1",
              mn: "ADBE Vector Graphic - Stroke",
              hd: false
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 0.611764705882, 0.2, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [0, 0], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Ellipse 1",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false
        }
      ],
      ip: 0,
      op: 150.000006109625,
      st: 0,
      bm: 0
    },
    {
      ddd: 0,
      ind: 23,
      ty: 4,
      nm: "Shape Layer 32",
      sr: 1,
      ks: {
        o: {
          a: 1,
          k: [
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 0, s: [80] },
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 47, s: [80] },
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 92, s: [100] },
            { t: 150.000006109625, s: [0] }
          ],
          ix: 11
        },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.833, y: 0.833 },
              o: { x: 0.167, y: 0.167 },
              t: 4,
              s: [268, -664.25, 0],
              to: [0, 178, 0],
              ti: [0, -178, 0]
            },
            { t: 150.000006109625, s: [268, 403.75, 0] }
          ],
          ix: 2
        },
        a: { a: 0, k: [0, 0, 0], ix: 1 },
        s: { a: 0, k: [1.14, 2, 100], ix: 6 }
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              d: 1,
              ty: "el",
              s: { a: 0, k: [1820, 1024], ix: 2 },
              p: { a: 0, k: [0, 0], ix: 3 },
              nm: "Ellipse Path 1",
              mn: "ADBE Vector Shape - Ellipse",
              hd: false
            },
            {
              ty: "st",
              c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 0, ix: 5 },
              lc: 1,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: "Stroke 1",
              mn: "ADBE Vector Graphic - Stroke",
              hd: false
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 0.611764705882, 0.2, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [0, 0], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Ellipse 1",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false
        }
      ],
      ip: 0,
      op: 150.000006109625,
      st: 0,
      bm: 0
    },
    {
      ddd: 0,
      ind: 24,
      ty: 4,
      nm: "Shape Layer 31",
      sr: 1,
      ks: {
        o: {
          a: 1,
          k: [
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 0, s: [80] },
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 47, s: [80] },
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 92, s: [100] },
            { t: 150.000006109625, s: [0] }
          ],
          ix: 11
        },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.833, y: 0.833 },
              o: { x: 0.167, y: 0.167 },
              t: 4,
              s: [436, -244.25, 0],
              to: [0, 178, 0],
              ti: [0, -178, 0]
            },
            { t: 150.000006109625, s: [436, 823.75, 0] }
          ],
          ix: 2
        },
        a: { a: 0, k: [0, 0, 0], ix: 1 },
        s: { a: 0, k: [1.14, 2, 100], ix: 6 }
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              d: 1,
              ty: "el",
              s: { a: 0, k: [1820, 1024], ix: 2 },
              p: { a: 0, k: [0, 0], ix: 3 },
              nm: "Ellipse Path 1",
              mn: "ADBE Vector Shape - Ellipse",
              hd: false
            },
            {
              ty: "st",
              c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 0, ix: 5 },
              lc: 1,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: "Stroke 1",
              mn: "ADBE Vector Graphic - Stroke",
              hd: false
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 0.611764705882, 0.2, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [0, 0], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Ellipse 1",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false
        }
      ],
      ip: 0,
      op: 150.000006109625,
      st: 0,
      bm: 0
    },
    {
      ddd: 0,
      ind: 25,
      ty: 4,
      nm: "Shape Layer 30",
      sr: 1,
      ks: {
        o: {
          a: 1,
          k: [
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 0, s: [80] },
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 47, s: [80] },
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 92, s: [100] },
            { t: 150.000006109625, s: [0] }
          ],
          ix: 11
        },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.833, y: 0.833 },
              o: { x: 0.167, y: 0.167 },
              t: 4,
              s: [442, -664.25, 0],
              to: [0, 178, 0],
              ti: [0, -178, 0]
            },
            { t: 152.000006191087, s: [442, 403.75, 0] }
          ],
          ix: 2
        },
        a: { a: 0, k: [0, 0, 0], ix: 1 },
        s: { a: 0, k: [1.14, 2, 100], ix: 6 }
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              d: 1,
              ty: "el",
              s: { a: 0, k: [1820, 1024], ix: 2 },
              p: { a: 0, k: [0, 0], ix: 3 },
              nm: "Ellipse Path 1",
              mn: "ADBE Vector Shape - Ellipse",
              hd: false
            },
            {
              ty: "st",
              c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 0, ix: 5 },
              lc: 1,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: "Stroke 1",
              mn: "ADBE Vector Graphic - Stroke",
              hd: false
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 0.611764705882, 0.2, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [0, 0], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Ellipse 1",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false
        }
      ],
      ip: 0,
      op: 150.000006109625,
      st: 0,
      bm: 0
    },
    {
      ddd: 0,
      ind: 26,
      ty: 4,
      nm: "Shape Layer 29",
      sr: 1,
      ks: {
        o: {
          a: 1,
          k: [
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 0, s: [80] },
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 47, s: [80] },
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 92, s: [100] },
            { t: 150.000006109625, s: [0] }
          ],
          ix: 11
        },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.833, y: 0.833 },
              o: { x: 0.167, y: 0.167 },
              t: 4,
              s: [258, -76.25, 0],
              to: [0, 0, 0],
              ti: [0, 0, 0]
            },
            {
              i: { x: 0.833, y: 0.833 },
              o: { x: 0.167, y: 0.167 },
              t: 19,
              s: [258, -76.25, 0],
              to: [0, 178, 0],
              ti: [0, -178, 0]
            },
            { t: 131.000005335739, s: [258, 991.75, 0] }
          ],
          ix: 2
        },
        a: { a: 0, k: [0, 0, 0], ix: 1 },
        s: { a: 0, k: [1.14, 2, 100], ix: 6 }
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              d: 1,
              ty: "el",
              s: { a: 0, k: [1820, 1024], ix: 2 },
              p: { a: 0, k: [0, 0], ix: 3 },
              nm: "Ellipse Path 1",
              mn: "ADBE Vector Shape - Ellipse",
              hd: false
            },
            {
              ty: "st",
              c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 0, ix: 5 },
              lc: 1,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: "Stroke 1",
              mn: "ADBE Vector Graphic - Stroke",
              hd: false
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 0.611764705882, 0.2, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [0, 0], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Ellipse 1",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false
        }
      ],
      ip: 0,
      op: 150.000006109625,
      st: 0,
      bm: 0
    },
    {
      ddd: 0,
      ind: 27,
      ty: 4,
      nm: "Shape Layer 27",
      sr: 1,
      ks: {
        o: {
          a: 1,
          k: [
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 0, s: [100] },
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 30, s: [82] },
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 54, s: [100] },
            { t: 150.000006109625, s: [0] }
          ],
          ix: 11
        },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.833, y: 0.833 },
              o: { x: 0.167, y: 0.167 },
              t: 0,
              s: [76.135, -779, 0],
              to: [0, 195.333, 0],
              ti: [0, -195.333, 0]
            },
            { t: 150.000006109625, s: [76.135, 393, 0] }
          ],
          ix: 2
        },
        a: { a: 0, k: [0.135, 1.485, 0], ix: 1 },
        s: {
          a: 1,
          k: [
            {
              i: { x: [0.833, 0.833, 0.833], y: [0.833, 0.833, 0.833] },
              o: { x: [0.167, 0.167, 0.167], y: [0.167, 0.167, 0.167] },
              t: 0,
              s: [15, 15, 100]
            },
            {
              i: { x: [0.833, 0.833, 0.833], y: [0.833, 0.833, 0.833] },
              o: { x: [0.167, 0.167, 0.167], y: [0.167, 0.167, 0.167] },
              t: 30,
              s: [42.8, 42.8, 100]
            },
            {
              i: { x: [0.833, 0.833, 0.833], y: [0.833, 0.833, 0.833] },
              o: { x: [0.167, 0.167, 0.167], y: [0.167, 0.167, 0.167] },
              t: 70,
              s: [19.2, 19.2, 100]
            },
            {
              i: { x: [0.833, 0.833, 0.833], y: [0.833, 0.833, 0.833] },
              o: { x: [0.167, 0.167, 0.167], y: [0.167, 0.167, 0.167] },
              t: 108,
              s: [30.005, 30.005, 100]
            },
            { t: 150.000006109625, s: [19, 19, 100] }
          ],
          ix: 6
        }
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              ty: "rc",
              d: 1,
              s: { a: 0, k: [7.582, 47.299], ix: 2 },
              p: { a: 0, k: [0, 0], ix: 3 },
              r: { a: 0, k: 0, ix: 4 },
              nm: "Rectangle Path 1",
              mn: "ADBE Vector Shape - Rect",
              hd: false
            },
            {
              ty: "st",
              c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 0, ix: 5 },
              lc: 1,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: "Stroke 1",
              mn: "ADBE Vector Graphic - Stroke",
              hd: false
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 0.611764705882, 0.2, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [-34.998, 1.043], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 90, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Rectangle 5",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false
        },
        {
          ty: "gr",
          it: [
            {
              ty: "rc",
              d: 1,
              s: { a: 0, k: [7.582, 47.299], ix: 2 },
              p: { a: 0, k: [0, 0], ix: 3 },
              r: { a: 0, k: 0, ix: 4 },
              nm: "Rectangle Path 1",
              mn: "ADBE Vector Shape - Rect",
              hd: false
            },
            {
              ty: "st",
              c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 0, ix: 5 },
              lc: 1,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: "Stroke 1",
              mn: "ADBE Vector Graphic - Stroke",
              hd: false
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 0.611764705882, 0.2, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [0.25, 36.72], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Rectangle 3",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 2,
          mn: "ADBE Vector Group",
          hd: false
        },
        {
          ty: "gr",
          it: [
            {
              ty: "rc",
              d: 1,
              s: { a: 0, k: [7.582, 47.299], ix: 2 },
              p: { a: 0, k: [0, 0], ix: 3 },
              r: { a: 0, k: 0, ix: 4 },
              nm: "Rectangle Path 1",
              mn: "ADBE Vector Shape - Rect",
              hd: false
            },
            {
              ty: "st",
              c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 0, ix: 5 },
              lc: 1,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: "Stroke 1",
              mn: "ADBE Vector Graphic - Stroke",
              hd: false
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 0.611764705882, 0.2, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [35.269, 1.06], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 90, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Rectangle 4",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 3,
          mn: "ADBE Vector Group",
          hd: false
        },
        {
          ty: "gr",
          it: [
            {
              ty: "rc",
              d: 1,
              s: { a: 0, k: [7.582, 47.299], ix: 2 },
              p: { a: 0, k: [0, 0], ix: 3 },
              r: { a: 0, k: 0, ix: 4 },
              nm: "Rectangle Path 1",
              mn: "ADBE Vector Shape - Rect",
              hd: false
            },
            {
              ty: "st",
              c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 0, ix: 5 },
              lc: 1,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: "Stroke 1",
              mn: "ADBE Vector Graphic - Stroke",
              hd: false
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 0.611764705882, 0.2, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [0.25, -33.75], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Rectangle 2",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 4,
          mn: "ADBE Vector Group",
          hd: false
        }
      ],
      ip: 0,
      op: 150.000006109625,
      st: 0,
      bm: 0
    },
    {
      ddd: 0,
      ind: 28,
      ty: 4,
      nm: "Shape Layer 11",
      sr: 1,
      ks: {
        o: {
          a: 1,
          k: [
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 0, s: [100] },
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 30, s: [82] },
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 54, s: [100] },
            { t: 150.000006109625, s: [0] }
          ],
          ix: 11
        },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.833, y: 0.833 },
              o: { x: 0.167, y: 0.167 },
              t: 0,
              s: [128.135, -265, 0],
              to: [0, 195.333, 0],
              ti: [0, -195.333, 0]
            },
            { t: 150.000006109625, s: [128.135, 907, 0] }
          ],
          ix: 2
        },
        a: { a: 0, k: [0.135, 1.485, 0], ix: 1 },
        s: {
          a: 1,
          k: [
            {
              i: { x: [0.833, 0.833, 0.833], y: [0.833, 0.833, 0.833] },
              o: { x: [0.167, 0.167, 0.167], y: [0.167, 0.167, 0.167] },
              t: 0,
              s: [15, 15, 100]
            },
            {
              i: { x: [0.833, 0.833, 0.833], y: [0.833, 0.833, 0.833] },
              o: { x: [0.167, 0.167, 0.167], y: [0.167, 0.167, 0.167] },
              t: 30,
              s: [42.8, 42.8, 100]
            },
            {
              i: { x: [0.833, 0.833, 0.833], y: [0.833, 0.833, 0.833] },
              o: { x: [0.167, 0.167, 0.167], y: [0.167, 0.167, 0.167] },
              t: 70,
              s: [19.2, 19.2, 100]
            },
            {
              i: { x: [0.833, 0.833, 0.833], y: [0.833, 0.833, 0.833] },
              o: { x: [0.167, 0.167, 0.167], y: [0.167, 0.167, 0.167] },
              t: 108,
              s: [30.005, 30.005, 100]
            },
            { t: 150.000006109625, s: [19, 19, 100] }
          ],
          ix: 6
        }
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              ty: "rc",
              d: 1,
              s: { a: 0, k: [7.582, 47.299], ix: 2 },
              p: { a: 0, k: [0, 0], ix: 3 },
              r: { a: 0, k: 0, ix: 4 },
              nm: "Rectangle Path 1",
              mn: "ADBE Vector Shape - Rect",
              hd: false
            },
            {
              ty: "st",
              c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 0, ix: 5 },
              lc: 1,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: "Stroke 1",
              mn: "ADBE Vector Graphic - Stroke",
              hd: false
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 0.611764705882, 0.2, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [-34.998, 1.043], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 90, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Rectangle 5",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false
        },
        {
          ty: "gr",
          it: [
            {
              ty: "rc",
              d: 1,
              s: { a: 0, k: [7.582, 47.299], ix: 2 },
              p: { a: 0, k: [0, 0], ix: 3 },
              r: { a: 0, k: 0, ix: 4 },
              nm: "Rectangle Path 1",
              mn: "ADBE Vector Shape - Rect",
              hd: false
            },
            {
              ty: "st",
              c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 0, ix: 5 },
              lc: 1,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: "Stroke 1",
              mn: "ADBE Vector Graphic - Stroke",
              hd: false
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 0.611764705882, 0.2, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [0.25, 36.72], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Rectangle 3",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 2,
          mn: "ADBE Vector Group",
          hd: false
        },
        {
          ty: "gr",
          it: [
            {
              ty: "rc",
              d: 1,
              s: { a: 0, k: [7.582, 47.299], ix: 2 },
              p: { a: 0, k: [0, 0], ix: 3 },
              r: { a: 0, k: 0, ix: 4 },
              nm: "Rectangle Path 1",
              mn: "ADBE Vector Shape - Rect",
              hd: false
            },
            {
              ty: "st",
              c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 0, ix: 5 },
              lc: 1,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: "Stroke 1",
              mn: "ADBE Vector Graphic - Stroke",
              hd: false
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 0.611764705882, 0.2, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [35.269, 1.06], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 90, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Rectangle 4",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 3,
          mn: "ADBE Vector Group",
          hd: false
        },
        {
          ty: "gr",
          it: [
            {
              ty: "rc",
              d: 1,
              s: { a: 0, k: [7.582, 47.299], ix: 2 },
              p: { a: 0, k: [0, 0], ix: 3 },
              r: { a: 0, k: 0, ix: 4 },
              nm: "Rectangle Path 1",
              mn: "ADBE Vector Shape - Rect",
              hd: false
            },
            {
              ty: "st",
              c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 0, ix: 5 },
              lc: 1,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: "Stroke 1",
              mn: "ADBE Vector Graphic - Stroke",
              hd: false
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 0.611764705882, 0.2, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [0.25, -33.75], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Rectangle 2",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 4,
          mn: "ADBE Vector Group",
          hd: false
        }
      ],
      ip: 0,
      op: 150.000006109625,
      st: 0,
      bm: 0
    },
    {
      ddd: 0,
      ind: 29,
      ty: 4,
      nm: "Shape Layer 10",
      sr: 1,
      ks: {
        o: {
          a: 1,
          k: [
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 0, s: [100] },
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 30, s: [82] },
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 54, s: [100] },
            { t: 150.000006109625, s: [0] }
          ],
          ix: 11
        },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.833, y: 0.833 },
              o: { x: 0.167, y: 0.167 },
              t: 0,
              s: [194.135, -9, 0],
              to: [0, 195.333, 0],
              ti: [0, -195.333, 0]
            },
            { t: 150.000006109625, s: [194.135, 1163, 0] }
          ],
          ix: 2
        },
        a: { a: 0, k: [0.135, 1.485, 0], ix: 1 },
        s: {
          a: 1,
          k: [
            {
              i: { x: [0.833, 0.833, 0.833], y: [0.833, 0.833, 0.833] },
              o: { x: [0.167, 0.167, 0.167], y: [0.167, 0.167, 0.167] },
              t: 0,
              s: [15, 15, 100]
            },
            {
              i: { x: [0.833, 0.833, 0.833], y: [0.833, 0.833, 0.833] },
              o: { x: [0.167, 0.167, 0.167], y: [0.167, 0.167, 0.167] },
              t: 30,
              s: [9.8, 9.8, 100]
            },
            {
              i: { x: [0.833, 0.833, 0.833], y: [0.833, 0.833, 0.833] },
              o: { x: [0.167, 0.167, 0.167], y: [0.167, 0.167, 0.167] },
              t: 70,
              s: [19.2, 19.2, 100]
            },
            {
              i: { x: [0.833, 0.833, 0.833], y: [0.833, 0.833, 0.833] },
              o: { x: [0.167, 0.167, 0.167], y: [0.167, 0.167, 0.167] },
              t: 108,
              s: [10.005, 10.005, 100]
            },
            { t: 150.000006109625, s: [19, 19, 100] }
          ],
          ix: 6
        }
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              ty: "rc",
              d: 1,
              s: { a: 0, k: [7.582, 47.299], ix: 2 },
              p: { a: 0, k: [0, 0], ix: 3 },
              r: { a: 0, k: 0, ix: 4 },
              nm: "Rectangle Path 1",
              mn: "ADBE Vector Shape - Rect",
              hd: false
            },
            {
              ty: "st",
              c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 0, ix: 5 },
              lc: 1,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: "Stroke 1",
              mn: "ADBE Vector Graphic - Stroke",
              hd: false
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 0.611764705882, 0.2, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [-34.998, 1.043], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 90, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Rectangle 5",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false
        },
        {
          ty: "gr",
          it: [
            {
              ty: "rc",
              d: 1,
              s: { a: 0, k: [7.582, 47.299], ix: 2 },
              p: { a: 0, k: [0, 0], ix: 3 },
              r: { a: 0, k: 0, ix: 4 },
              nm: "Rectangle Path 1",
              mn: "ADBE Vector Shape - Rect",
              hd: false
            },
            {
              ty: "st",
              c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 0, ix: 5 },
              lc: 1,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: "Stroke 1",
              mn: "ADBE Vector Graphic - Stroke",
              hd: false
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 0.611764705882, 0.2, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [0.25, 36.72], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Rectangle 3",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 2,
          mn: "ADBE Vector Group",
          hd: false
        },
        {
          ty: "gr",
          it: [
            {
              ty: "rc",
              d: 1,
              s: { a: 0, k: [7.582, 47.299], ix: 2 },
              p: { a: 0, k: [0, 0], ix: 3 },
              r: { a: 0, k: 0, ix: 4 },
              nm: "Rectangle Path 1",
              mn: "ADBE Vector Shape - Rect",
              hd: false
            },
            {
              ty: "st",
              c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 0, ix: 5 },
              lc: 1,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: "Stroke 1",
              mn: "ADBE Vector Graphic - Stroke",
              hd: false
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 0.611764705882, 0.2, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [35.269, 1.06], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 90, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Rectangle 4",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 3,
          mn: "ADBE Vector Group",
          hd: false
        },
        {
          ty: "gr",
          it: [
            {
              ty: "rc",
              d: 1,
              s: { a: 0, k: [7.582, 47.299], ix: 2 },
              p: { a: 0, k: [0, 0], ix: 3 },
              r: { a: 0, k: 0, ix: 4 },
              nm: "Rectangle Path 1",
              mn: "ADBE Vector Shape - Rect",
              hd: false
            },
            {
              ty: "st",
              c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 0, ix: 5 },
              lc: 1,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: "Stroke 1",
              mn: "ADBE Vector Graphic - Stroke",
              hd: false
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 0.611764705882, 0.2, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [0.25, -33.75], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Rectangle 2",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 4,
          mn: "ADBE Vector Group",
          hd: false
        }
      ],
      ip: 0,
      op: 150.000006109625,
      st: 0,
      bm: 0
    },
    {
      ddd: 0,
      ind: 30,
      ty: 4,
      nm: "Shape Layer 17",
      sr: 1,
      ks: {
        o: {
          a: 1,
          k: [
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 0, s: [100] },
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 30, s: [100] },
            { t: 150.000006109625, s: [0] }
          ],
          ix: 11
        },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.833, y: 0.833 },
              o: { x: 0.167, y: 0.167 },
              t: 0,
              s: [34.135, -475, 0],
              to: [0, 167.333, 0],
              ti: [0, -167.333, 0]
            },
            { t: 150.000006109625, s: [34.135, 529, 0] }
          ],
          ix: 2
        },
        a: { a: 0, k: [0.135, 1.485, 0], ix: 1 },
        s: {
          a: 1,
          k: [
            {
              i: { x: [0.833, 0.833, 0.833], y: [0.833, 0.833, 0.833] },
              o: { x: [0.167, 0.167, 0.167], y: [0.167, 0.167, 0.167] },
              t: 15,
              s: [11, 11, 100]
            },
            {
              i: { x: [0.833, 0.833, 0.833], y: [0.833, 0.833, 0.833] },
              o: { x: [0.167, 0.167, 0.167], y: [0.167, 0.167, 0.167] },
              t: 20,
              s: [36, 36, 100]
            },
            { t: 133.000005417201, s: [19, 19, 100] }
          ],
          ix: 6
        }
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              ty: "rc",
              d: 1,
              s: { a: 0, k: [7.582, 47.299], ix: 2 },
              p: { a: 0, k: [0, 0], ix: 3 },
              r: { a: 0, k: 0, ix: 4 },
              nm: "Rectangle Path 1",
              mn: "ADBE Vector Shape - Rect",
              hd: false
            },
            {
              ty: "st",
              c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 0, ix: 5 },
              lc: 1,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: "Stroke 1",
              mn: "ADBE Vector Graphic - Stroke",
              hd: false
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 0.611764705882, 0.2, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [-34.998, 1.043], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 90, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Rectangle 5",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false
        },
        {
          ty: "gr",
          it: [
            {
              ty: "rc",
              d: 1,
              s: { a: 0, k: [7.582, 47.299], ix: 2 },
              p: { a: 0, k: [0, 0], ix: 3 },
              r: { a: 0, k: 0, ix: 4 },
              nm: "Rectangle Path 1",
              mn: "ADBE Vector Shape - Rect",
              hd: false
            },
            {
              ty: "st",
              c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 0, ix: 5 },
              lc: 1,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: "Stroke 1",
              mn: "ADBE Vector Graphic - Stroke",
              hd: false
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 0.611764705882, 0.2, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [0.25, 36.72], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Rectangle 3",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 2,
          mn: "ADBE Vector Group",
          hd: false
        },
        {
          ty: "gr",
          it: [
            {
              ty: "rc",
              d: 1,
              s: { a: 0, k: [7.582, 47.299], ix: 2 },
              p: { a: 0, k: [0, 0], ix: 3 },
              r: { a: 0, k: 0, ix: 4 },
              nm: "Rectangle Path 1",
              mn: "ADBE Vector Shape - Rect",
              hd: false
            },
            {
              ty: "st",
              c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 0, ix: 5 },
              lc: 1,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: "Stroke 1",
              mn: "ADBE Vector Graphic - Stroke",
              hd: false
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 0.611764705882, 0.2, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [35.269, 1.06], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 90, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Rectangle 4",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 3,
          mn: "ADBE Vector Group",
          hd: false
        },
        {
          ty: "gr",
          it: [
            {
              ty: "rc",
              d: 1,
              s: { a: 0, k: [7.582, 47.299], ix: 2 },
              p: { a: 0, k: [0, 0], ix: 3 },
              r: { a: 0, k: 0, ix: 4 },
              nm: "Rectangle Path 1",
              mn: "ADBE Vector Shape - Rect",
              hd: false
            },
            {
              ty: "st",
              c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 0, ix: 5 },
              lc: 1,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: "Stroke 1",
              mn: "ADBE Vector Graphic - Stroke",
              hd: false
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 0.611764705882, 0.2, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [0.25, -33.75], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Rectangle 2",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 4,
          mn: "ADBE Vector Group",
          hd: false
        }
      ],
      ip: 0,
      op: 150.000006109625,
      st: 0,
      bm: 0
    },
    {
      ddd: 0,
      ind: 31,
      ty: 4,
      nm: "Shape Layer 20",
      sr: 1,
      ks: {
        o: {
          a: 1,
          k: [
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 0, s: [100] },
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 30, s: [100] },
            { t: 149.000006068894, s: [0] }
          ],
          ix: 11
        },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.833, y: 0.833 },
              o: { x: 0.167, y: 0.167 },
              t: 0,
              s: [52.135, -274, 0],
              to: [0, 206.167, 0],
              ti: [0, -206.167, 0]
            },
            { t: 174.000007087165, s: [52.135, 963, 0] }
          ],
          ix: 2
        },
        a: { a: 0, k: [0.135, 1.485, 0], ix: 1 },
        s: {
          a: 1,
          k: [
            {
              i: { x: [0.833, 0.833, 0.833], y: [0.833, 0.833, 0.833] },
              o: { x: [0.167, 0.167, 0.167], y: [0.167, 0.167, 0.167] },
              t: 20,
              s: [23, 23, 100]
            },
            { t: 133.000005417201, s: [11, 11, 100] }
          ],
          ix: 6
        }
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              ty: "rc",
              d: 1,
              s: { a: 0, k: [7.582, 47.299], ix: 2 },
              p: { a: 0, k: [0, 0], ix: 3 },
              r: { a: 0, k: 0, ix: 4 },
              nm: "Rectangle Path 1",
              mn: "ADBE Vector Shape - Rect",
              hd: false
            },
            {
              ty: "st",
              c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 0, ix: 5 },
              lc: 1,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: "Stroke 1",
              mn: "ADBE Vector Graphic - Stroke",
              hd: false
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 0.611764705882, 0.2, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [-34.998, 1.043], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 90, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Rectangle 5",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false
        },
        {
          ty: "gr",
          it: [
            {
              ty: "rc",
              d: 1,
              s: { a: 0, k: [7.582, 47.299], ix: 2 },
              p: { a: 0, k: [0, 0], ix: 3 },
              r: { a: 0, k: 0, ix: 4 },
              nm: "Rectangle Path 1",
              mn: "ADBE Vector Shape - Rect",
              hd: false
            },
            {
              ty: "st",
              c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 0, ix: 5 },
              lc: 1,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: "Stroke 1",
              mn: "ADBE Vector Graphic - Stroke",
              hd: false
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 0.611764705882, 0.2, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [0.25, 36.72], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Rectangle 3",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 2,
          mn: "ADBE Vector Group",
          hd: false
        },
        {
          ty: "gr",
          it: [
            {
              ty: "rc",
              d: 1,
              s: { a: 0, k: [7.582, 47.299], ix: 2 },
              p: { a: 0, k: [0, 0], ix: 3 },
              r: { a: 0, k: 0, ix: 4 },
              nm: "Rectangle Path 1",
              mn: "ADBE Vector Shape - Rect",
              hd: false
            },
            {
              ty: "st",
              c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 0, ix: 5 },
              lc: 1,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: "Stroke 1",
              mn: "ADBE Vector Graphic - Stroke",
              hd: false
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 0.611764705882, 0.2, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [35.269, 1.06], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 90, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Rectangle 4",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 3,
          mn: "ADBE Vector Group",
          hd: false
        },
        {
          ty: "gr",
          it: [
            {
              ty: "rc",
              d: 1,
              s: { a: 0, k: [7.582, 47.299], ix: 2 },
              p: { a: 0, k: [0, 0], ix: 3 },
              r: { a: 0, k: 0, ix: 4 },
              nm: "Rectangle Path 1",
              mn: "ADBE Vector Shape - Rect",
              hd: false
            },
            {
              ty: "st",
              c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 0, ix: 5 },
              lc: 1,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: "Stroke 1",
              mn: "ADBE Vector Graphic - Stroke",
              hd: false
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 0.611764705882, 0.2, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [0.25, -33.75], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Rectangle 2",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 4,
          mn: "ADBE Vector Group",
          hd: false
        }
      ],
      ip: 0,
      op: 150.000006109625,
      st: 0,
      bm: 0
    },
    {
      ddd: 0,
      ind: 32,
      ty: 4,
      nm: "Shape Layer 9",
      sr: 1,
      ks: {
        o: {
          a: 1,
          k: [
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 0, s: [100] },
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 30, s: [100] },
            { t: 150.000006109625, s: [0] }
          ],
          ix: 11
        },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.833, y: 0.833 },
              o: { x: 0.167, y: 0.167 },
              t: 0,
              s: [188.135, -543, 0],
              to: [0, 167.333, 0],
              ti: [0, -167.333, 0]
            },
            { t: 150.000006109625, s: [188.135, 461, 0] }
          ],
          ix: 2
        },
        a: { a: 0, k: [0.135, 1.485, 0], ix: 1 },
        s: {
          a: 1,
          k: [
            {
              i: { x: [0.833, 0.833, 0.833], y: [0.833, 0.833, 0.833] },
              o: { x: [0.167, 0.167, 0.167], y: [0.167, 0.167, 0.167] },
              t: 15,
              s: [11, 11, 100]
            },
            {
              i: { x: [0.833, 0.833, 0.833], y: [0.833, 0.833, 0.833] },
              o: { x: [0.167, 0.167, 0.167], y: [0.167, 0.167, 0.167] },
              t: 20,
              s: [36, 36, 100]
            },
            { t: 133.000005417201, s: [19, 19, 100] }
          ],
          ix: 6
        }
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              ty: "rc",
              d: 1,
              s: { a: 0, k: [7.582, 47.299], ix: 2 },
              p: { a: 0, k: [0, 0], ix: 3 },
              r: { a: 0, k: 0, ix: 4 },
              nm: "Rectangle Path 1",
              mn: "ADBE Vector Shape - Rect",
              hd: false
            },
            {
              ty: "st",
              c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 0, ix: 5 },
              lc: 1,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: "Stroke 1",
              mn: "ADBE Vector Graphic - Stroke",
              hd: false
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 0.611764705882, 0.2, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [-34.998, 1.043], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 90, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Rectangle 5",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false
        },
        {
          ty: "gr",
          it: [
            {
              ty: "rc",
              d: 1,
              s: { a: 0, k: [7.582, 47.299], ix: 2 },
              p: { a: 0, k: [0, 0], ix: 3 },
              r: { a: 0, k: 0, ix: 4 },
              nm: "Rectangle Path 1",
              mn: "ADBE Vector Shape - Rect",
              hd: false
            },
            {
              ty: "st",
              c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 0, ix: 5 },
              lc: 1,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: "Stroke 1",
              mn: "ADBE Vector Graphic - Stroke",
              hd: false
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 0.611764705882, 0.2, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [0.25, 36.72], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Rectangle 3",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 2,
          mn: "ADBE Vector Group",
          hd: false
        },
        {
          ty: "gr",
          it: [
            {
              ty: "rc",
              d: 1,
              s: { a: 0, k: [7.582, 47.299], ix: 2 },
              p: { a: 0, k: [0, 0], ix: 3 },
              r: { a: 0, k: 0, ix: 4 },
              nm: "Rectangle Path 1",
              mn: "ADBE Vector Shape - Rect",
              hd: false
            },
            {
              ty: "st",
              c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 0, ix: 5 },
              lc: 1,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: "Stroke 1",
              mn: "ADBE Vector Graphic - Stroke",
              hd: false
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 0.611764705882, 0.2, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [35.269, 1.06], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 90, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Rectangle 4",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 3,
          mn: "ADBE Vector Group",
          hd: false
        },
        {
          ty: "gr",
          it: [
            {
              ty: "rc",
              d: 1,
              s: { a: 0, k: [7.582, 47.299], ix: 2 },
              p: { a: 0, k: [0, 0], ix: 3 },
              r: { a: 0, k: 0, ix: 4 },
              nm: "Rectangle Path 1",
              mn: "ADBE Vector Shape - Rect",
              hd: false
            },
            {
              ty: "st",
              c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 0, ix: 5 },
              lc: 1,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: "Stroke 1",
              mn: "ADBE Vector Graphic - Stroke",
              hd: false
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 0.611764705882, 0.2, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [0.25, -33.75], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Rectangle 2",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 4,
          mn: "ADBE Vector Group",
          hd: false
        }
      ],
      ip: 0,
      op: 150.000006109625,
      st: 0,
      bm: 0
    },
    {
      ddd: 0,
      ind: 33,
      ty: 4,
      nm: "Shape Layer 16",
      sr: 1,
      ks: {
        o: {
          a: 1,
          k: [
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 0, s: [80] },
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 20, s: [100] },
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 40, s: [100] },
            { t: 150.000006109625, s: [0] }
          ],
          ix: 11
        },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.833, y: 0.833 },
              o: { x: 0.167, y: 0.167 },
              t: 0,
              s: [132, -718.25, 0],
              to: [0, 8.18, 0],
              ti: [0, -166.487, 0]
            },
            { t: 150.000006109625, s: [132, 685.75, 0] }
          ],
          ix: 2
        },
        a: { a: 0, k: [0, 0, 0], ix: 1 },
        s: { a: 0, k: [0.72, 1.263, 100], ix: 6 }
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              d: 1,
              ty: "el",
              s: { a: 0, k: [1820, 1024], ix: 2 },
              p: { a: 0, k: [0, 0], ix: 3 },
              nm: "Ellipse Path 1",
              mn: "ADBE Vector Shape - Ellipse",
              hd: false
            },
            {
              ty: "st",
              c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 0, ix: 5 },
              lc: 1,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: "Stroke 1",
              mn: "ADBE Vector Graphic - Stroke",
              hd: false
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 0.611764705882, 0.2, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [0, 0], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Ellipse 1",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false
        }
      ],
      ip: 0,
      op: 150.000006109625,
      st: 0,
      bm: 0
    },
    {
      ddd: 0,
      ind: 34,
      ty: 4,
      nm: "Shape Layer 28",
      sr: 1,
      ks: {
        o: {
          a: 1,
          k: [
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 0, s: [80] },
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 20, s: [100] },
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 40, s: [100] },
            { t: 150.000006109625, s: [0] }
          ],
          ix: 11
        },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.833, y: 0.833 },
              o: { x: 0.167, y: 0.167 },
              t: 0,
              s: [186, -672.25, 0],
              to: [0, 8.18, 0],
              ti: [0, -166.487, 0]
            },
            { t: 150.000006109625, s: [186, 375.75, 0] }
          ],
          ix: 2
        },
        a: { a: 0, k: [0, 0, 0], ix: 1 },
        s: { a: 0, k: [0.72, 1.263, 100], ix: 6 }
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              d: 1,
              ty: "el",
              s: { a: 0, k: [1820, 1024], ix: 2 },
              p: { a: 0, k: [0, 0], ix: 3 },
              nm: "Ellipse Path 1",
              mn: "ADBE Vector Shape - Ellipse",
              hd: false
            },
            {
              ty: "st",
              c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 0, ix: 5 },
              lc: 1,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: "Stroke 1",
              mn: "ADBE Vector Graphic - Stroke",
              hd: false
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 0.611764705882, 0.2, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [0, 0], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Ellipse 1",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false
        }
      ],
      ip: 0,
      op: 150.000006109625,
      st: 0,
      bm: 0
    },
    {
      ddd: 0,
      ind: 35,
      ty: 4,
      nm: "Shape Layer 8",
      sr: 1,
      ks: {
        o: {
          a: 1,
          k: [
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 0, s: [80] },
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 20, s: [100] },
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 40, s: [100] },
            { t: 150.000006109625, s: [0] }
          ],
          ix: 11
        },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.833, y: 0.833 },
              o: { x: 0.167, y: 0.167 },
              t: 0,
              s: [80, -8.25, 0],
              to: [0, 8.18, 0],
              ti: [0, -166.487, 0]
            },
            { t: 150.000006109625, s: [80, 1039.75, 0] }
          ],
          ix: 2
        },
        a: { a: 0, k: [0, 0, 0], ix: 1 },
        s: { a: 0, k: [0.72, 1.263, 100], ix: 6 }
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              d: 1,
              ty: "el",
              s: { a: 0, k: [1820, 1024], ix: 2 },
              p: { a: 0, k: [0, 0], ix: 3 },
              nm: "Ellipse Path 1",
              mn: "ADBE Vector Shape - Ellipse",
              hd: false
            },
            {
              ty: "st",
              c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 0, ix: 5 },
              lc: 1,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: "Stroke 1",
              mn: "ADBE Vector Graphic - Stroke",
              hd: false
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 0.611764705882, 0.2, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [0, 0], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Ellipse 1",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false
        }
      ],
      ip: 0,
      op: 150.000006109625,
      st: 0,
      bm: 0
    },
    {
      ddd: 0,
      ind: 36,
      ty: 4,
      nm: "Shape Layer 15",
      sr: 1,
      ks: {
        o: {
          a: 1,
          k: [
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 0, s: [80] },
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 20, s: [100] },
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 40, s: [100] },
            { t: 150.000006109625, s: [0] }
          ],
          ix: 11
        },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.833, y: 0.833 },
              o: { x: 0.167, y: 0.167 },
              t: 0,
              s: [82, -488.25, 0],
              to: [0, 9.163, 0],
              ti: [0, -186.503, 0]
            },
            { t: 150.000006109625, s: [82, 685.75, 0] }
          ],
          ix: 2
        },
        a: { a: 0, k: [0, 0, 0], ix: 1 },
        s: { a: 0, k: [1.71, 3, 100], ix: 6 }
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              d: 1,
              ty: "el",
              s: { a: 0, k: [1820, 1024], ix: 2 },
              p: { a: 0, k: [0, 0], ix: 3 },
              nm: "Ellipse Path 1",
              mn: "ADBE Vector Shape - Ellipse",
              hd: false
            },
            {
              ty: "st",
              c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 0, ix: 5 },
              lc: 1,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: "Stroke 1",
              mn: "ADBE Vector Graphic - Stroke",
              hd: false
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 0.611764705882, 0.2, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [0, 0], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Ellipse 1",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false
        }
      ],
      ip: 0,
      op: 150.000006109625,
      st: 0,
      bm: 0
    },
    {
      ddd: 0,
      ind: 37,
      ty: 4,
      nm: "Shape Layer 7",
      sr: 1,
      ks: {
        o: {
          a: 1,
          k: [
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 0, s: [80] },
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 20, s: [100] },
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 40, s: [100] },
            { t: 150.000006109625, s: [0] }
          ],
          ix: 11
        },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.833, y: 0.833 },
              o: { x: 0.167, y: 0.167 },
              t: 0,
              s: [130, -26.25, 0],
              to: [0, 9.163, 0],
              ti: [0, -11.618, 0]
            },
            {
              i: { x: 0.833, y: 0.833 },
              o: { x: 0.167, y: 0.167 },
              t: 4,
              s: [130, 19.058, 0],
              to: [0, 236.455, 0],
              ti: [0, -186.503, 0]
            },
            { t: 150.000006109625, s: [130, 1161.75, 0] }
          ],
          ix: 2
        },
        a: { a: 0, k: [0, 0, 0], ix: 1 },
        s: { a: 0, k: [1.71, 3, 100], ix: 6 }
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              d: 1,
              ty: "el",
              s: { a: 0, k: [1820, 1024], ix: 2 },
              p: { a: 0, k: [0, 0], ix: 3 },
              nm: "Ellipse Path 1",
              mn: "ADBE Vector Shape - Ellipse",
              hd: false
            },
            {
              ty: "st",
              c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 0, ix: 5 },
              lc: 1,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: "Stroke 1",
              mn: "ADBE Vector Graphic - Stroke",
              hd: false
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 0.611764705882, 0.2, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [0, 0], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Ellipse 1",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false
        }
      ],
      ip: 0,
      op: 150.000006109625,
      st: 0,
      bm: 0
    },
    {
      ddd: 0,
      ind: 38,
      ty: 4,
      nm: "Shape Layer 14",
      sr: 1,
      ks: {
        o: {
          a: 1,
          k: [
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 0, s: [80] },
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 10, s: [100] },
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 61, s: [100] },
            { t: 134.000005457932, s: [0] }
          ],
          ix: 11
        },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.833, y: 0.833 },
              o: { x: 0.167, y: 0.167 },
              t: 4,
              s: [22, -252.25, 0],
              to: [0, 152.333, 0],
              ti: [0, -152.333, 0]
            },
            { t: 136.000005539394, s: [22, 661.75, 0] }
          ],
          ix: 2
        },
        a: { a: 0, k: [0, 0, 0], ix: 1 },
        s: { a: 0, k: [1.425, 2.5, 100], ix: 6 }
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              d: 1,
              ty: "el",
              s: { a: 0, k: [1820, 1024], ix: 2 },
              p: { a: 0, k: [0, 0], ix: 3 },
              nm: "Ellipse Path 1",
              mn: "ADBE Vector Shape - Ellipse",
              hd: false
            },
            {
              ty: "st",
              c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 0, ix: 5 },
              lc: 1,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: "Stroke 1",
              mn: "ADBE Vector Graphic - Stroke",
              hd: false
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 0.611764705882, 0.2, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [0, 0], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Ellipse 1",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false
        }
      ],
      ip: 0,
      op: 150.000006109625,
      st: 0,
      bm: 0
    },
    {
      ddd: 0,
      ind: 39,
      ty: 4,
      nm: "Shape Layer 18",
      sr: 1,
      ks: {
        o: {
          a: 1,
          k: [
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 0, s: [80] },
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 10, s: [100] },
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 61, s: [100] },
            { t: 134.000005457932, s: [0] }
          ],
          ix: 11
        },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.833, y: 0.833 },
              o: { x: 0.167, y: 0.167 },
              t: 4,
              s: [204, -346.25, 0],
              to: [0, 152.333, 0],
              ti: [0, -152.333, 0]
            },
            { t: 136.000005539394, s: [204, 567.75, 0] }
          ],
          ix: 2
        },
        a: { a: 0, k: [0, 0, 0], ix: 1 },
        s: { a: 0, k: [1.425, 2.5, 100], ix: 6 }
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              d: 1,
              ty: "el",
              s: { a: 0, k: [1820, 1024], ix: 2 },
              p: { a: 0, k: [0, 0], ix: 3 },
              nm: "Ellipse Path 1",
              mn: "ADBE Vector Shape - Ellipse",
              hd: false
            },
            {
              ty: "st",
              c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 0, ix: 5 },
              lc: 1,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: "Stroke 1",
              mn: "ADBE Vector Graphic - Stroke",
              hd: false
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 0.611764705882, 0.2, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [0, 0], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Ellipse 1",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false
        }
      ],
      ip: 0,
      op: 150.000006109625,
      st: 0,
      bm: 0
    },
    {
      ddd: 0,
      ind: 40,
      ty: 4,
      nm: "Shape Layer 6",
      sr: 1,
      ks: {
        o: {
          a: 1,
          k: [
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 0, s: [80] },
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 10, s: [100] },
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 61, s: [100] },
            { t: 134.000005457932, s: [0] }
          ],
          ix: 11
        },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.833, y: 0.833 },
              o: { x: 0.167, y: 0.167 },
              t: 4,
              s: [94, -72.25, 0],
              to: [0, 152.333, 0],
              ti: [0, -152.333, 0]
            },
            { t: 136.000005539394, s: [94, 841.75, 0] }
          ],
          ix: 2
        },
        a: { a: 0, k: [0, 0, 0], ix: 1 },
        s: { a: 0, k: [1.425, 2.5, 100], ix: 6 }
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              d: 1,
              ty: "el",
              s: { a: 0, k: [1820, 1024], ix: 2 },
              p: { a: 0, k: [0, 0], ix: 3 },
              nm: "Ellipse Path 1",
              mn: "ADBE Vector Shape - Ellipse",
              hd: false
            },
            {
              ty: "st",
              c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 0, ix: 5 },
              lc: 1,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: "Stroke 1",
              mn: "ADBE Vector Graphic - Stroke",
              hd: false
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 0.611764705882, 0.2, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [0, 0], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Ellipse 1",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false
        }
      ],
      ip: 0,
      op: 150.000006109625,
      st: 0,
      bm: 0
    },
    {
      ddd: 0,
      ind: 41,
      ty: 4,
      nm: "Shape Layer 4",
      sr: 1,
      ks: {
        o: {
          a: 1,
          k: [
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 0, s: [80] },
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 20, s: [100] },
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 40, s: [100] },
            { t: 150.000006109625, s: [0] }
          ],
          ix: 11
        },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.833, y: 0.833 },
              o: { x: 0.167, y: 0.167 },
              t: 0,
              s: [164, -262.25, 0],
              to: [0, 8.18, 0],
              ti: [0, -166.487, 0]
            },
            { t: 150.000006109625, s: [164, 785.75, 0] }
          ],
          ix: 2
        },
        a: { a: 0, k: [0, 0, 0], ix: 1 },
        s: { a: 0, k: [0.72, 1.263, 100], ix: 6 }
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              d: 1,
              ty: "el",
              s: { a: 0, k: [1820, 1024], ix: 2 },
              p: { a: 0, k: [0, 0], ix: 3 },
              nm: "Ellipse Path 1",
              mn: "ADBE Vector Shape - Ellipse",
              hd: false
            },
            {
              ty: "st",
              c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 0, ix: 5 },
              lc: 1,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: "Stroke 1",
              mn: "ADBE Vector Graphic - Stroke",
              hd: false
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 0.611764705882, 0.2, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [0, 0], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Ellipse 1",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false
        }
      ],
      ip: 0,
      op: 150.000006109625,
      st: 0,
      bm: 0
    },
    {
      ddd: 0,
      ind: 42,
      ty: 4,
      nm: "Shape Layer 26",
      sr: 1,
      ks: {
        o: {
          a: 1,
          k: [
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 0, s: [80] },
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 20, s: [80] },
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 40, s: [50] },
            { t: 150.000006109625, s: [0] }
          ],
          ix: 11
        },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.833, y: 0.833 },
              o: { x: 0.167, y: 0.167 },
              t: 0,
              s: [184, -178.25, 0],
              to: [0, 9.866, 0],
              ti: [0, -200.801, 0]
            },
            { t: 150.000006109625, s: [184, 489.75, 0] }
          ],
          ix: 2
        },
        a: { a: 0, k: [0, 0, 0], ix: 1 },
        s: { a: 0, k: [1.71, 3, 100], ix: 6 }
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              d: 1,
              ty: "el",
              s: { a: 0, k: [1820, 1024], ix: 2 },
              p: { a: 0, k: [0, 0], ix: 3 },
              nm: "Ellipse Path 1",
              mn: "ADBE Vector Shape - Ellipse",
              hd: false
            },
            {
              ty: "st",
              c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 0, ix: 5 },
              lc: 1,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: "Stroke 1",
              mn: "ADBE Vector Graphic - Stroke",
              hd: false
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 0.611764705882, 0.2, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [0, 0], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Ellipse 1",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false
        }
      ],
      ip: 0,
      op: 150.000006109625,
      st: 0,
      bm: 0
    },
    {
      ddd: 0,
      ind: 43,
      ty: 4,
      nm: "Shape Layer 25",
      sr: 1,
      ks: {
        o: {
          a: 1,
          k: [
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 0, s: [80] },
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 20, s: [80] },
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 40, s: [50] },
            { t: 150.000006109625, s: [0] }
          ],
          ix: 11
        },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.833, y: 0.833 },
              o: { x: 0.167, y: 0.167 },
              t: 0,
              s: [196, -206.25, 0],
              to: [0, 9.866, 0],
              ti: [0, -200.801, 0]
            },
            { t: 150.000006109625, s: [196, 1057.75, 0] }
          ],
          ix: 2
        },
        a: { a: 0, k: [0, 0, 0], ix: 1 },
        s: { a: 0, k: [1.71, 3, 100], ix: 6 }
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              d: 1,
              ty: "el",
              s: { a: 0, k: [1820, 1024], ix: 2 },
              p: { a: 0, k: [0, 0], ix: 3 },
              nm: "Ellipse Path 1",
              mn: "ADBE Vector Shape - Ellipse",
              hd: false
            },
            {
              ty: "st",
              c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 0, ix: 5 },
              lc: 1,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: "Stroke 1",
              mn: "ADBE Vector Graphic - Stroke",
              hd: false
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 0.611764705882, 0.2, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [0, 0], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Ellipse 1",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false
        }
      ],
      ip: 0,
      op: 150.000006109625,
      st: 0,
      bm: 0
    },
    {
      ddd: 0,
      ind: 44,
      ty: 4,
      nm: "Shape Layer 13",
      sr: 1,
      ks: {
        o: {
          a: 1,
          k: [
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 0, s: [80] },
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 20, s: [80] },
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 40, s: [50] },
            { t: 150.000006109625, s: [0] }
          ],
          ix: 11
        },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.833, y: 0.833 },
              o: { x: 0.167, y: 0.167 },
              t: 0,
              s: [68, -410.25, 0],
              to: [0, 9.866, 0],
              ti: [0, -200.801, 0]
            },
            { t: 150.000006109625, s: [68, 853.75, 0] }
          ],
          ix: 2
        },
        a: { a: 0, k: [0, 0, 0], ix: 1 },
        s: { a: 0, k: [1.71, 3, 100], ix: 6 }
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              d: 1,
              ty: "el",
              s: { a: 0, k: [1820, 1024], ix: 2 },
              p: { a: 0, k: [0, 0], ix: 3 },
              nm: "Ellipse Path 1",
              mn: "ADBE Vector Shape - Ellipse",
              hd: false
            },
            {
              ty: "st",
              c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 0, ix: 5 },
              lc: 1,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: "Stroke 1",
              mn: "ADBE Vector Graphic - Stroke",
              hd: false
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 0.611764705882, 0.2, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [0, 0], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Ellipse 1",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false
        }
      ],
      ip: 0,
      op: 150.000006109625,
      st: 0,
      bm: 0
    },
    {
      ddd: 0,
      ind: 45,
      ty: 4,
      nm: "Shape Layer 5",
      sr: 1,
      ks: {
        o: {
          a: 1,
          k: [
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 0, s: [80] },
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 20, s: [80] },
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 40, s: [50] },
            { t: 150.000006109625, s: [0] }
          ],
          ix: 11
        },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.833, y: 0.833 },
              o: { x: 0.167, y: 0.167 },
              t: 0,
              s: [92, -716.25, 0],
              to: [0, 9.866, 0],
              ti: [0, -200.801, 0]
            },
            { t: 150.000006109625, s: [92, 547.75, 0] }
          ],
          ix: 2
        },
        a: { a: 0, k: [0, 0, 0], ix: 1 },
        s: { a: 0, k: [1.71, 3, 100], ix: 6 }
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              d: 1,
              ty: "el",
              s: { a: 0, k: [1820, 1024], ix: 2 },
              p: { a: 0, k: [0, 0], ix: 3 },
              nm: "Ellipse Path 1",
              mn: "ADBE Vector Shape - Ellipse",
              hd: false
            },
            {
              ty: "st",
              c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 0, ix: 5 },
              lc: 1,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: "Stroke 1",
              mn: "ADBE Vector Graphic - Stroke",
              hd: false
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 0.611764705882, 0.2, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [0, 0], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Ellipse 1",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false
        }
      ],
      ip: 0,
      op: 150.000006109625,
      st: 0,
      bm: 0
    },
    {
      ddd: 0,
      ind: 46,
      ty: 4,
      nm: "Shape Layer 19",
      sr: 1,
      ks: {
        o: {
          a: 1,
          k: [
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 0, s: [80] },
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 47, s: [80] },
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 92, s: [100] },
            { t: 150.000006109625, s: [0] }
          ],
          ix: 11
        },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.833, y: 0.833 },
              o: { x: 0.167, y: 0.167 },
              t: 4,
              s: [140, -458.25, 0],
              to: [0, 178, 0],
              ti: [0, -178, 0]
            },
            { t: 150.000006109625, s: [140, 609.75, 0] }
          ],
          ix: 2
        },
        a: { a: 0, k: [0, 0, 0], ix: 1 },
        s: { a: 0, k: [1.14, 2, 100], ix: 6 }
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              d: 1,
              ty: "el",
              s: { a: 0, k: [1820, 1024], ix: 2 },
              p: { a: 0, k: [0, 0], ix: 3 },
              nm: "Ellipse Path 1",
              mn: "ADBE Vector Shape - Ellipse",
              hd: false
            },
            {
              ty: "st",
              c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 0, ix: 5 },
              lc: 1,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: "Stroke 1",
              mn: "ADBE Vector Graphic - Stroke",
              hd: false
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 0.611764705882, 0.2, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [0, 0], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Ellipse 1",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false
        }
      ],
      ip: 0,
      op: 150.000006109625,
      st: 0,
      bm: 0
    },
    {
      ddd: 0,
      ind: 47,
      ty: 4,
      nm: "Shape Layer 24",
      sr: 1,
      ks: {
        o: {
          a: 1,
          k: [
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 0, s: [80] },
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 47, s: [80] },
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 92, s: [100] },
            { t: 150.000006109625, s: [0] }
          ],
          ix: 11
        },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.833, y: 0.833 },
              o: { x: 0.167, y: 0.167 },
              t: 4,
              s: [18, -136.25, 0],
              to: [0, 178, 0],
              ti: [0, -178, 0]
            },
            { t: 150.000006109625, s: [18, 931.75, 0] }
          ],
          ix: 2
        },
        a: { a: 0, k: [0, 0, 0], ix: 1 },
        s: { a: 0, k: [1.14, 2, 100], ix: 6 }
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              d: 1,
              ty: "el",
              s: { a: 0, k: [1820, 1024], ix: 2 },
              p: { a: 0, k: [0, 0], ix: 3 },
              nm: "Ellipse Path 1",
              mn: "ADBE Vector Shape - Ellipse",
              hd: false
            },
            {
              ty: "st",
              c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 0, ix: 5 },
              lc: 1,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: "Stroke 1",
              mn: "ADBE Vector Graphic - Stroke",
              hd: false
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 0.611764705882, 0.2, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [0, 0], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Ellipse 1",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false
        }
      ],
      ip: 0,
      op: 150.000006109625,
      st: 0,
      bm: 0
    },
    {
      ddd: 0,
      ind: 48,
      ty: 4,
      nm: "Shape Layer 23",
      sr: 1,
      ks: {
        o: {
          a: 1,
          k: [
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 0, s: [80] },
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 47, s: [80] },
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 92, s: [100] },
            { t: 150.000006109625, s: [0] }
          ],
          ix: 11
        },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.833, y: 0.833 },
              o: { x: 0.167, y: 0.167 },
              t: 4,
              s: [150, -784.25, 0],
              to: [0, 178, 0],
              ti: [0, -178, 0]
            },
            { t: 150.000006109625, s: [150, 283.75, 0] }
          ],
          ix: 2
        },
        a: { a: 0, k: [0, 0, 0], ix: 1 },
        s: { a: 0, k: [1.14, 2, 100], ix: 6 }
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              d: 1,
              ty: "el",
              s: { a: 0, k: [1820, 1024], ix: 2 },
              p: { a: 0, k: [0, 0], ix: 3 },
              nm: "Ellipse Path 1",
              mn: "ADBE Vector Shape - Ellipse",
              hd: false
            },
            {
              ty: "st",
              c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 0, ix: 5 },
              lc: 1,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: "Stroke 1",
              mn: "ADBE Vector Graphic - Stroke",
              hd: false
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 0.611764705882, 0.2, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [0, 0], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Ellipse 1",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false
        }
      ],
      ip: 0,
      op: 150.000006109625,
      st: 0,
      bm: 0
    },
    {
      ddd: 0,
      ind: 49,
      ty: 4,
      nm: "Shape Layer 22",
      sr: 1,
      ks: {
        o: {
          a: 1,
          k: [
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 0, s: [80] },
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 47, s: [80] },
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 92, s: [100] },
            { t: 150.000006109625, s: [0] }
          ],
          ix: 11
        },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.833, y: 0.833 },
              o: { x: 0.167, y: 0.167 },
              t: 4,
              s: [36, -624.25, 0],
              to: [0, 178, 0],
              ti: [0, -178, 0]
            },
            { t: 150.000006109625, s: [36, 443.75, 0] }
          ],
          ix: 2
        },
        a: { a: 0, k: [0, 0, 0], ix: 1 },
        s: { a: 0, k: [1.14, 2, 100], ix: 6 }
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              d: 1,
              ty: "el",
              s: { a: 0, k: [1820, 1024], ix: 2 },
              p: { a: 0, k: [0, 0], ix: 3 },
              nm: "Ellipse Path 1",
              mn: "ADBE Vector Shape - Ellipse",
              hd: false
            },
            {
              ty: "st",
              c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 0, ix: 5 },
              lc: 1,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: "Stroke 1",
              mn: "ADBE Vector Graphic - Stroke",
              hd: false
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 0.611764705882, 0.2, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [0, 0], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Ellipse 1",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false
        }
      ],
      ip: 0,
      op: 150.000006109625,
      st: 0,
      bm: 0
    },
    {
      ddd: 0,
      ind: 50,
      ty: 4,
      nm: "Shape Layer 12",
      sr: 1,
      ks: {
        o: {
          a: 1,
          k: [
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 0, s: [80] },
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 47, s: [80] },
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 92, s: [100] },
            { t: 150.000006109625, s: [0] }
          ],
          ix: 11
        },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.833, y: 0.833 },
              o: { x: 0.167, y: 0.167 },
              t: 4,
              s: [204, -204.25, 0],
              to: [0, 178, 0],
              ti: [0, -178, 0]
            },
            { t: 150.000006109625, s: [204, 863.75, 0] }
          ],
          ix: 2
        },
        a: { a: 0, k: [0, 0, 0], ix: 1 },
        s: { a: 0, k: [1.14, 2, 100], ix: 6 }
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              d: 1,
              ty: "el",
              s: { a: 0, k: [1820, 1024], ix: 2 },
              p: { a: 0, k: [0, 0], ix: 3 },
              nm: "Ellipse Path 1",
              mn: "ADBE Vector Shape - Ellipse",
              hd: false
            },
            {
              ty: "st",
              c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 0, ix: 5 },
              lc: 1,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: "Stroke 1",
              mn: "ADBE Vector Graphic - Stroke",
              hd: false
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 0.611764705882, 0.2, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [0, 0], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Ellipse 1",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false
        }
      ],
      ip: 0,
      op: 150.000006109625,
      st: 0,
      bm: 0
    },
    {
      ddd: 0,
      ind: 51,
      ty: 4,
      nm: "Shape Layer 21",
      sr: 1,
      ks: {
        o: {
          a: 1,
          k: [
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 0, s: [80] },
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 47, s: [80] },
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 92, s: [100] },
            { t: 150.000006109625, s: [0] }
          ],
          ix: 11
        },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.833, y: 0.833 },
              o: { x: 0.167, y: 0.167 },
              t: 4,
              s: [210, -624.25, 0],
              to: [0, 178, 0],
              ti: [0, -178, 0]
            },
            { t: 152.000006191087, s: [210, 443.75, 0] }
          ],
          ix: 2
        },
        a: { a: 0, k: [0, 0, 0], ix: 1 },
        s: { a: 0, k: [1.14, 2, 100], ix: 6 }
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              d: 1,
              ty: "el",
              s: { a: 0, k: [1820, 1024], ix: 2 },
              p: { a: 0, k: [0, 0], ix: 3 },
              nm: "Ellipse Path 1",
              mn: "ADBE Vector Shape - Ellipse",
              hd: false
            },
            {
              ty: "st",
              c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 0, ix: 5 },
              lc: 1,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: "Stroke 1",
              mn: "ADBE Vector Graphic - Stroke",
              hd: false
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 0.611764705882, 0.2, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [0, 0], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Ellipse 1",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false
        }
      ],
      ip: 0,
      op: 150.000006109625,
      st: 0,
      bm: 0
    },
    {
      ddd: 0,
      ind: 52,
      ty: 4,
      nm: "Shape Layer 3",
      sr: 1,
      ks: {
        o: {
          a: 1,
          k: [
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 0, s: [80] },
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 47, s: [80] },
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 92, s: [100] },
            { t: 150.000006109625, s: [0] }
          ],
          ix: 11
        },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.833, y: 0.833 },
              o: { x: 0.167, y: 0.167 },
              t: 4,
              s: [26, -36.25, 0],
              to: [0, 0, 0],
              ti: [0, 0, 0]
            },
            {
              i: { x: 0.833, y: 0.833 },
              o: { x: 0.167, y: 0.167 },
              t: 19,
              s: [26, -36.25, 0],
              to: [0, 178, 0],
              ti: [0, -178, 0]
            },
            { t: 131.000005335739, s: [26, 1031.75, 0] }
          ],
          ix: 2
        },
        a: { a: 0, k: [0, 0, 0], ix: 1 },
        s: { a: 0, k: [1.14, 2, 100], ix: 6 }
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              d: 1,
              ty: "el",
              s: { a: 0, k: [1820, 1024], ix: 2 },
              p: { a: 0, k: [0, 0], ix: 3 },
              nm: "Ellipse Path 1",
              mn: "ADBE Vector Shape - Ellipse",
              hd: false
            },
            {
              ty: "st",
              c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 0, ix: 5 },
              lc: 1,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: "Stroke 1",
              mn: "ADBE Vector Graphic - Stroke",
              hd: false
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 0.611764705882, 0.2, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [0, 0], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Ellipse 1",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false
        }
      ],
      ip: 0,
      op: 150.000006109625,
      st: 0,
      bm: 0
    }
  ],
  markers: []
};
var animations = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  confetti
}, Symbol.toStringTag, { value: "Module" }));
const INTERNAL_ONLY_ANIMATION_TYPES = ["confetti"];
const animationMapping = (type) => {
  if (INTERNAL_ONLY_ANIMATION_TYPES.includes(type)) {
    return animations[type];
  }
  throw new Error(`Animation type: ${type} does not exist`);
};
const defaultOptions = {
  loop: true,
  autoplay: true,
  rendererSettings: {
    preserveAspectRatio: "xMidYMid slice"
  },
  animationData: "null"
};
const Animation = (_qa) => {
  var _ra = _qa, {
    loop = defaultOptions.loop,
    autoplay = defaultOptions.autoplay,
    lottieProps,
    variant,
    sx
  } = _ra, props = __objRest(_ra, [
    "loop",
    "autoplay",
    "lottieProps",
    "variant",
    "sx"
  ]);
  const lottieOptions = __spreadProps(__spreadValues({}, lottieProps), {
    options: __spreadProps(__spreadValues({}, defaultOptions), {
      animationData: animationMapping(variant),
      loop,
      autoplay
    })
  });
  return jsx(Lottie, __spreadValues(__spreadValues(__spreadValues({}, lottieOptions), sx), props));
};
const MOBILE_BREAKPOINT = `@media only screen and (max-width :56em)`;
const loanCardStyles = {
  rowHeader: {
    alignItems: "center",
    backgroundColor: "#f5f5f5",
    display: "flex",
    height: 30,
    [MOBILE_BREAKPOINT]: {
      display: "none"
    }
  },
  row: {
    display: "flex",
    flexDirection: "column"
  },
  rowTitle: {
    fontWeight: 700,
    paddingLeft: 3
  },
  cartTitle: {
    alignItems: "center",
    borderBottom: "1px solid #d7d7d7",
    display: "flex",
    fontSize: 16,
    fontWeight: 700,
    justifyContent: "center",
    minHeight: 50,
    [MOBILE_BREAKPOINT]: {
      display: "none"
    }
  },
  cellValue: {
    alignItems: "center",
    display: "flex",
    lineHeight: "16px",
    minHeight: 50,
    textAlign: "center"
  },
  cellWrapper: {
    display: "flex",
    alignItems: "center",
    position: "relative",
    [MOBILE_BREAKPOINT]: {
      display: "block"
    }
  },
  label: {
    color: "neutral.l1",
    display: "flex",
    fontSize: 12,
    lineHeight: "14px",
    marginBottom: 1,
    textAlign: "center",
    [MOBILE_BREAKPOINT]: {
      color: "neutral.l1",
      fontWeight: 500,
      fontSize: 14,
      textAlign: "left"
    }
  },
  cellContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    paddingLeft: 3,
    paddingRight: 3
  },
  mobileLabel: {
    display: "none",
    [MOBILE_BREAKPOINT]: {
      display: "block",
      color: "neutral.l1",
      fontWeight: 500,
      marginTop: 10
    }
  },
  headerStyle: {
    [MOBILE_BREAKPOINT]: {
      backgroundColor: "neutral.l4",
      display: "flex"
    }
  },
  mobileTitle: {
    display: "none",
    [MOBILE_BREAKPOINT]: {
      backgroundColor: "neutral.l4",
      display: "flex",
      width: " 100%",
      fontSize: 16,
      fontWeight: 700,
      minHeight: 50,
      alignItems: "center",
      borderRadius: "10px 10px 0 0",
      padding: 3
    }
  }
};
const styles = {
  container: {
    padding: 3
  },
  button: {
    width: "100%"
  },
  text: {
    fontSize: 12,
    fontStyle: "italic",
    lineHeight: "12px"
  },
  footerDisclaimer: {
    display: "none",
    [MOBILE_BREAKPOINT]: {
      color: "neutral.l1",
      fontSize: 12,
      fontStyle: "italic",
      lineHeight: "12px",
      display: "flex"
    }
  }
};
const LoanCardFooter = ({
  config
}) => {
  const {
    footerDisclaimer,
    text,
    textAlign,
    button
  } = config;
  return jsxs("footer", {
    sx: __spreadProps(__spreadValues({}, styles.container), {
      textAlign
    }),
    children: [text && jsx("span", {
      sx: styles.text,
      children: text
    }), button && jsx(Button, {
      onClick: button.onClick,
      variant: button.variant,
      sx: __spreadProps(__spreadValues({}, styles.button), {
        marginTop: button && text ? 3 : 0,
        marginBottom: footerDisclaimer ? 3 : 0
      }),
      children: button.label
    }), footerDisclaimer && jsx("span", {
      sx: styles.footerDisclaimer,
      children: footerDisclaimer
    })]
  });
};
var LoanCardFooter$1 = memo(LoanCardFooter);
const borderStyle$2 = "1px solid #d7d7d7";
const createRowKey$1 = (rowId, value, label, mobileLabel) => value || label ? `${value == null ? void 0 : value.toString()}-${label == null ? void 0 : label.toString()}-${mobileLabel == null ? void 0 : mobileLabel.toString()}-${rowId}` : rowId;
const WarningIcon$1 = jsx(Icon, {
  color: "orange",
  variant: "color-warning",
  size: "sm",
  sx: {
    position: "absolute",
    left: "-24px",
    [MOBILE_BREAKPOINT]: {
      position: "relative",
      left: 0,
      marginRight: 1,
      marginTop: 0
    }
  }
});
const LoanPaymentsRow = ({
  alignItems,
  hasPaymentsBorders,
  isActive,
  config: {
    dataSource,
    rowTitle,
    rowsCount
  }
}) => jsxs("div", {
  sx: loanCardStyles.row,
  children: [jsx("div", {
    sx: loanCardStyles.rowHeader,
    children: rowTitle && jsx("span", {
      sx: loanCardStyles.rowTitle,
      children: rowTitle
    })
  }), jsxs("div", {
    sx: {
      opacity: isActive ? 1 : 0.7
    },
    children: [dataSource == null ? void 0 : dataSource.map(({
      value,
      paymentLabel,
      hasWarning,
      mobileLabel
    }, rowId) => {
      const cellContainerStyle = __spreadProps(__spreadValues({}, loanCardStyles.cellContainer), {
        alignItems,
        borderTop: hasPaymentsBorders ? borderStyle$2 : "none",
        borderBottom: hasPaymentsBorders ? borderStyle$2 : "none",
        minHeight: 80,
        [MOBILE_BREAKPOINT]: {
          display: "block",
          minHeight: 20,
          marginTop: 20,
          marginBottom: 20,
          borderTop: "none"
        }
      });
      return jsxs("div", {
        sx: cellContainerStyle,
        children: [jsx("span", {
          sx: loanCardStyles.label,
          children: mobileLabel
        }), jsx("span", {
          sx: loanCardStyles.label,
          children: paymentLabel
        }), jsxs("div", {
          sx: __spreadProps(__spreadValues({}, loanCardStyles.cellWrapper), {
            [MOBILE_BREAKPOINT]: {
              display: "flex",
              marginTop: 3
            }
          }),
          children: [hasWarning && WarningIcon$1, jsx("span", {
            children: value
          })]
        })]
      }, createRowKey$1(rowId, value, paymentLabel));
    }), dataSource && rowsCount && dataSource.length <= rowsCount && jsx("div", {
      sx: {
        borderBottom: borderStyle$2
      },
      children: new Array(rowsCount - dataSource.length).fill(null).map((_, id) => jsx("div", {
        sx: {
          height: 80
        }
      }, id))
    })]
  })]
});
const borderStyle$1 = "1px solid #d7d7d7";
const createRowKey = (rowId, value, label, mobileLabel) => value || label ? `${value == null ? void 0 : value.toString()}-${label == null ? void 0 : label.toString()}-${mobileLabel == null ? void 0 : mobileLabel.toString()}-${rowId}` : rowId;
const WarningIcon = jsx(Icon, {
  color: "orange",
  variant: "color-warning",
  size: "sm",
  sx: {
    position: "absolute",
    left: "-24px",
    top: "13px",
    [MOBILE_BREAKPOINT]: {
      position: "relative",
      left: 0,
      top: 2,
      marginRight: 1
    }
  }
});
const LoanCardRow = ({
  alignItems,
  isActive,
  config: {
    dataSource,
    rowTitle
  }
}) => jsxs("div", {
  sx: loanCardStyles.row,
  children: [jsx("div", {
    sx: loanCardStyles.rowHeader,
    children: rowTitle && jsx("span", {
      sx: loanCardStyles.rowTitle,
      children: rowTitle
    })
  }), jsx("div", {
    sx: {
      opacity: isActive ? 1 : 0.7,
      [MOBILE_BREAKPOINT]: {
        borderBottom: borderStyle$1
      }
    },
    children: dataSource == null ? void 0 : dataSource.map(({
      value,
      label,
      hasWarning,
      mobileLabel
    }, rowId) => {
      const cellContainerStyle = __spreadProps(__spreadValues({}, loanCardStyles.cellContainer), {
        alignItems,
        borderTop: !(value || label) ? "none" : borderStyle$1,
        borderBottom: !(value || label) ? "none" : borderStyle$1,
        [MOBILE_BREAKPOINT]: {
          display: "block",
          borderTop: "none",
          borderBottom: "none"
        }
      });
      const cellStyle = __spreadProps(__spreadValues({}, loanCardStyles.cellValue), {
        fontWeight: hasWarning ? 700 : "normal",
        [MOBILE_BREAKPOINT]: {
          paddingBottom: 10
        }
      });
      return jsx("div", {
        sx: cellContainerStyle,
        children: jsxs("div", {
          sx: loanCardStyles.cellWrapper,
          children: [jsx("span", {
            sx: loanCardStyles.mobileLabel,
            children: mobileLabel
          }), jsx("span", {
            children: label
          }), jsxs("div", {
            sx: {
              display: "flex"
            },
            children: [hasWarning && WarningIcon, jsx("span", {
              sx: cellStyle,
              children: value
            })]
          })]
        })
      }, createRowKey(rowId, value, label, mobileLabel));
    })
  })]
});
const activeBorderStyle = "2px solid #00838f";
const borderStyle = "1px solid #d7d7d7";
const borderRadius = "0.25em";
const LoanCard = ({
  alignItems = "center",
  amountConfig,
  borderLeft,
  borderRight,
  detailsConfig,
  footerConfig,
  hasPaymentsBorders,
  isActive = false,
  paymentsConfig,
  title,
  width = 300
}) => {
  const cardStyle = useMemo(() => ({
    border: isActive ? activeBorderStyle : "none",
    [MOBILE_BREAKPOINT]: {
      border: isActive ? "0.5px solid #00838f" : "none",
      borderTop: "none",
      width: "100%"
    },
    borderRadius: 0,
    borderBottomLeftRadius: borderLeft ? borderRadius : "auto",
    borderTopLeftRadius: borderLeft ? borderRadius : "auto",
    borderBottomRightRadius: borderRight ? borderRadius : "auto",
    borderTopRightRadius: borderRight ? borderRadius : "auto",
    borderTop: isActive ? activeBorderStyle : "2px solid transparent",
    outline: borderStyle,
    padding: 0,
    width
  }), [borderLeft, borderRight, isActive, width]);
  return jsxs("div", {
    sx: {
      display: "flex",
      [MOBILE_BREAKPOINT]: {
        display: "block",
        marginBottom: 3
      }
    },
    children: [jsx("header", {
      sx: loanCardStyles.mobileTitle,
      children: title
    }), jsxs(Card, {
      sx: cardStyle,
      children: [jsx("header", {
        sx: loanCardStyles.cartTitle,
        children: title
      }), jsx(LoanCardRow, {
        alignItems,
        config: amountConfig,
        isActive
      }), jsx(LoanCardRow, {
        alignItems,
        config: detailsConfig,
        isActive
      }), jsx(LoanPaymentsRow, {
        alignItems,
        config: paymentsConfig,
        hasPaymentsBorders,
        isActive
      }), footerConfig && jsx(LoanCardFooter$1, {
        config: footerConfig
      })]
    })]
  });
};
var loanCard = memo(LoanCard);
const CompletionContainer = ({
  initialOpen = false,
  status = "incomplete",
  title,
  isFocused = false,
  description,
  content
}) => {
  const prefix = React.useMemo(() => v4(), []);
  const [isCollapsed, toggleCollapse] = React.useState(isFocused ? false : !initialOpen);
  const iconVariant = {
    incomplete: {
      icon: "circle",
      status: "Incomplete: ",
      styles: {
        fontSize: 24,
        transform: "translateX(-1px)",
        color: "neutral.l2"
      }
    },
    warning: {
      icon: "color-warning",
      status: "Warning: ",
      styles: {
        transform: "translateX(-.5px)",
        width: 24,
        height: 24
      }
    },
    danger: {
      icon: "color-danger",
      status: "Critical: ",
      styles: {
        transform: "translateX(-1px)",
        width: 25,
        height: 25
      }
    },
    complete: {
      icon: "color-success",
      status: "Complete: ",
      styles: {
        transform: "translateX(-1px)",
        width: 25,
        height: 25
      }
    },
    inProgress: {
      icon: "in-progress",
      status: "In Progress: ",
      styles: {
        transform: "translateX(-1px)",
        width: 25,
        height: 25
      }
    }
  };
  const boxStyles = !isCollapsed ? {
    border: "1px solid",
    bg: isFocused ? "primary.l4" : "background.depth.0",
    py: 2,
    mb: 2,
    px: 2,
    borderRadius: "rounded",
    borderColor: isFocused ? "primary.l4" : "neutral.l2"
  } : {};
  const section = `${prefix}-section`;
  const titleAria = `${prefix}-title`;
  return jsxs(Box, {
    as: "li",
    sx: __spreadValues({
      display: "grid",
      gridTemplateColumns: "24px 32px 1fr",
      gap: 1,
      alignItems: "flex-start",
      position: "relative",
      px: "9px"
    }, boxStyles),
    children: [jsx(Box, {
      className: "icon-container",
      sx: {
        height: "100%",
        bg: !isCollapsed ? "transparent !important" : void 0
      },
      children: jsx(Box, {
        sx: {
          overflow: "hidden",
          width: 24,
          height: 24,
          bg: isCollapsed ? "background.depth.0" : "transparent",
          py: "2px",
          boxSizing: "content-box"
        },
        children: jsx(Icon, {
          variant: iconVariant[status].icon,
          sx: iconVariant[status].styles
        })
      })
    }), jsxs(Button, {
      variant: "ghost",
      onClick: () => toggleCollapse(!isCollapsed),
      sx: {
        px: 0,
        mt: "-2px",
        py: 0,
        height: 24,
        width: "100%",
        color: "neutral.base"
      },
      children: [jsx(Icon, {
        variant: isCollapsed ? "angle-right" : "angle-down"
      }), jsx(VisuallyHidden, {
        children: isCollapsed ? "Show" : "Hide"
      })]
    }), jsxs(Box, {
      sx: {
        pb: 3
      },
      children: [jsxs(Box, {
        as: "button",
        "aria-expanded": isCollapsed,
        "aria-controls": section,
        onClick: () => toggleCollapse(!isCollapsed),
        sx: {
          border: "none",
          bg: "transparent",
          textAlign: "left",
          p: 0,
          cursor: "pointer"
        },
        children: [jsxs(Heading, {
          id: titleAria,
          variant: "h5",
          as: "h4",
          children: [jsx(VisuallyHidden, {
            children: iconVariant[status].status
          }), title]
        }), description && jsx(Box, {
          variant: "text.small",
          sx: {
            color: "neutral.l1"
          },
          children: description
        })]
      }), jsx(Box, {
        id: section,
        "aria-labelledby": titleAria,
        role: "region",
        children: !isCollapsed && jsx(Box, {
          sx: {
            mt: 1
          },
          children: content
        })
      })]
    })]
  });
};
const CompletionList = ({
  items
}) => {
  const content = items.map((x) => createElement(CompletionContainer, __spreadProps(__spreadValues({}, x), {
    key: x.title.replace(/ /g, "-")
  })));
  return jsxs(Box, {
    as: "ul",
    sx: {
      listStyleType: "none",
      pl: 0,
      position: "relative",
      "& li:last-of-type .icon-container": {
        bg: "white"
      }
    },
    children: [jsx(Box, {
      role: "presentation",
      "aria-hidden": true,
      sx: {
        position: "absolute",
        left: 19,
        top: 0,
        height: "100%",
        bg: "neutral.l2",
        width: 2
      }
    }), content]
  });
};
const DataList = React.forwardRef((_sa, ref) => {
  var _ta = _sa, {
    columns = [1, 2, 3],
    items = [],
    children
  } = _ta, rest = __objRest(_ta, [
    "columns",
    "items",
    "children"
  ]);
  return jsxs(Grid, __spreadProps(__spreadValues({
    as: "dl",
    ref,
    columns
  }, rest), {
    children: [items.map(({
      text,
      label,
      textStyles,
      titleStyles
    }) => {
      const key = label.replace(/ /g, "-");
      return jsxs(Box, {
        children: [jsxs(Box, {
          as: "dt",
          sx: __spreadValues({
            variant: "text.small",
            fontWeight: 500,
            color: "neutral.base",
            display: "flex",
            alignItems: "center",
            mb: "2px"
          }, titleStyles == null ? void 0 : titleStyles.sx),
          children: [label, (titleStyles == null ? void 0 : titleStyles.icon) && jsx(Icon, __spreadValues({
            size: "sm",
            sx: {
              ml: (titleStyles == null ? void 0 : titleStyles.icon.variant.includes("color")) ? 1 : 0
            }
          }, titleStyles == null ? void 0 : titleStyles.icon))]
        }), jsxs(Box, {
          as: "dd",
          sx: __spreadValues({
            display: "flex",
            alignItems: "center"
          }, textStyles == null ? void 0 : textStyles.sx),
          children: [text, text === void 0 || text === null && jsx(VisuallyHidden, {
            children: "No definition available"
          }), (textStyles == null ? void 0 : textStyles.icon) && jsx(Icon, __spreadValues({
            size: "sm",
            sx: {
              ml: (textStyles == null ? void 0 : textStyles.icon.variant.includes("color")) ? 1 : 0
            }
          }, textStyles == null ? void 0 : textStyles.icon))]
        })]
      }, key);
    }), children]
  }));
});
const isLinkItem = (x) => Boolean(x.onSelect === void 0);
const isSeperatorItem = (x) => x.type === "seperator";
const Menu = ({
  children,
  listItems,
  sx = {},
  variant = "primary",
  menuButtonProps
}) => {
  const styles2 = {
    py: 2,
    px: "6px",
    width: "100%",
    display: "block",
    textDecoration: "none",
    color: "text.positive",
    cursor: "pointer",
    "&[data-selected]": {
      bg: "primary.l4"
    }
  };
  const itemsWithKeys = React.useMemo(() => listItems.map((x) => Object.assign({}, x, {
    key: v4()
  })), [listItems]);
  return jsxs(Box, {
    as: Menu$3,
    sx,
    children: [jsx(Box, __spreadProps(__spreadValues({
      as: MenuButton
    }, menuButtonProps), {
      variant: `buttons.${variant}`,
      children
    })), jsx(Card, {
      variant: "float",
      as: MenuList,
      sx: {
        p: 0,
        borderRadius: "rounded",
        minWidth: 192,
        "&:focus": {
          outline: "none"
        }
      },
      children: itemsWithKeys.map((item) => {
        if (isSeperatorItem(item))
          return jsx(Box, {
            sx: {
              borderTop: "1px solid",
              borderColor: "neutral.l3",
              my: 2,
              mx: 1
            }
          }, item.key);
        const _a = item, {
          content,
          key
        } = _a, rest = __objRest(_a, [
          "content",
          "key"
        ]);
        if (isLinkItem(item)) {
          return jsx(Box, __spreadProps(__spreadValues({
            as: MenuLink
          }, rest), {
            sx: styles2,
            children: content
          }), key);
        }
        return jsx(Box, __spreadProps(__spreadValues({
          as: MenuItem$1
        }, rest), {
          sx: styles2,
          children: content
        }), key);
      })
    })]
  });
};
const DrawerControlType = {
  CONFIRMATION_TOOLTIP: "CONFIRMATION_TOOLTIP",
  DEFAULT: "DEFAULT"
};
const DrawerControls = ({
  actions
}) => {
  if (actions.length > 3) {
    console.warn("Drawer component given actions array length greater than 3");
  }
  const buttonBasedOnType = (props, index) => {
    const {
      label,
      drawerControlType,
      content
    } = props;
    switch (drawerControlType) {
      case DrawerControlType.CONFIRMATION_TOOLTIP:
        return jsx(ButtonConfirmationTooltip, __spreadProps(__spreadValues({
          buttonLabel: label
        }, props), {
          children: content
        }));
      default:
        return jsx(Button, __spreadProps(__spreadValues({
          sx: {
            my: [1, 0],
            mr: index === 2 ? "auto" : void 0
          },
          variant: index === 0 ? "primary" : "secondary"
        }, props), {
          children: label
        }));
    }
  };
  return jsx(Box, {
    sx: {
      px: 3,
      py: 3,
      position: ["static", "fixed"],
      bottom: 0,
      alignItems: "center",
      display: "flex",
      flexFlow: ["column", "row-reverse"],
      gap: [0, 2],
      ml: [0, -3],
      mr: [0, -3],
      mb: [-3, 0],
      mt: [3, 0],
      maxWidth: "100%",
      width: "100%",
      borderTop: "1px solid",
      borderColor: "neutral.l3",
      "& > button": {
        minWidth: ["100%", 180]
      }
    },
    children: actions.map((props, index) => {
      const key = ["primary", "secondary", "tertiary"];
      return jsx(React.Fragment, {
        children: buttonBasedOnType(props, index)
      }, key[index]);
    })
  });
};
const Drawer = (_ua) => {
  var _va = _ua, {
    title,
    children,
    descriptionList = [],
    isOpen,
    dimension = 0,
    variant = "base",
    backAction,
    onDismiss,
    sx = {}
  } = _va, rest = __objRest(_va, [
    "title",
    "children",
    "descriptionList",
    "isOpen",
    "dimension",
    "variant",
    "backAction",
    "onDismiss",
    "sx"
  ]);
  const drawerPrefix = React.useMemo(() => v4(), []);
  React.useEffect(() => {
    if (typeof window !== "undefined") {
      Modal$1.setAppElement("#root");
    }
  }, []);
  React.useEffect(() => {
    if (!document)
      return () => {
      };
    if (isOpen) {
      document.body.classList.add("no-scroll");
    } else {
      document.body.classList.remove("no-scroll");
    }
    return () => {
      document.body.classList.remove("no-scroll");
    };
  }, [isOpen]);
  const titleId = `${drawerPrefix}-title`;
  const width = {
    base: [624, 1248, "100%"],
    small: [360, 720, "100%"]
  };
  return jsx(Modal$1, {
    portalClassName: "modal-drawer",
    shouldCloseOnOverlayClick: true,
    onRequestClose: () => onDismiss(),
    isOpen,
    aria: {
      labelledby: titleId
    },
    style: {
      overlay: {
        zIndex: 999
      }
    },
    children: jsxs(Box, __spreadProps(__spreadValues({}, rest), {
      sx: __spreadProps(__spreadValues({}, sx), {
        height: "100%",
        position: "absolute",
        right: 0,
        bg: "white",
        maxWidth: width[variant][dimension] || 624,
        width: "100%",
        boxShadow: "drawer",
        overflow: ["auto", "visible"],
        display: "grid",
        gridTemplateRows: ["56px 1fr auto", "56px calc(100vh - 120px) 64px"]
      }),
      children: [jsxs(Box, {
        sx: {
          bg: "primary.d3",
          height: 56,
          display: "grid",
          alignItems: "center",
          px: 3,
          gridTemplateColumns: "1fr 45px",
          color: "text.negative"
        },
        children: [jsx(Heading, {
          id: titleId,
          variant: "h3",
          children: title
        }), jsx(Button, {
          onClick: onDismiss,
          variant: "ghost",
          sx: {
            p: 0,
            color: "text.negative",
            "&:hover": {
              bg: "primary.d1"
            }
          },
          "aria-label": "Dismiss",
          children: jsx(Icon, {
            "aria-hidden": "true",
            role: "presentation",
            variant: "times",
            size: "lg"
          })
        })]
      }), jsxs(Box, {
        sx: {
          overflowY: ["visible", "auto"]
        },
        children: [backAction && jsx(Box, {
          sx: {
            bg: "neutral.l4",
            borderBottom: "1px solid",
            py: 1,
            borderColor: "neutral.l3"
          },
          children: jsxs(Button, {
            onClick: backAction.onClick,
            variant: "ghost",
            sx: {
              textTransform: "none",
              fontSize: 2,
              color: "primary.base"
            },
            children: [jsx(Icon, {
              variant: "color-back",
              "aria-hidden": "true",
              sx: {
                mr: 2
              },
              size: "md"
            }), backAction.label]
          })
        }), Boolean(descriptionList.length) && jsx(DataList, {
          sx: {
            bg: "neutral.l4",
            p: 3
          },
          items: descriptionList
        }), jsx(Box, {
          sx: {
            p: 3,
            height: "100%"
          },
          children
        })]
      })]
    }))
  });
};
const sizeVariants$5 = {
  xs: "110px",
  sm: "160px",
  md: "230px",
  lg: "320px",
  xl: "640px"
};
const Loanpal = (_wa) => {
  var _xa = _wa, {
    size = "md",
    invert = false,
    sx
  } = _xa, rest = __objRest(_xa, [
    "size",
    "invert",
    "sx"
  ]);
  return jsxs("svg", __spreadProps(__spreadValues({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 612 183",
    xmlSpace: "preserve"
  }, rest), {
    sx: __spreadProps(__spreadValues({}, sx), {
      width: Array.isArray(size) ? size.map((x) => sizeVariants$5[x]) : sizeVariants$5[size],
      height: "auto"
    }),
    children: [jsx("title", {
      children: "Loanpal"
    }), jsxs(Box, {
      as: "g",
      sx: {
        fill: invert ? "text.negative" : "logo.text"
      },
      children: [jsx("path", {
        d: "M10.6,46.8c0-1.4,1.1-2.6,2.6-2.6h5.3c1.4,0,2.6,1.2,2.6,2.6v72.7c0,8.9,1.8,11,9.4,11h29.8 c1.5,0,2.6,1.2,2.6,2.6v3.9c0,1.4-1.1,2.6-2.6,2.6H23c-6.7,0-12.4-4.2-12.4-12.7V46.8z"
      }), jsx("path", {
        d: "M187.9,136l41.4-91.7c0.4-0.8,1.1-1.5,2.3-1.5h1.4c1.2,0,1.9,0.7,2.3,1.5l41.1,91.7c0.8,1.8-0.3,3.5-2.3,3.5 h-5.4c-1.2,0-2-0.8-2.3-1.5l-10.1-22.5h-48.3L198,138c-0.3,0.7-1.1,1.5-2.3,1.5h-5.4C188.2,139.5,187.1,137.8,187.9,136z M252.6,107.1c-6.7-14.8-13.2-29.8-19.9-44.7h-1.1l-19.9,44.7H252.6z"
      }), jsx("path", {
        d: "M304.1,42.8h-3.4c-1.4,0-2.6,1.1-2.6,2.5v91.7c0,1.4,1.2,2.6,2.6,2.6h4.8c1.5,0,2.6-1.2,2.6-2.6V62.9h0.1 l60.6,75.9l-0.4-15.7L304.1,42.8z"
      }), jsx("path", {
        d: "M367.9,46.8c0-1.4,1.1-2.6,2.6-2.6h32c16.7,0,30.5,13.6,30.5,30.1c0,16.9-13.8,30.6-30.4,30.6h-17v32 c0,1.4-1.2,2.6-2.6,2.6l-13.7,0l-1.4-1.8V46.8z M401.4,88.3c7.6,0,14-6.1,14-14.2c0-7.5-6.4-13.2-14-13.2h-15.8v27.4H401.4z"
      }), jsx("path", {
        d: "M437.7,136L480,44.3c0.4-0.8,1.1-1.5,2.3-1.5h1.4c1.4,0,1.9,0.7,2.3,1.5L528,136c0.8,1.8-0.3,3.5-2.3,3.5 h-11.8c-2,0-3-0.8-3.9-2.7l-6.7-14.7h-40.7l-6.7,14.7c-0.5,1.4-1.8,2.7-3.9,2.7H440C437.9,139.5,436.9,137.8,437.7,136z M496.5,107 l-13.6-30h-0.4l-13.3,30H496.5z"
      }), jsx("path", {
        d: "M547.2,46.8c0-1.4,1.1-2.6,2.6-2.6h12.5c1.4,0,2.6,1.2,2.6,2.6v76.4h34.7c1.5,0,2.6,1.2,2.6,2.6v11.2 c0,1.4-1.1,2.6-2.6,2.6h-49.8c-1.5,0-2.6-1.2-2.6-2.6V46.8z"
      })]
    }), jsxs(Box, {
      as: "g",
      sx: {
        fill: "logo.icon"
      },
      children: [jsx("path", {
        d: "M125.1,42.4c27.3,0,49.2,21.9,49.2,49.2s-21.9,49-49.2,49s-49-21.6-49-49S98,42.4,125.1,42.4z M125.1,131.2 c21.6,0,39.6-17.7,39.6-39.3S146.7,52,125.1,52S85.7,70,85.7,91.8C85.7,113.2,103.4,131.2,125.1,131.2z"
      }), jsx("path", {
        d: "M101.2,107.5c0.2-0.1,0.4-0.1,0.6,0c5.3,2.9,9.4,4.3,13.3,5.1c3.7,0.8,7,1.2,10.1,1.2c3.1,0,6.3-0.1,10-1 c3.6-0.9,7.9-2.2,13.2-5c0.2-0.1,0.4-0.1,0.6,0c0.4,0.2,0.6,0.6,0.4,1c-2.2,4.6-5.2,8.4-9.4,11.4c-4.3,2.9-9.6,4.7-15,4.5 c-5.2-0.2-10.5-1.9-14.9-4.9c-2.2-1.5-4.2-3.2-5.7-5.4c-1.4-2-2.7-4-3.6-6.2C100.8,108.1,100.9,107.7,101.2,107.5z"
      })]
    })]
  }));
};
const sizeVariants$4 = {
  xs: "32px",
  sm: "50px",
  md: "72px",
  lg: "96px",
  xl: "128px"
};
const LoanpalIcon = (_ya) => {
  var _za = _ya, {
    size = "md",
    sx
  } = _za, rest = __objRest(_za, [
    "size",
    "sx"
  ]);
  return jsxs("svg", __spreadProps(__spreadValues({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 300 300",
    xmlSpace: "preserve"
  }, rest), {
    sx: __spreadValues({
      width: Array.isArray(size) ? size.map((x) => sizeVariants$4[x]) : sizeVariants$4[size],
      height: "auto"
    }, sx),
    children: [jsx("title", {
      children: "Loanpal"
    }), jsxs(Box, {
      as: "g",
      sx: {
        fill: "logo.icon"
      },
      children: [jsx("path", {
        d: "M149.1,63c48.5,0,87.4,38.9,87.4,87.4s-38.9,87-87.4,87s-87-38.4-87-87S100.9,63,149.1,63z M149.1,220.6 c38.4,0,70.3-31.4,70.3-69.8s-31.8-70.7-70.3-70.7s-70,31.8-70,70.5C79.1,188.8,110.5,220.6,149.1,220.6z"
      }), jsx("path", {
        d: "M106.6,178.7c0.4-0.2,0.7-0.2,1.1,0c9.4,5.2,16.7,7.6,23.6,9.1c6.6,1.4,12.4,2.1,17.9,2.1 c5.5,0,11.2-0.2,17.8-1.8c6.4-1.6,14-3.9,23.4-8.9c0.4-0.2,0.7-0.2,1.1,0c0.7,0.4,1.1,1.1,0.7,1.8c-3.9,8.2-9.2,14.9-16.7,20.3 c-7.6,5.2-17.1,8.3-26.6,8c-9.2-0.4-18.7-3.4-26.5-8.7c-3.9-2.7-7.5-5.7-10.1-9.6c-2.5-3.6-4.8-7.1-6.4-11 C105.9,179.6,106.1,178.9,106.6,178.7z"
      })]
    })]
  }));
};
const sizeVariants$3 = {
  xs: "110px",
  sm: "160px",
  md: "230px",
  lg: "320px",
  xl: "640px"
};
const GivePower$1 = (_Aa) => {
  var _Ba = _Aa, {
    size = "md",
    invert = false,
    sx
  } = _Ba, rest = __objRest(_Ba, [
    "size",
    "invert",
    "sx"
  ]);
  return jsxs("svg", __spreadProps(__spreadValues({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 612.16 140.79",
    xmlSpace: "preserve"
  }, rest), {
    sx: __spreadValues({
      width: Array.isArray(size) ? size.map((x) => sizeVariants$3[x]) : sizeVariants$3[size],
      height: "auto"
    }, sx),
    children: [jsx("title", {
      children: "GivePower"
    }), jsxs(Box, {
      as: "g",
      sx: {
        fill: invert ? "text.negative" : "logo.icon"
      },
      children: [jsx("path", {
        d: "M86.1,122.7c-26.2,7.5-47.5,2.8-55.9.2a1.76,1.76,0,0,0-2,2.6,33.67,33.67,0,0,0,18,13.5l-.1.1a45.42,45.42,0,0,0,12,1.7,57.79,57.79,0,0,0,10.4-1.1,8.22,8.22,0,0,0,3-.9A32,32,0,0,0,88,125.3a1.73,1.73,0,0,0-1.9-2.6",
        transform: "translate(0.06 -0.01)"
      }), jsx("path", {
        d: "M65.8,109.7V55.5a6.8,6.8,0,1,0-13.6-.2V96.6a5.73,5.73,0,0,1-7.3,5.5h0c-.1,0-.2-.1-.3-.1l-1.7-.7C27.6,95,16.4,81.3,14.2,64.9A45.32,45.32,0,0,1,57.6,13.8h1.3A45.18,45.18,0,0,1,95.5,85.5a6.61,6.61,0,0,0-.5,6.8,6.91,6.91,0,0,0,6.4,4,6.77,6.77,0,0,0,5.4-2.7,58.64,58.64,0,0,0,11.1-37.7C116.2,21.8,85-3.9,51.2.5L49.4.8C27.7,4.1,9.3,19.3,2.8,40.3-3.9,62.2,1.4,84.2,16.3,99.7a57.19,57.19,0,0,0,12.6,10A58.05,58.05,0,0,0,49,117.1a63.92,63.92,0,0,0,9.9.9,6.87,6.87,0,0,0,6.8-6.8v-1.5",
        transform: "translate(0.06 -0.01)"
      }), jsx("path", {
        d: "M154.7,104.7c.3.1.8.4,1.7.7a31.7,31.7,0,0,0,3.3,1.1,26.2,26.2,0,0,0,4.7.9,36,36,0,0,0,5.8.4,29.62,29.62,0,0,0,6.6-.7,14.74,14.74,0,0,0,5.8-2.7,14.52,14.52,0,0,0,4.2-5.4,20.37,20.37,0,0,0,1.6-8.8V89a23.59,23.59,0,0,1-6.5,5,20.91,20.91,0,0,1-10.3,2.4,27.49,27.49,0,0,1-10.1-1.8,23.8,23.8,0,0,1-8-5.1,22.66,22.66,0,0,1-5.2-7.9,28,28,0,0,1-1.9-10.2,26.64,26.64,0,0,1,2-10.3,24.43,24.43,0,0,1,5.6-8.2,25.72,25.72,0,0,1,8.5-5.4,29.37,29.37,0,0,1,10.9-2,31.94,31.94,0,0,1,10.4,1.7,22,22,0,0,1,13.8,13.9,36,36,0,0,1,2,12.5V87.8a37.5,37.5,0,0,1-2.1,13.3,25.43,25.43,0,0,1-5.8,9.1,22.76,22.76,0,0,1-8.9,5.2,36.75,36.75,0,0,1-11.3,1.6,54.43,54.43,0,0,1-7.3-.4c-2.2-.3-4.1-.7-5.8-1.1a36,36,0,0,1-4.2-1.3c-1.1-.4-1.9-.8-2.5-1l3-8.5M173.4,87a15.09,15.09,0,0,0,6.1-1.2,15.64,15.64,0,0,0,4.7-3.2,16.37,16.37,0,0,0,3.1-4.9,16.06,16.06,0,0,0,1.1-6.3,18,18,0,0,0-1.1-6.2,16.88,16.88,0,0,0-3.1-5,14.27,14.27,0,0,0-4.7-3.3,16.36,16.36,0,0,0-12.3,0,12.73,12.73,0,0,0-4.8,3.4,14.83,14.83,0,0,0-3,5,17.39,17.39,0,0,0-1.1,6.1,16.09,16.09,0,0,0,4.1,11.4C165.2,85.6,168.8,87,173.4,87Z",
        transform: "translate(0.06 -0.01)"
      }), jsx("path", {
        d: "M214.1,24.8a6.79,6.79,0,0,1,4.8,11.6,6.79,6.79,0,1,1-9.6-9.6,6.2,6.2,0,0,1,4.8-2m-5.6,27.3a4.67,4.67,0,0,1,1.6-4,7,7,0,0,1,4.4-1.2,10.38,10.38,0,0,1,3.2.4c1,.3,1.6.5,2,.6V96.2H208.5Z",
        transform: "translate(0.06 -0.01)"
      }), jsx("path", {
        d: "M245.6,96.2c-3.1-5.7-5.9-11.1-8.5-16.1s-4.8-9.5-6.6-13.4-3.2-7.2-4.2-9.8a19.29,19.29,0,0,1-1.5-5.1,5,5,0,0,1,1.4-3.5,5.74,5.74,0,0,1,4.2-1.4,10.92,10.92,0,0,1,3.4.4,6.71,6.71,0,0,1,1.5.6q1.95,5.25,4.2,10.8c1.5,3.6,3,7.1,4.5,10.3s2.9,6.2,4.1,8.8,2.3,4.8,3.2,6.5c1.2-2.4,2.6-5.1,4-8.4s2.8-6.4,4.2-9.5,2.6-6,3.6-8.6,1.9-4.5,2.3-5.7a12.33,12.33,0,0,1,2.4-3.9,6,6,0,0,1,4.3-1.4,10,10,0,0,1,4.5.9,20.12,20.12,0,0,1,1.9,1.1c-.4,1.4-1.1,3.3-2,5.7s-2.1,5.1-3.4,8-2.8,6-4.3,9.2-3.1,6.3-4.6,9.4-2.9,5.9-4.3,8.5-2.5,4.8-3.4,6.5H245.6",
        transform: "translate(0.06 -0.01)"
      }), jsx("path", {
        d: "M325,92.6c-.5.3-1.3.8-2.5,1.4a30.18,30.18,0,0,1-4.2,1.7,55.17,55.17,0,0,1-5.8,1.4,40.32,40.32,0,0,1-7.2.6A31.34,31.34,0,0,1,295,96a23.56,23.56,0,0,1-14.1-13.1,27,27,0,0,1-2.1-11,29.23,29.23,0,0,1,2-10.8,25.25,25.25,0,0,1,5.6-8.4,25.72,25.72,0,0,1,8.5-5.4,28.31,28.31,0,0,1,10.7-1.9,27.53,27.53,0,0,1,9,1.3,22.89,22.89,0,0,1,6.6,3.5,14.57,14.57,0,0,1,4.1,5.2,15.23,15.23,0,0,1,1.4,6.3,13.77,13.77,0,0,1-1.3,6.2,11.44,11.44,0,0,1-4.5,4.8,27.44,27.44,0,0,1-8.7,3.1,68.34,68.34,0,0,1-14,1.1h-3.7c-1.1,0-2.4-.1-3.7-.1a12,12,0,0,0,4.9,8.1c2.7,2.1,6.6,3.1,11.6,3.1a22.88,22.88,0,0,0,4.7-.4,36.86,36.86,0,0,0,3.9-1q1.65-.6,3-1.2l1.8-.9,4.3,8.1M290.5,69.3c1.5.1,2.9.1,4.3.1h4.1a41.14,41.14,0,0,0,8.7-.7,16.43,16.43,0,0,0,5.2-1.8,5.47,5.47,0,0,0,2.5-2.5,7.17,7.17,0,0,0,.6-2.9,6.1,6.1,0,0,0-3-5.6,15.82,15.82,0,0,0-13.8-.6,14.51,14.51,0,0,0-4.6,3.4,15.9,15.9,0,0,0-2.9,4.9A16.47,16.47,0,0,0,290.5,69.3Z",
        transform: "translate(0.06 -0.01)"
      }), jsx("path", {
        d: "M332,73.8a34.47,34.47,0,0,1,2-12.1,23.15,23.15,0,0,1,5.5-8.8,24,24,0,0,1,8.6-5.5,32.28,32.28,0,0,1,11.1-1.9,26.64,26.64,0,0,1,10.3,2,24.69,24.69,0,0,1,13.7,13.7,29,29,0,0,1,.1,20.9,24.16,24.16,0,0,1-5.3,8.2,24.57,24.57,0,0,1-8,5.4,25.11,25.11,0,0,1-10,1.9,21.22,21.22,0,0,1-9.9-2.2,19.41,19.41,0,0,1-6.8-5.3V116H332V73.8m26.4,13.8a15.09,15.09,0,0,0,6.1-1.2,12.73,12.73,0,0,0,4.8-3.4,14.55,14.55,0,0,0,3.1-5.1,19.11,19.11,0,0,0,1.1-6.4,18,18,0,0,0-1.1-6.2,15.06,15.06,0,0,0-3.1-5,14.69,14.69,0,0,0-4.8-3.3,15.44,15.44,0,0,0-6.1-1.2,15.09,15.09,0,0,0-6.1,1.2,14.94,14.94,0,0,0-4.8,3.2,14.11,14.11,0,0,0-3.1,5,16.56,16.56,0,0,0-1.1,6.4,19.11,19.11,0,0,0,1.1,6.4,16.19,16.19,0,0,0,3.1,5.1,13.94,13.94,0,0,0,4.8,3.4A16.2,16.2,0,0,0,358.4,87.6Z",
        transform: "translate(0.06 -0.01)"
      }), jsx("path", {
        d: "M417.4,45.5a29.08,29.08,0,0,1,10.7,2,24.87,24.87,0,0,1,8.6,5.5,25.86,25.86,0,0,1,7.8,18.7A25.3,25.3,0,0,1,442.4,82a26.7,26.7,0,0,1-5.7,8.3,26.41,26.41,0,0,1-8.6,5.5,29.62,29.62,0,0,1-21.4,0,26.41,26.41,0,0,1-8.6-5.5,25.58,25.58,0,0,1-5.7-8.3,25.3,25.3,0,0,1-2.1-10.3,25.77,25.77,0,0,1,2.1-10.4,26.7,26.7,0,0,1,5.7-8.3,28.17,28.17,0,0,1,8.6-5.5,29.08,29.08,0,0,1,10.7-2m0,42.2a15.93,15.93,0,0,0,6.2-1.2,15.38,15.38,0,0,0,4.9-3.4,16.61,16.61,0,0,0,3.1-5.1,16.06,16.06,0,0,0,1.1-6.3,19.11,19.11,0,0,0-1.1-6.4,17.94,17.94,0,0,0-3.1-5.2,14.35,14.35,0,0,0-4.9-3.4,15.93,15.93,0,0,0-6.2-1.2,15.24,15.24,0,0,0-6.2,1.2,13.94,13.94,0,0,0-4.8,3.4,15,15,0,0,0-3.1,5.2,16.9,16.9,0,0,0-1.1,6.4,18.1,18.1,0,0,0,1.1,6.3,18.81,18.81,0,0,0,3.1,5.1,12.73,12.73,0,0,0,4.8,3.4A15.24,15.24,0,0,0,417.4,87.7Z",
        transform: "translate(0.06 -0.01)"
      }), jsx("path", {
        d: "M460.7,96.2c-3.2-7.5-5.8-13.9-7.9-19.2s-3.7-9.6-4.9-13-2.1-6.1-2.6-8a17.36,17.36,0,0,1-.7-4,5.24,5.24,0,0,1,1.4-3.6,5.42,5.42,0,0,1,4.2-1.6,10.53,10.53,0,0,1,3.4.4c.8.3,1.4.5,1.6.6.8,2.9,1.7,5.9,2.7,9.2s2,6.5,3,9.7S463,73,464,75.9s1.9,5.5,2.7,7.8c.7-2,1.5-4.4,2.3-7s1.7-5.3,2.6-8.1,1.8-5.6,2.6-8.5,1.6-5.6,2.4-8.1a9.09,9.09,0,0,1,2.2-3.9c.9-.9,2.5-1.3,4.6-1.3a12.3,12.3,0,0,1,3.5.5c1,.4,1.7.6,2,.7.9,2.9,1.8,6,2.8,9.3s2,6.4,2.9,9.6,1.9,6.2,2.9,9,1.8,5.4,2.6,7.7c1.7-4.5,3.5-9.5,5.3-14.8s3.5-10.7,5-16.1a11.78,11.78,0,0,1,2.3-4.5,6.1,6.1,0,0,1,4.4-1.4,8.86,8.86,0,0,1,4.3.9c1.1.6,1.7,1,1.9,1.1a75.17,75.17,0,0,1-2.8,8.9c-1.3,3.8-2.8,7.9-4.4,12.3s-3.4,8.9-5.2,13.6-3.6,8.8-5.2,12.5H494.1q-.75-2.1-2.1-6c-.9-2.7-1.9-5.6-2.9-8.7S487,75,486,71.7s-1.9-6.3-2.8-9.1c-.9,2.8-1.8,5.8-2.8,9.1s-2,6.5-3,9.7-2,6-2.8,8.7-1.5,4.7-2.1,6H460.7",
        transform: "translate(0.06 -0.01)"
      }), jsx("path", {
        d: "M569.6,92.6c-.5.3-1.3.8-2.5,1.4a30.18,30.18,0,0,1-4.2,1.7,55.17,55.17,0,0,1-5.8,1.4,40.32,40.32,0,0,1-7.2.6A31.34,31.34,0,0,1,539.6,96a23.56,23.56,0,0,1-14.1-13.1,27,27,0,0,1-2.1-11,29.23,29.23,0,0,1,2-10.8,25.25,25.25,0,0,1,5.6-8.4,25.72,25.72,0,0,1,8.5-5.4,28.31,28.31,0,0,1,10.7-1.9,27.53,27.53,0,0,1,9,1.3,22.89,22.89,0,0,1,6.6,3.5,14.57,14.57,0,0,1,4.1,5.2,15.23,15.23,0,0,1,1.4,6.3,13.77,13.77,0,0,1-1.3,6.2,11.44,11.44,0,0,1-4.5,4.8,27.44,27.44,0,0,1-8.7,3.1,68.34,68.34,0,0,1-14,1.1h-3.7c-1.1,0-2.4-.1-3.7-.1a12,12,0,0,0,4.9,8.1C543,87,546.9,88,552,88a22.88,22.88,0,0,0,4.7-.4,36.86,36.86,0,0,0,3.9-1,28.52,28.52,0,0,0,2.9-1.2l1.8-.9,4.3,8.1M535.1,69.3c1.5.1,2.9.1,4.3.1h4.1a41.14,41.14,0,0,0,8.7-.7,16.43,16.43,0,0,0,5.2-1.8,5.47,5.47,0,0,0,2.5-2.5,7.17,7.17,0,0,0,.6-2.9,6.1,6.1,0,0,0-3-5.6,15.82,15.82,0,0,0-13.8-.6,14.51,14.51,0,0,0-4.6,3.4,15.9,15.9,0,0,0-2.9,4.9A16.47,16.47,0,0,0,535.1,69.3Z",
        transform: "translate(0.06 -0.01)"
      }), jsx("path", {
        d: "M577.1,64.5c0-6,1.9-10.7,5.6-14s8.8-5,15.4-5a26.24,26.24,0,0,1,10.1,1.7c2.6,1.1,3.9,2.9,3.9,5.3a6.2,6.2,0,0,1-.9,3.2,7.73,7.73,0,0,1-1.5,2,36.77,36.77,0,0,0-4.1-1.5,19.06,19.06,0,0,0-5.6-.7c-7.7,0-11.5,4.1-11.5,12.2V96.2H577.3V64.5",
        transform: "translate(0.06 -0.01)"
      })]
    })]
  }));
};
const sizeVariants$2 = {
  xs: "32px",
  sm: "50px",
  md: "72px",
  lg: "96px",
  xl: "128px"
};
const GivePowerIcon$1 = (_Ca) => {
  var _Da = _Ca, {
    size = "md",
    sx
  } = _Da, rest = __objRest(_Da, [
    "size",
    "sx"
  ]);
  return jsxs("svg", __spreadProps(__spreadValues({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 588 682",
    xmlSpace: "preserve"
  }, rest), {
    sx: __spreadValues({
      width: Array.isArray(size) ? size.map((x) => sizeVariants$2[x]) : sizeVariants$2[size],
      height: "auto"
    }, sx),
    children: [jsx("title", {
      children: "GivePower"
    }), jsxs(Box, {
      as: "g",
      sx: {
        fill: "logo.icon"
      },
      children: [jsx("path", {
        d: "M371.9,494.8c-83.2,23.7-150.8,8.7-177.4,0.6c-4.8-1.5-8.9,3.9-6.3,8.1c11.8,19.1,34.6,36.2,57.2,42.8 c0,0-0.2,0.2-0.2,0.2c0.7,0,17,5.3,38.2,5.3c0,0,11.6,0.4,33.1-3.4c4.4-0.8,7.3-1.7,9.4-2.7c21.3-7.2,41.6-24.1,52.3-42.8 C380.8,498.5,376.8,493.4,371.9,494.8z"
      }), jsx("path", {
        d: "M307.5,453.5v-49.9l0-122.4c0-10.4-7-20-17.3-22c-13.8-2.7-25.9,7.9-25.9,21.2v123.2l0,7.9 c0,12-11.5,20.7-23.1,17.4l-0.2,0c-0.3-0.1-0.5-0.2-0.8-0.3l-5.4-2.2c-48.6-19.7-84.3-63.3-91.1-115.3 c-11.3-85.8,55.1-159.9,138-162.3c1.4,0,2.8-0.1,4.3-0.1c79.1,0,143.5,64.4,143.5,143.5c0,30.4-9.4,59.5-27.2,84.1 c-4.4,6.1-5,14.4-1.6,21.6c4.4,9.4,13.3,12.7,20.2,12.7c4,0,11.6-1.1,17-8.6c25.2-34.7,37.5-76.4,35.3-119.7 C467.6,174.2,368.5,92.7,261,106.5c-1.9,0.2-3.8,0.5-5.7,0.8c-68.9,10.8-127.4,58.9-147.8,125.6c-21.2,69.5-4.4,139.4,42.8,188.8 c12,12.6,25.6,23.1,40.1,31.8c19.7,11.7,41.2,19.6,64,23.4c10.3,1.7,20.8,2.8,31.5,2.8h0c11.9,0,21.6-9.7,21.6-21.6V453.5z"
      })]
    })]
  }));
};
const sizeVariants$1 = {
  xs: "110px",
  sm: "160px",
  md: "230px",
  lg: "320px",
  xl: "640px"
};
const GivePower = (_Ea) => {
  var _Fa = _Ea, {
    size = "md",
    invert = false,
    sx
  } = _Fa, rest = __objRest(_Fa, [
    "size",
    "invert",
    "sx"
  ]);
  const id = React.useMemo(() => `gradient-${v4()}`, []);
  return jsxs("svg", __spreadProps(__spreadValues({
    height: "87.01",
    width: "357.22",
    viewBox: "0 0 137 37",
    xmlns: "http://www.w3.org/2000/svg"
  }, rest), {
    sx: __spreadValues({
      width: Array.isArray(size) ? size.map((x) => sizeVariants$1[x]) : sizeVariants$1[size],
      height: "auto"
    }, sx),
    children: [jsx("title", {
      children: "GoodLeap"
    }), jsx("defs", {}), jsxs(Box, {
      as: "g",
      sx: {
        fill: invert ? "text.negative" : "neutral.base"
      },
      children: [jsx("defs", {
        children: jsxs("linearGradient", {
          x1: "0.0441700867%",
          y1: "50.0493315%",
          x2: "99.9990742%",
          y2: "50.0493315%",
          id,
          children: [jsx("stop", {
            stopColor: "#FF8300",
            offset: "41%"
          }), jsx("stop", {
            stopColor: "#FA9F1F",
            offset: "60%"
          }), jsx("stop", {
            stopColor: "#F7B334",
            offset: "76%"
          })]
        })
      }), jsx("path", {
        d: "M51.5063546,11.5800644 C51.379794,11.4131721 51.2493981,11.2500729 51.1228375,11.0945597 L51.0192878,10.9731835 C50.77942,10.7051491 50.5232676,10.451813 50.2522535,10.2145824 L50.2522535,10.2145824 C50.1314859,10.0997412 49.9710602,10.0346492 49.8035384,10.0325181 C49.610261,10.0258953 49.4252649,10.1103393 49.3049661,10.2600985 L49.3049661,10.2600985 L47.893623,12.2286683 L47.893623,12.2286683 C47.8162291,12.3401483 47.7760019,12.4727646 47.7785678,12.6079688 C47.777926,12.7865182 47.8530565,12.9571433 47.9856671,13.0783015 L47.9856671,13.0783015 C48.3125315,13.3794828 48.5987007,13.7211502 48.8370752,14.0948269 C49.2274783,14.7413081 49.4733311,15.4629973 49.5580875,16.211324 C49.5580875,16.3364932 49.5810985,16.4616623 49.5810985,16.5906245 C49.5810985,16.5906245 49.5810985,16.6664846 49.5810985,16.6778636 C49.5810989,17.9752133 49.0597371,19.2193715 48.1318146,20.1363805 C47.2038921,21.0533895 45.9454988,21.5680541 44.6337271,21.5670476 C43.0372866,21.5643014 41.5387205,20.8056293 40.6029618,19.5264107 L35.0266222,11.7583356 C33.4010515,9.51519764 30.7871635,8.17819731 27.9967527,8.16256647 C23.2454783,8.17511772 19.4017205,11.9901917 19.4059648,16.6892427 C19.4059648,16.9775111 19.4059648,17.2619865 19.4481552,17.5426689 C19.449924,17.5603263 19.449924,17.5781135 19.4481552,17.5957709 C19.4788366,17.8802464 19.5248586,18.1571358 19.5823862,18.4340251 C19.5823862,18.4340251 19.5823862,18.4340251 19.5823862,18.4605762 C19.9531634,20.2378847 20.8948386,21.8490716 22.2670063,23.0539057 C22.4001902,23.1910228 22.5781928,23.2770298 22.7694138,23.2966581 C23.0202535,23.2795057 23.2446689,23.1363135 23.3638654,22.9173576 L23.3638654,22.9173576 L24.6256369,21.149817 C24.7121962,21.0416274 24.7606744,20.9084465 24.763703,20.7705165 C24.7634181,20.6070387 24.7003598,20.4497704 24.5872851,20.3305279 L24.5872851,20.3305279 C23.585918,19.3807442 23.0300116,18.0612377 23.0532165,16.6892427 C23.0266128,15.4125698 23.5264434,14.1801552 24.4377135,13.2755378 C25.4647977,12.2296925 26.9091221,11.6900068 28.378857,11.8028917 C29.8485919,11.9157765 31.1913512,12.6695277 32.0428587,13.8596606 L37.6076927,21.6201497 C39.4077584,24.1112631 42.4219979,25.4541982 45.5012407,25.1369645 C48.5804835,24.8197308 51.2501529,22.8912208 52.4924446,20.0866737 C53.7347363,17.2821266 53.3581868,14.0337828 51.5063546,11.5800644 Z"
      }), jsx("path", {
        d: "M46.6282072,8.85289346 C46.6322678,8.68163054 46.5653475,8.5161307 46.4428632,8.39499303 C46.3203788,8.27385537 46.1530392,8.20767086 45.9798723,8.21187555 L45.9798723,8.21187555 C45.3358388,8.13619155 44.6858297,8.12348675 44.0392755,8.17394549 L43.6557584,8.21566855 C41.2276557,8.49640837 39.034532,9.78430187 37.6230334,11.7583356 L32.0581994,19.5188247 C31.2074081,20.8018709 29.7739663,21.5901019 28.2230278,21.6277357 L28.1731706,21.6277357 C27.9869423,21.6405427 27.8151978,21.731685 27.7014445,21.8780741 L27.7014445,21.8780741 C27.7014445,21.8780741 27.6784335,21.9084181 27.6707631,21.9197971 L26.1366945,24.0438802 C26.0114677,24.2097905 25.9755472,24.4255287 26.0403721,24.6223908 C26.105197,24.8192529 26.2626856,24.972696 26.4626841,25.0338546 L26.4972006,25.0338546 C27.3354093,25.1195288 28.1787169,25.1461469 29.0207435,25.1135077 C31.4488777,24.8321315 33.6439449,23.5496829 35.064974,21.5822196 L40.5914562,13.8520746 C41.4648691,12.6645409 42.8230222,11.9179988 44.3039024,11.8114377 L44.3307486,11.8114377 C44.561274,11.8107792 44.7736568,11.6876478 44.8868484,11.4890322 L46.5052909,9.21322898 C46.5832236,9.10872934 46.6261374,8.98272956 46.6282072,8.85289346 L46.6282072,8.85289346 Z",
        fill: `url(#${id})`
      }), jsx("path", {
        d: "M16.6484799,8.66324319 L14.5736521,8.66324319 C14.1500307,8.66324319 13.8066178,9.00288046 13.8066178,9.42184427 L13.8066178,9.97183006 C13.8078723,10.0828262 13.7419811,10.1838349 13.6392119,10.2284571 C13.5364427,10.2730792 13.4166618,10.2526888 13.3348917,10.1766524 C11.9729588,8.97627814 10.2078816,8.32046841 8.38368512,8.33704472 C3.61273165,8.3218727 0,12.012467 0,16.909237 C0,21.806007 3.53602822,25.4131551 8.40669615,25.4131551 C10.6809529,25.4131551 12.7366049,24.4876618 13.8603102,23.0045967 C13.7644309,27.457585 11.9657354,29.6233911 8.37217961,29.6233911 C6.67552996,29.6130421 5.09478586,28.7702465 4.15349085,27.3741389 C3.94371302,27.0628808 3.53120074,26.9568068 3.19469795,27.1275936 C2.70379598,27.3741389 1.96360786,27.7686115 1.46503555,28.0379149 C1.27767803,28.1345446 1.13892464,28.3033349 1.08151839,28.5044545 C1.03055114,28.6883808 1.05537499,28.8847882 1.15055148,29.0506473 C2.68097525,31.5386748 5.42784209,33.0405598 8.37217961,32.999166 C14.3627177,32.999166 17.4001736,29.4299479 17.4001736,22.3977158 L17.4001736,9.40667225 C17.3920182,8.99947541 17.0602035,8.67130885 16.6484799,8.66324319 Z M8.68282851,21.8970391 C5.7527574,21.8970391 3.6740944,19.8336441 3.6740944,16.8750999 C3.63109285,15.5397324 4.14165794,14.2449716 5.08742584,13.2909805 C6.03319375,12.3369895 7.33203069,11.8066163 8.68282851,11.8228167 C11.1450087,11.8228167 13.8066178,13.4045 13.8066178,16.8750999 C13.8066178,20.1370846 11.1603494,21.8970391 8.68282851,21.8970391 Z"
      }), jsx("path", {
        d: "M71.4224008,9.31919866e-06 L69.3437378,9.31919866e-06 C68.9201164,9.31919866e-06 68.5767034,0.339656089 68.5767034,0.758619899 L68.5767034,9.81631684 C68.5754032,9.93246152 68.5046384,10.036805 68.3964772,10.0820624 C68.288316,10.1273198 68.1633192,10.1048879 68.0781311,10.0249321 C66.8892279,8.94392559 65.0828621,8.3218727 63.1192542,8.3218727 C58.286938,8.3218727 54.7815912,11.9062628 54.7815912,16.8409629 C54.7815912,21.7756629 58.3828173,25.4131551 63.157606,25.4131551 C64.9654135,25.4305747 66.7176004,24.7953946 68.0858015,23.6266496 C68.1700391,23.5455812 68.2952674,23.5224848 68.4033877,23.5680757 C68.5115079,23.6136667 68.5813608,23.7190228 68.5805386,23.8352649 L68.5805386,24.3169766 C68.5805386,24.7359404 68.9239516,25.0755776 69.3475729,25.0755776 L71.4262359,25.0755776 C71.8498573,25.0755776 72.1932703,24.7359404 72.1932703,24.3169766 L72.1932703,0.758619899 C72.1932703,0.556767474 72.1119342,0.363237269 71.9672569,0.220862432 C71.8225795,0.0784875949 71.6264946,-0.000990446947 71.4224008,9.31919866e-06 Z M68.5460221,16.8068258 C68.5460221,20.3039768 65.8959185,21.8970391 63.4337383,21.8970391 C60.5995465,21.8970391 58.4480152,19.708475 58.4480152,16.8068258 C58.4480152,13.9051767 60.5420189,11.8228167 63.4337383,11.8228167 C65.9649516,11.8228167 68.5460221,13.5334621 68.5460221,16.8068258 Z"
      }), jsx("rect", {
        x: "75.7216281",
        y: "1.88151913e-05",
        width: "3.60889648",
        height: "25.0565938",
        rx: "0.759363977"
      }), jsx("path", {
        d: "M89.8082134,8.3218727 C84.8953586,8.3218727 81.3324842,11.8910908 81.3324842,16.8068258 C81.3324842,21.7832489 84.8953586,25.3941901 89.8082134,25.3941901 C93.0297576,25.3941901 95.7028722,24.0059501 97.1410615,21.5784266 C97.2511495,21.3875295 97.2721226,21.1587978 97.1985527,20.9514289 C97.1249828,20.7440599 96.9641009,20.5784354 96.7575444,20.4974201 C96.504423,20.402595 96.2474665,20.3115628 95.99051,20.2243237 C95.6606853,20.1067405 95.3308605,19.9929504 95.0202116,19.8677812 C94.7006059,19.7294099 94.326694,19.830552 94.1227815,20.1105335 C93.1454058,21.4384435 91.5636461,22.1978735 89.9040927,22.1359984 C87.4687587,22.1359984 85.6048653,20.7856885 85.0487655,18.6122964 C85.0265177,18.5305296 85.0450383,18.4431714 85.0986227,18.3771301 C85.1536355,18.308862 85.2366414,18.2685111 85.3248978,18.2671329 L97.2752925,18.2671329 C97.6857924,18.2675442 98.0238546,17.9482444 98.0423269,17.5426689 C98.0423269,17.2885375 98.0423269,17.0306131 98.0423269,16.8068258 C98.0423269,11.8114377 94.6558703,8.3218727 89.8082134,8.3218727 Z M85.0564358,15.0354923 C85.6048653,12.9076163 87.4265719,11.5838574 89.8082134,11.5838574 C92.1093164,11.5838574 93.8198029,12.8734792 94.3567269,15.0392853 C94.3754459,15.1228622 94.354578,15.210319 94.3000537,15.2768017 C94.2455293,15.3432844 94.1633094,15.3815249 94.0767594,15.3806558 L85.3364033,15.3806558 C85.2464024,15.3821557 85.1610183,15.3413404 85.106293,15.2706586 C85.052122,15.2048927 85.0335389,15.1172399 85.0564358,15.0354923 L85.0564358,15.0354923 Z"
      }), jsx("path", {
        d: "M116.43581,8.66324319 L114.360982,8.66324319 C113.952207,8.67322996 113.623221,8.99859843 113.613124,9.40287925 L113.613124,9.8618329 C113.61584,9.97211203 113.548348,10.0722359 113.444376,10.1121713 C113.345258,10.1588443 113.227199,10.1391314 113.149068,10.0628622 C111.772885,8.89059612 110.005961,8.26484872 108.190191,8.30670068 C103.319523,8.30670068 99.7834948,11.8910908 99.7834948,16.8257908 C99.7834948,21.7604909 103.400062,25.4131551 108.190191,25.4131551 C110.011215,25.4261805 111.772988,24.7737926 113.137562,23.5811335 C113.217572,23.5058716 113.335225,23.4849866 113.436706,23.5280314 C113.540548,23.5702365 113.607555,23.6711473 113.605453,23.7821628 L113.605453,24.3169766 C113.605323,24.7286444 113.937197,25.065286 114.353312,25.0755776 L116.42814,25.0755776 C116.844254,25.065286 117.175998,24.7286444 117.175998,24.3169766 L117.175998,9.40287925 C117.166092,9.00144098 116.841587,8.67717818 116.43581,8.66324319 Z M113.578607,16.8068258 C113.578607,20.3039768 110.928503,21.8970391 108.466323,21.8970391 C105.612956,21.8970391 103.457589,19.708475 103.457589,16.8068258 C103.408104,15.4758946 103.918856,14.1842547 104.86816,13.2396371 C105.817464,12.2950194 107.120319,11.7820043 108.466323,11.8228167 C111.005207,11.8228167 113.578607,13.5334621 113.578607,16.8068258 L113.578607,16.8068258 Z"
      }), jsx("path", {
        d: "M128.696853,8.3218727 C126.88349,8.29375872 125.127173,8.9486958 123.783999,10.1538943 C123.702042,10.2314197 123.580891,10.2523879 123.477185,10.2069964 C123.373342,10.1647913 123.306336,10.0638805 123.308437,9.95286503 L123.308437,9.40667225 C123.308437,8.98770844 122.965024,8.64807117 122.541403,8.64807117 L120.435894,8.64807117 C120.01978,8.65836285 119.688035,8.99500437 119.688035,9.40667225 L119.688035,32.0547076 C119.688035,32.4663755 120.01978,32.803017 120.435894,32.8133087 L122.541403,32.8133087 C122.965024,32.8133087 123.308437,32.4736714 123.308437,32.0547076 L123.308437,23.8542299 C123.309411,23.7441157 123.375401,23.6447369 123.477185,23.6000985 C123.579716,23.5553525 123.699424,23.5763333 123.780163,23.6532006 C125.140009,24.8253678 126.893454,25.4530227 128.696853,25.4131551 C133.506159,25.4131551 137,21.84773 137,16.928202 C137,12.008674 133.506159,8.3218727 128.696853,8.3218727 Z M133.360422,16.943374 C133.360422,19.8601952 131.312441,21.8970391 128.374699,21.8970391 C125.866497,21.8970391 123.331448,20.1939797 123.331448,16.943374 C123.331448,13.423465 125.947035,11.8228167 128.374699,11.8228167 C131.266418,11.8228167 133.360422,13.9772438 133.360422,16.943374 Z"
      })]
    })]
  }));
};
const sizeVariants = {
  xs: "60px",
  sm: "72px",
  md: "96px",
  lg: "128px",
  xl: "230px"
};
const GivePowerIcon = (_Ga) => {
  var _Ha = _Ga, {
    size = "md",
    sx,
    invert
  } = _Ha, rest = __objRest(_Ha, [
    "size",
    "sx",
    "invert"
  ]);
  const id = React.useMemo(() => `gradient-${v4()}`, []);
  return jsxs("svg", __spreadProps(__spreadValues({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 188.22 87.01",
    xmlSpace: "preserve"
  }, rest), {
    sx: __spreadValues({
      width: Array.isArray(size) ? size.map((x) => sizeVariants[x]) : sizeVariants[size],
      height: "auto"
    }, sx),
    children: [jsx("title", {
      children: "GivePower"
    }), jsxs(Box, {
      as: "g",
      sx: {
        fill: invert ? "text.negative" : "neutral.base"
      },
      children: [jsx("defs", {
        children: jsxs("linearGradient", {
          id,
          gradientUnits: "userSpaceOnUse",
          x1: "67.84",
          x2: "121.58",
          y1: "43.88",
          y2: "43.88",
          children: [jsx("stop", {
            offset: ".22",
            stopColor: "#ff7b00"
          }), jsx("stop", {
            offset: ".51",
            stopColor: "#ff9a11"
          }), jsx("stop", {
            offset: ".76",
            stopColor: "#ffaf1c"
          })]
        })
      }), jsx("path", {
        d: "M134.3 30.53c-.33-.44-.67-.87-1-1.28l-.27-.32a23.24 23.24 0 0 0-2-2 1.72 1.72 0 0 0-1.17-.48 1.59 1.59 0 0 0-1.3.6l-3.68 5.19a1.71 1.71 0 0 0-.3 1 1.68 1.68 0 0 0 .54 1.24 13.53 13.53 0 0 1 2.22 2.68 13.9 13.9 0 0 1 1.88 5.58c0 .33.06.66.06 1v.23a12.89 12.89 0 0 1-12.9 12.89 13 13 0 0 1-10.51-5.38L91.33 31A22.71 22.71 0 0 0 73 21.52 22.46 22.46 0 0 0 50.6 44c0 .76 0 1.51.11 2.25a.71.71 0 0 1 0 .14c.08.75.2 1.48.35 2.21v.07a22.19 22.19 0 0 0 7 12.11 2.12 2.12 0 0 0 1.31.64 1.91 1.91 0 0 0 1.55-1l3.29-4.66a1.67 1.67 0 0 0 .36-1 1.7 1.7 0 0 0-.46-1.16 13 13 0 0 1-4-9.6 12.39 12.39 0 0 1 3.61-9 12.93 12.93 0 0 1 19.83 1.54L98.06 57a22.44 22.44 0 1 0 36.24-26.47z"
      }), jsx("path", {
        className: "icon-gradient",
        d: "M121.58 23.34a1.65 1.65 0 0 0-1.69-1.69 25.73 25.73 0 0 0-5.06-.1l-1 .11A22.46 22.46 0 0 0 98.1 31L83.59 51.46a12.32 12.32 0 0 1-10 5.56h-.13a1.7 1.7 0 0 0-1.23.66s-.06.08-.08.11l-4 5.6A1.68 1.68 0 0 0 69 66h.09a46.35 46.35 0 0 0 6.58.21 22.6 22.6 0 0 0 15.76-9.31l14.41-20.38a13.15 13.15 0 0 1 9.68-5.38h.07a1.67 1.67 0 0 0 1.45-.85l4.22-6a1.64 1.64 0 0 0 .32-.95z",
        fill: `url(#${id})`
      }), jsx("path", {
        d: "M43.41 22.84H38a2 2 0 0 0-2 2v1.45a.73.73 0 0 1-1.23.54 19.14 19.14 0 0 0-12.91-4.85C9.42 21.94 0 31.67 0 44.58S9.22 67 21.92 67c5.93 0 11.29-2.44 14.22-6.35-.25 11.74-4.94 17.45-14.31 17.45a13.32 13.32 0 0 1-11-5.93 1.94 1.94 0 0 0-2.5-.65c-1.28.65-3.21 1.69-4.51 2.4a2 2 0 0 0-1 1.23A1.9 1.9 0 0 0 3 76.59 21.68 21.68 0 0 0 21.83 87c15.62 0 23.54-9.41 23.54-27.95V24.8a2 2 0 0 0-1.96-1.96zM22.64 57.73c-7.64 0-13.06-5.44-13.06-13.24a12.91 12.91 0 0 1 13.06-13.32c6.42 0 13.36 4.17 13.36 13.32 0 8.6-6.9 13.24-13.36 13.24z"
      }), jsx("path", {
        d: "M186.23 0h-5.42a2 2 0 0 0-2 2v23.88a.77.77 0 0 1-1.3.55c-3.1-2.85-7.81-4.49-12.93-4.49-12.6 0-21.74 9.45-21.74 22.46S152.23 67 164.68 67a19.37 19.37 0 0 0 12.85-4.71.76.76 0 0 1 1.29.55v1.27a2 2 0 0 0 2 2h5.42a2 2 0 0 0 2-2V2a2 2 0 0 0-2.01-2zm-7.5 44.31c0 9.22-6.91 13.42-13.33 13.42-7.39 0-13-5.77-13-13.42s5.46-13.14 13-13.14c6.6 0 13.33 4.51 13.33 13.14z"
      })]
    })]
  }));
};
const Logo = (_Ia) => {
  var _Ja = _Ia, {
    size = "md",
    variant = "base"
  } = _Ja, rest = __objRest(_Ja, [
    "size",
    "variant"
  ]);
  const {
    theme
  } = useThemeUI();
  switch (theme.company) {
    case "Loanpal":
      return variant === "base" ? jsx(Loanpal, __spreadValues({
        size
      }, rest)) : jsx(LoanpalIcon, __spreadValues({
        size
      }, rest));
    case "GivePower":
      return variant === "base" ? jsx(GivePower$1, __spreadValues({
        size
      }, rest)) : jsx(GivePowerIcon$1, __spreadValues({
        size
      }, rest));
    case "GoodLeap":
      return variant === "base" ? jsx(GivePower, __spreadValues({
        size
      }, rest)) : jsx(GivePowerIcon, __spreadValues({
        size
      }, rest));
    default:
      return null;
  }
};
const Modal = (_Ka) => {
  var _La = _Ka, {
    title,
    children,
    isOpen,
    variant = "small",
    onDismiss
  } = _La, rest = __objRest(_La, [
    "title",
    "children",
    "isOpen",
    "variant",
    "onDismiss"
  ]);
  const modalPrefix = React.useMemo(() => v4(), []);
  const titleId = `${modalPrefix}-title`;
  React.useEffect(() => {
    if (typeof window !== "undefined") {
      Modal$1.setAppElement("#root");
    }
  }, []);
  React.useEffect(() => {
    if (!document)
      return () => {
      };
    if (isOpen) {
      document.body.classList.add("no-scroll");
    } else {
      document.body.classList.remove("no-scroll");
    }
    return () => {
      document.body.classList.remove("no-scroll");
    };
  }, [isOpen]);
  return jsx(Modal$1, {
    shouldCloseOnOverlayClick: true,
    onRequestClose: onDismiss,
    portalClassName: "lumos-modal",
    isOpen,
    aria: {
      labelledby: titleId
    },
    children: jsxs(Box, __spreadProps(__spreadValues({
      variant: `modal.${variant}`
    }, rest), {
      children: [jsxs(Box, {
        sx: {
          bg: "primary.d3",
          height: 56,
          display: "grid",
          alignItems: "center",
          px: 3,
          gridTemplateColumns: "1fr 45px",
          color: "text.negative"
        },
        children: [jsx(Heading, {
          id: titleId,
          variant: "h3",
          children: title
        }), jsx(Button, {
          onClick: onDismiss,
          variant: "ghost",
          sx: {
            p: 0,
            color: "text.negative",
            "&:hover": {
              bg: "primary.d1"
            }
          },
          "aria-label": "Dismiss",
          children: jsx(Icon, {
            "aria-hidden": "true",
            role: "presentation",
            variant: "times",
            size: "lg"
          })
        })]
      }), jsx(Box, {
        className: "modal-container",
        sx: {
          p: 3,
          mb: "100px",
          height: "100%",
          bg: "background.depth.0",
          position: "relative",
          overflowY: "auto"
        },
        children
      })]
    }))
  });
};
const ModalControls = ({
  actions
}) => {
  if (actions.length > 2) {
    console.warn("Modal component given actions array length greater than 3");
  }
  return jsxs(Box, {
    sx: {
      px: [2, 3],
      py: 3,
      position: ["inherit", "fixed"],
      bottom: 0,
      bg: "white",
      alignItems: "center",
      display: "flex",
      flexDirection: "row-reverse",
      flexWrap: "wrap",
      gridTemplateColumns: "160px 160px",
      gap: 2,
      ml: -3,
      mt: "auto",
      width: ["calc(100% + 32px)", "100%"],
      borderTop: "1px solid",
      borderColor: "neutral.l3",
      "& > button": {
        minWidth: ["100%", 180]
      }
    },
    children: [jsx(Global, {
      styles: {
        ".modal-container": {
          height: "calc(100% - 69px)",
          "@media (max-width: 40em)": {
            height: "100%"
          }
        }
      }
    }), actions.map((_a, index) => {
      var _b = _a, {
        label,
        variant
      } = _b, props = __objRest(_b, [
        "label",
        "variant"
      ]);
      const key = ["primary", "secondary", "tertiary"];
      let buttonVariant = variant;
      if (!buttonVariant) {
        buttonVariant = index === 0 ? "primary" : "secondary";
      }
      return jsxs(React.Fragment, {
        children: [index === 2 && jsx(Box, {
          sx: {
            display: ["none", "block"]
          }
        }, "empty"), jsx(Button, __spreadProps(__spreadValues({
          sx: {
            my: [1, 0],
            mr: index === 2 ? "auto" : void 0
          },
          variant: buttonVariant
        }, props), {
          children: label
        }))]
      }, key[index]);
    })]
  });
};
const Collapsible = ({
  title,
  initialOpen = false,
  children
}) => {
  const id = React.useMemo(() => v4(), []);
  const [isOpen, toggleOpen] = React.useState(initialOpen);
  const iconVariant = isOpen ? "angle-up" : "angle-down";
  const container = `container-${id}`;
  const control = `control-${id}`;
  return jsxs(Box, {
    children: [jsxs(Button, {
      onClick: () => toggleOpen(!isOpen),
      id: control,
      "aria-expanded": isOpen,
      variant: "ghost",
      "aria-controls": container,
      sx: {
        minHeight: 32,
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start",
        px: 0,
        textTransform: "none",
        fontSize: 2,
        fontWeight: 400,
        ":hover": {
          bg: "neutral.l4"
        }
      },
      children: [jsx(Icon, {
        variant: iconVariant,
        sx: {
          color: "neutral.base",
          mr: 1
        },
        "aria-hidden": true
      }), title]
    }), jsx(Box, {
      id: container,
      "aria-labelledby": control,
      role: "region",
      sx: {
        ml: 4,
        display: isOpen ? "block" : "none"
      },
      children
    })]
  });
};
const Navbar$2 = (_Ma) => {
  var _Na = _Ma, {
    logoLink = "/",
    navLinks,
    handleLink,
    currentPath,
    children
  } = _Na, props = __objRest(_Na, [
    "logoLink",
    "navLinks",
    "handleLink",
    "currentPath",
    "children"
  ]);
  const isCurrentPath = (path) => {
    if (currentPath === "/" && path === "/")
      return true;
    if (path !== "/")
      return currentPath.includes(path);
    return false;
  };
  return jsxs(Box, __spreadProps(__spreadValues({
    as: "nav",
    "aria-label": "Main"
  }, props), {
    sx: {
      display: "flex",
      alignItems: "center",
      maxWidth: 1440,
      height: 56,
      width: "100%",
      mx: "auto"
    },
    children: [jsxs(Flex, {
      sx: {
        alignItems: "center"
      },
      children: [jsx(Box, {
        as: "button",
        onClick: () => handleLink(logoLink),
        sx: {
          mr: [3, 4],
          bg: "transparent",
          p: 0,
          border: "none",
          cursor: "pointer"
        },
        children: jsxs("h1", {
          sx: {
            m: 0,
            p: 0
          },
          children: [jsx(Logo, {
            invert: true,
            size: "sm",
            sx: {
              display: ["none", "block"]
            }
          }), jsx(Logo, {
            variant: "icon",
            size: "sm",
            invert: true,
            sx: {
              display: ["block", "none"],
              ml: -2
            }
          })]
        })
      }), navLinks == null ? void 0 : navLinks.map(({
        to,
        text,
        hiddenDesktop
      }) => {
        if (hiddenDesktop)
          return null;
        return jsx(Box, {
          as: "button",
          variant: "text.base",
          onClick: () => handleLink(to),
          sx: {
            color: "text.negative",
            border: "none",
            bg: "transparent",
            borderBottom: "2px solid",
            borderColor: isCurrentPath(to) ? "logo.icon" : "transparent",
            textDecoration: "none",
            fontWeight: 600,
            py: "2px",
            cursor: "pointer",
            mr: 3,
            ":hover": {
              textDecoration: "none",
              borderColor: "secondary.l2"
            }
          },
          children: text
        }, `${to}${text}`);
      })]
    }), jsx(Box, {
      sx: {
        ml: "auto",
        color: "text.negative"
      },
      children
    })]
  }));
};
const mobileToggle = React.createContext({
  isOpen: false,
  toggleOpen: () => {
  }
});
const useMobileToggle = () => {
  const {
    isOpen,
    toggleOpen
  } = React.useContext(mobileToggle);
  return {
    isOpen,
    toggleOpen
  };
};
const MenuText = ({
  children
}) => jsx(Box, {
  variant: "text.h5",
  sx: {
    color: "white",
    position: "absolute",
    left: "50%",
    top: "50%",
    transform: "translate(-50%, -50%)"
  },
  children
});
const sidebar = {
  open: {
    height: "100vh",
    minHeight: "-webkit-fill-available"
  },
  closed: {
    height: 56
  }
};
const Navbar$1 = (_Oa) => {
  var _Pa = _Oa, {
    title,
    navLinks,
    search,
    children,
    handleLink,
    currentPath
  } = _Pa, props = __objRest(_Pa, [
    "title",
    "navLinks",
    "search",
    "children",
    "handleLink",
    "currentPath"
  ]);
  const {
    isOpen,
    toggleOpen
  } = useMobileToggle();
  const [isSearching, toggleSearch] = React.useState(false);
  const isCurrentPath = (path) => {
    if (currentPath === "/" && path === "/")
      return true;
    if (path !== "/")
      return currentPath.includes(path);
    return false;
  };
  React.useEffect(() => {
    if (!document)
      return () => {
      };
    if (isOpen) {
      document.body.classList.add("no-scroll");
    } else {
      document.body.classList.remove("no-scroll");
    }
    return () => {
      document.body.classList.remove("no-scroll");
    };
  }, [isOpen]);
  const onLinkClick = (to) => {
    toggleOpen(false);
    handleLink(to);
  };
  return jsx(FocusLock, {
    disabled: !isOpen,
    children: jsxs(Box, __spreadProps(__spreadValues({
      as: "nav",
      "aria-label": "Main",
      sx: __spreadValues({
        bg: "primary.d3"
      }, sidebar[isOpen ? "open" : "closed"])
    }, props), {
      children: [jsxs(Box, {
        sx: {
          display: "flex",
          alignItems: "center",
          height: 56,
          py: 1,
          pr: 3,
          pl: 2,
          bg: "primary.d3",
          position: "relative",
          mb: 2
        },
        children: [!isSearching && jsxs(Fragment, {
          children: [jsx(Box, {
            as: "button",
            sx: {
              bg: "transparent",
              p: 2,
              border: "none"
            },
            onClick: () => toggleOpen(!isOpen),
            "aria-expanded": isOpen,
            children: jsx(Icon, {
              variant: isOpen ? "times" : "menu",
              title: "Main menu",
              color: "white",
              size: "lg"
            })
          }), jsx(Logo, {
            variant: "icon",
            size: "sm",
            invert: true
          }), jsx(MenuText, {
            children: isOpen ? "Menu" : title
          })]
        }), isSearching && search, search && !isOpen && jsx(Box, {
          as: "button",
          sx: {
            bg: "transparent",
            p: 2,
            border: "none",
            ml: "auto"
          },
          onClick: () => toggleSearch(!isSearching),
          children: jsx(Icon, {
            variant: isSearching ? "times" : "search",
            title: "Search",
            color: "white",
            size: "md"
          })
        })]
      }), isOpen && jsxs(Fragment, {
        children: [navLinks == null ? void 0 : navLinks.map(({
          to,
          text
        }) => jsxs(Box, {
          as: "button",
          onClick: () => onLinkClick(to),
          variant: "text.h5",
          sx: {
            color: "text.negative",
            display: "flex",
            alignItems: "center",
            py: "13px",
            px: 0,
            cursor: "pointer",
            width: "100%",
            bg: "transparent",
            border: "none"
          },
          children: [jsx(Box, {
            sx: {
              mx: "10px",
              width: 3,
              bg: isCurrentPath(to) ? "logo.icon" : "transparent",
              height: 28
            }
          }), jsx(Box, {
            sx: {
              transform: "translateY(-1px)"
            },
            children: text
          })]
        }, `${to}${text}`)), children]
      })]
    }))
  });
};
const Navbar = (_Qa) => {
  var _Ra = _Qa, {
    mobileBreakpoint = "56em"
  } = _Ra, props = __objRest(_Ra, [
    "mobileBreakpoint"
  ]);
  const [isOpen, toggleOpen] = React.useState(false);
  const context = useMemo(() => ({
    isOpen,
    toggleOpen
  }), [isOpen]);
  return jsxs(mobileToggle.Provider, {
    value: context,
    children: [jsx(Box, {
      sx: {
        display: "flex",
        alignItems: "center",
        width: "100%",
        position: "sticky",
        top: 0,
        bg: "primary.d3",
        zIndex: 900,
        px: 3,
        py: 1,
        height: 56,
        [`@media only screen and (max-width: ${mobileBreakpoint})`]: {
          display: "none"
        }
      },
      children: jsx(Navbar$2, __spreadValues({}, props))
    }), jsx(Box, {
      sx: {
        display: "none",
        position: "sticky",
        top: 0,
        zIndex: 900,
        [`@media only screen and (max-width: ${mobileBreakpoint})`]: {
          display: "block"
        }
      },
      children: jsx(Navbar$1, __spreadValues({}, props))
    })]
  });
};
const SectionGroup = (_Sa) => {
  var _Ta = _Sa, {
    title,
    children,
    isFieldset = false,
    actions = [],
    description,
    sx = {}
  } = _Ta, props = __objRest(_Ta, [
    "title",
    "children",
    "isFieldset",
    "actions",
    "description",
    "sx"
  ]);
  const prefix = React.useMemo(() => v4(), []);
  const titleId = `${prefix}-title`;
  const descriptionId = `${prefix}-description`;
  return jsxs(Box, __spreadProps(__spreadValues({
    "aria-labelledby": titleId,
    "aria-describedby": description ? descriptionId : void 0,
    as: isFieldset ? "fieldset" : "section",
    sx: __spreadProps(__spreadValues({}, sx), {
      border: "none",
      borderTop: "1px solid",
      borderColor: "neutral.l3",
      pt: 2,
      pb: 0,
      px: 0
    })
  }, props), {
    children: [jsx(Heading, {
      id: titleId,
      as: isFieldset ? "legend" : "h4",
      sx: {
        mb: 2,
        float: "left",
        px: 0
      },
      variant: "h5",
      children: title
    }), jsx("div", {
      sx: {
        clear: "both"
      }
    }), description && jsx(Box, {
      id: descriptionId,
      children: description
    }), children, Boolean(actions.length) && jsx("div", {
      sx: {
        display: "flex",
        justifyContent: "flex-end"
      },
      children: actions.map((action) => jsx(ButtonLink, {
        onClick: action.onClick,
        children: action.title
      }))
    })]
  }));
};
const StartHero = () => {
  var _a;
  const {
    theme: {
      colors
    }
  } = useThemeUI();
  return jsxs(Fragment, {
    children: [jsxs(Box, {
      as: "header",
      sx: {
        display: "flex",
        "@media screen and (max-width: 80em)": {
          display: "none"
        },
        maxWidth: 480,
        width: "100%",
        bg: "primary.d3",
        background: ((_a = colors == null ? void 0 : colors.gradients) == null ? void 0 : _a.secondary) || (colors == null ? void 0 : colors.primary),
        position: "relative",
        overflow: "hidden",
        justifyContent: "center",
        color: "text.negative",
        minHeight: "100vh"
      },
      children: [jsx(Box, {
        as: "h1",
        mt: 72,
        children: jsx(Logo, {
          invert: true
        })
      }), jsx(Logo, {
        "aria-hidden": "true",
        variant: "icon",
        sx: {
          g: {
            fill: "white"
          },
          transform: "scale(3.8)",
          width: 300,
          opacity: 0.11,
          position: "absolute",
          left: -80,
          bottom: 183
        }
      })]
    }), jsx(Box, {
      as: "header",
      sx: {
        display: "none",
        "@media screen and (max-width: 80em)": {
          display: "flex"
        },
        bg: "primary.d3",
        px: 3,
        py: 1,
        height: 56
      },
      children: jsx(Logo, {
        invert: true,
        size: "sm"
      })
    })]
  });
};
const ButtonControls = ({
  submitMessage,
  onPrevious,
  isFirstStep = true,
  isLastStep = false
}) => {
  const {
    values,
    setErrors
  } = useFormikContext();
  return jsxs(Box, {
    sx: {
      mt: 4,
      borderTop: "1px solid",
      borderColor: "neutral.l3",
      pt: 3,
      display: "flex",
      flexFlow: ["column nowrap", "row nowrap"],
      justifyContent: "flex-end",
      alignItems: "center"
    },
    children: [jsx(Button, {
      type: "submit",
      sx: {
        order: [0, 1],
        mb: [2, 0],
        ml: [0, 2],
        width: ["100%", 180]
      },
      children: isFirstStep ? "Start now" : isLastStep ? submitMessage : "Continue"
    }), !isFirstStep && jsx(Button, {
      variant: "secondary",
      sx: {
        width: ["100%", 180]
      },
      onClick: () => {
        setErrors({});
        onPrevious(values);
      },
      children: "Back"
    })]
  });
};
const Sidebar = ({
  children
}) => jsx(Box, {
  as: "header",
  sx: {
    display: "flex",
    px: 4,
    py: 4,
    "@media screen and (max-width: 80em)": {
      display: "none"
    },
    width: "100%",
    maxWidth: 480,
    bg: "neutral.l3",
    minHeight: "100vh"
  },
  children
});
const Progress = (_Ua) => {
  var _Va = _Ua, {
    indeterminate = false,
    progress = 0,
    sx
  } = _Va, props = __objRest(_Va, [
    "indeterminate",
    "progress",
    "sx"
  ]);
  const {
    theme: {
      colors
    }
  } = useThemeUI();
  const progressStyles = useMemo(() => {
    var _a;
    const basicStyles = {
      height: 8,
      width: `${progress}%`,
      background: ((_a = colors == null ? void 0 : colors.gradients) == null ? void 0 : _a.primary) || (colors == null ? void 0 : colors.primary),
      borderRadius: "rounded"
    };
    if (indeterminate) {
      const indeterminateAnimation = keyframes`
        0% {
          width: 0
        };
        50% {
          margin-left: 0;
          width: 100%;
        }
        100% {
          margin-left: 100%;
          width: 0%;
        }`;
      return __spreadProps(__spreadValues({}, basicStyles), {
        animation: `${indeterminateAnimation} 2.3s ease infinite`
      });
    }
    return basicStyles;
  }, [indeterminate, progress]);
  return jsx(Box, __spreadProps(__spreadValues({
    sx: __spreadProps(__spreadValues({}, sx), {
      width: "100%",
      height: 8,
      bg: "neutral.l3",
      borderRadius: "rounded"
    })
  }, props), {
    children: jsx(Box, {
      sx: progressStyles,
      role: "progressbar",
      "aria-valuenow": progress,
      "aria-valuemin": 0,
      "aria-valuemax": 100
    })
  }));
};
const ProgressSteps = (_Wa) => {
  var _Xa = _Wa, {
    steps,
    currentStep = 0,
    sx
  } = _Xa, props = __objRest(_Xa, [
    "steps",
    "currentStep",
    "sx"
  ]);
  const currentStepIndex = currentStep;
  const progress = currentStepIndex / steps.length * 100;
  const stepInfo = `(Step ${currentStepIndex + 1} of ${steps.length})`;
  return jsxs(Box, __spreadProps(__spreadValues({
    sx
  }, props), {
    children: [jsx(Progress, {
      progress
    }), jsx(Box, {
      sx: {
        display: ["block", "none"],
        mt: 1,
        color: "neutral.d1",
        fontWeight: 500
      },
      variant: "text.small",
      children: stepInfo
    }), jsx(Grid, {
      columns: steps.length,
      sx: {
        mt: 1,
        fontWeight: 500,
        display: ["none", "grid"]
      },
      children: steps.map(({
        name
      }, index) => jsxs(Box, {
        variant: "text.small",
        sx: {
          color: currentStepIndex === index ? "neutral.d1" : "neutral.l1"
        },
        children: [name, jsxs(VisuallyHidden, {
          children: [" ", stepInfo]
        })]
      }, name.replace(/ /g, "-").toLowerCase()))
    })]
  }));
};
const InternalWizard = ({
  children,
  initialValues,
  onSubmit,
  submitMessage,
  sidebar: sidebar2,
  steps: internalSteps
}) => {
  const [stepNumber, setStepNumber] = useState(0);
  const steps = React.Children.toArray(children);
  const [snapshot, setSnapshot] = useState(initialValues);
  const step = steps[stepNumber];
  const totalSteps = steps.length;
  const isLastStep = stepNumber === totalSteps - 1;
  const key = step.key.toString();
  const progressStep = Number.parseInt(key.slice(key.indexOf("$") + 1), 10);
  const next = (values) => {
    setSnapshot(values);
    setStepNumber(Math.min(stepNumber + 1, totalSteps - 1));
  };
  const previous = (values) => {
    setSnapshot(values);
    setStepNumber(Math.max(stepNumber - 1, 0));
  };
  const handleSubmit = async (values, bag) => {
    let response = true;
    if (step.props.onSubmit) {
      response = await step.props.onSubmit(values, bag);
    }
    if (response === false)
      return;
    if (isLastStep) {
      onSubmit(values, bag);
    } else {
      bag.setTouched({});
      next(values);
    }
  };
  return jsxs(Box, {
    as: "section",
    sx: {
      display: "flex",
      "@media screen and (max-width: 80em)": {
        display: "block"
      },
      maxWidth: 1400,
      mx: "auto"
    },
    children: [stepNumber === 0 ? jsx(StartHero, {}) : jsx(Sidebar, {
      children: sidebar2
    }), jsxs(Box, {
      sx: {
        width: "100%",
        px: 4
      },
      children: [stepNumber !== 0 && jsx(Box, {
        sx: {
          pb: 3,
          mb: 3,
          borderBottom: "1px solid",
          borderColor: "neutral.l3"
        },
        children: jsx(ProgressSteps, {
          steps: internalSteps,
          currentStep: progressStep
        })
      }), jsxs(Form, {
        initialValues: snapshot,
        onSubmit: handleSubmit,
        validationSchema: step.props.validationSchema,
        children: [step, jsx(ButtonControls, {
          submitMessage,
          onPrevious: previous,
          isLastStep,
          isFirstStep: stepNumber === 0
        })]
      })]
    })]
  });
};
const WizardStep = ({
  children
}) => children;
const Wizard = (_Ya) => {
  var _Za = _Ya, {
    steps
  } = _Za, rest = __objRest(_Za, [
    "steps"
  ]);
  return jsx(InternalWizard, __spreadProps(__spreadValues({
    steps
  }, rest), {
    children: steps.map((_a, mainStepIndex) => {
      var _b = _a, {
        component
      } = _b, props = __objRest(_b, [
        "component"
      ]);
      if (props.substeps) {
        const stepLength = props.substeps.length;
        return props.substeps.map((_a2, index) => {
          var _b2 = _a2, {
            component: subComponent
          } = _b2, subProps = __objRest(_b2, [
            "component"
          ]);
          return jsx(WizardStep, __spreadProps(__spreadValues({
            isSubStep: true,
            isLastStep: stepLength === index + 1,
            isFirstStep: index === 0
          }, subProps), {
            children: subComponent
          }), `${mainStepIndex}.${index}`);
        });
      }
      return createElement(WizardStep, __spreadProps(__spreadValues({}, props), {
        key: mainStepIndex
      }), component);
    })
  }));
};
const LUMOS_ONLY_SELECT = (__a) => {
  var _$a = __a, {
    width = "100%",
    name,
    label,
    description,
    items,
    selectedValueItem,
    onChange,
    sx = {}
  } = _$a, props = __objRest(_$a, [
    "width",
    "name",
    "label",
    "description",
    "items",
    "selectedValueItem",
    "onChange",
    "sx"
  ]);
  const {
    prefix
  } = React.useContext(INTERNAL_ONLY_FORM_INFO);
  const inputId = `${prefix}-${name}`;
  const descriptionId = `${inputId}-description`;
  const options = {
    "aria-describedby": descriptionId
  };
  const {
    isOpen,
    selectedItem,
    getToggleButtonProps,
    getLabelProps,
    getMenuProps,
    highlightedIndex,
    getItemProps
  } = useSelect({
    items,
    itemToString: (item) => {
      var _a;
      return (_a = item == null ? void 0 : item.name) != null ? _a : "";
    },
    onSelectedItemChange: (item) => {
      if (item.selectedItem) {
        onChange(item.selectedItem);
      }
    },
    labelId: inputId,
    selectedItem: selectedValueItem
  });
  return jsxs(Box, __spreadProps(__spreadValues({
    sx
  }, props), {
    children: [jsx("label", __spreadProps(__spreadValues({}, getLabelProps()), {
      children: jsx(VisuallyHidden, {
        children: label
      })
    })), jsxs(Box, __spreadProps(__spreadValues({
      as: "button",
      type: "button",
      variant: "inputContainer.select",
      sx: {
        width
      }
    }, getToggleButtonProps()), {
      children: [jsx("div", {
        children: (selectedItem == null ? void 0 : selectedItem.name) || "Select"
      }), jsx(Icon, {
        variant: "color-triangle",
        sx: {
          transform: isOpen ? "rotate(180deg)" : void 0
        }
      })]
    })), jsx("div", {
      sx: {
        position: "relative"
      },
      children: jsx(Box, __spreadProps(__spreadValues({
        as: "ul",
        variant: "inputContainer.dropzone",
        role: "listbox"
      }, getMenuProps(options)), {
        sx: !isOpen ? {
          border: "none",
          m: 0,
          boxShadow: 0,
          p: 0
        } : {},
        children: isOpen && items.map((item, index) => jsx(Box, __spreadProps(__spreadValues({
          className: [highlightedIndex === index ? "active" : "", (selectedItem == null ? void 0 : selectedItem.value) === item.value ? "selected" : ""].join(" "),
          as: "li",
          role: "option",
          variant: "inputContainer.listItem"
        }, getItemProps({
          item,
          index
        })), {
          children: item.name
        }), item.value.replace(/ /g, "")))
      }))
    }), jsx(VisuallyHidden, {
      id: descriptionId,
      children: description
    })]
  }));
};
const TabsMobile = ({
  tabs,
  currentIndex,
  onChange,
  children
}) => {
  const selectedTab = tabs[currentIndex];
  return jsxs(Box, {
    children: [jsxs(Box, {
      sx: {
        display: "flex"
      },
      children: [jsx(LUMOS_ONLY_SELECT, {
        name: "test",
        selectedValueItem: {
          name: selectedTab.label,
          value: selectedTab.id
        },
        label: "something",
        items: tabs.map((x) => ({
          name: x.label,
          value: x.id
        })),
        onChange: ({
          value
        }) => onChange(value),
        sx: {
          width: "100%",
          button: {
            height: 48,
            border: "none",
            borderBottom: "2px solid",
            borderColor: "secondary.base",
            borderRadius: 0,
            display: "grid",
            gridTemplateColumns: "1fr 24px",
            fontWeight: 600
          }
        }
      }), children]
    }), jsx("div", {
      children: selectedTab.content
    })]
  });
};
const Tabs = ({
  tabs,
  variant = "primary",
  selectedKey,
  onChange,
  children,
  allowMobile = false,
  tabListStyle,
  style
}) => {
  const i = tabs.findIndex((x) => x.id === selectedKey);
  const [currentIndex, changeIndex] = React.useState(i !== -1 ? i : 0);
  const handleChange = (selectedIndex) => {
    var _a;
    changeIndex(selectedIndex);
    if (onChange) {
      onChange((_a = tabs[selectedIndex]) == null ? void 0 : _a.id);
    }
  };
  const handleMobileChange = (value) => {
    const selectedIndex = tabs.findIndex(({
      id
    }) => id === value);
    if (selectedIndex !== -1)
      changeIndex(selectedIndex);
    if (onChange)
      onChange(value);
  };
  React.useEffect(() => {
    const selectedIndex = tabs.findIndex(({
      id
    }) => id === selectedKey);
    if (selectedIndex !== -1)
      changeIndex(selectedIndex);
  }, [selectedKey, tabs]);
  return jsxs(Fragment, {
    children: [jsx(Box, {
      sx: {
        display: allowMobile ? ["none", "none", "block"] : "block"
      },
      children: jsx(Tabs$1, {
        index: currentIndex,
        onChange: handleChange,
        style,
        children: ({
          selectedIndex
        }) => {
          const getPrimaryTabStyle = (index) => {
            const isSelected2 = index === selectedIndex;
            return {
              color: isSelected2 ? "text.positive" : "neutral.base",
              py: 3,
              fontSize: 2,
              mr: 3,
              fontWeight: 600,
              border: "none",
              borderBottom: "2px solid",
              borderColor: isSelected2 ? "secondary.base" : "transparent",
              mb: "-1px",
              bg: "transparent",
              ":hover": {
                borderColor: isSelected2 ? "secondary.base" : "secondary.l2"
              }
            };
          };
          const getSecondaryTabStyle = (index) => {
            const isSelected2 = index === selectedIndex;
            return {
              color: isSelected2 ? "text.positive" : "neutral.base",
              py: 2,
              fontSize: 2,
              mr: 3,
              border: "none",
              borderBottom: "2px solid",
              borderColor: isSelected2 ? "neutral.d2" : "transparent",
              mb: "-1px",
              bg: "transparent",
              ":hover": {
                borderColor: isSelected2 ? "neutral.d2" : "neutral.l2"
              }
            };
          };
          return jsxs(Fragment, {
            children: [jsx(TabList, {
              style: tabListStyle,
              sx: {
                borderBottom: "1px solid",
                borderColor: "neutral.l3",
                "button:last-of-type": {
                  mr: 0
                }
              },
              children: tabs.map(({
                label,
                id,
                tabStyle
              }, index) => jsx(Tab, {
                style: tabStyle,
                sx: variant === "primary" ? getPrimaryTabStyle(index) : getSecondaryTabStyle(index),
                children: label
              }, id))
            }), jsx(TabPanels, {
              children: tabs.map(({
                content,
                id
              }) => jsx(TabPanel, {
                children: content
              }, id))
            })]
          });
        }
      })
    }), jsx(Box, {
      sx: {
        display: allowMobile ? ["block", "block", "none"] : "none"
      },
      children: jsx(TabsMobile, {
        tabs,
        currentIndex,
        variant,
        onChange: handleMobileChange,
        children
      })
    })]
  });
};
const Search = ({
  initialInputValue,
  isLoading,
  label,
  labelPlacement = "placeholder",
  onChange,
  onSelect,
  overflow = false,
  position = "right",
  renderNode,
  results,
  searchDelay = 750,
  itemToString
}) => {
  const [inputText, setInputText] = useState(initialInputValue || "");
  const debouncedChange = useMemo(() => debounce$1(onChange, searchDelay), []);
  useEffect(() => () => debouncedChange.cancel(), []);
  const {
    getInputProps,
    getComboboxProps,
    getMenuProps,
    getItemProps,
    highlightedIndex,
    isOpen
  } = useCombobox({
    onSelectedItemChange: ({
      selectedItem
    }) => {
      if (selectedItem) {
        onSelect(selectedItem);
      }
    },
    itemToString,
    onInputValueChange: ({
      inputValue
    }) => {
      if (inputValue !== void 0) {
        setInputText(inputValue || "");
        debouncedChange(inputValue);
      }
    },
    items: results,
    initialInputValue,
    inputValue: inputText
  });
  const {
    id
  } = getInputProps();
  const showResults = Boolean(!isLoading && (results == null ? void 0 : results.length));
  const showNoResults = Boolean(!isLoading && !(results == null ? void 0 : results.length));
  const style = position === "left" ? {
    left: 0
  } : {
    right: 0
  };
  return jsxs("div", {
    children: [jsx("div", __spreadProps(__spreadValues({}, getComboboxProps()), {
      children: jsxs("div", {
        sx: {
          variant: "inputContainer.box",
          m: 0,
          p: 0
        },
        children: [jsx("label", {
          htmlFor: id,
          sx: __spreadValues({}, labelPlacement === "placeholder" ? hiddenVisually : {
            display: "block",
            mb: 1
          }),
          children: label
        }), jsxs(Grid, {
          columns: "22px 1fr",
          gap: 0,
          children: [jsx("div", {
            sx: {
              variant: "inputContainer.prefix",
              px: 0,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              minHeight: 36
            },
            children: jsx(Icon, {
              variant: "search",
              size: "sm",
              color: "primary.base",
              sx: {
                "i::before": {
                  mx: 0
                },
                ml: 1
              }
            })
          }), jsx("input", __spreadProps(__spreadValues({}, getInputProps()), {
            placeholder: labelPlacement === "placeholder" ? label : void 0,
            sx: {
              variant: "inputContainer.base",
              borderLeft: 0,
              borderTopLeftRadius: 0,
              borderBottomLeftRadius: 0,
              minHeight: 36
            }
          }))]
        })]
      })
    })), jsx("ul", __spreadProps(__spreadValues({}, getMenuProps()), {
      sx: {
        position: overflow ? "absolute" : "relative",
        margin: 0
      },
      children: isOpen && jsxs(Card, {
        variant: "float",
        sx: __spreadValues({
          position: "absolute",
          width: overflow ? 450 : "100%",
          zIndex: 99999,
          p: 0,
          maxHeight: 300,
          overflowY: "scroll",
          li: {
            "&:first-of-type": {
              borderTopLeftRadius: "rounded",
              borderTopRightRadius: "rounded"
            },
            "&:last-of-type": {
              borderBottomLeftRadius: "rounded",
              borderBottomRightRadius: "rounded"
            }
          }
        }, style),
        children: [isLoading && jsxs("p", {
          sx: {
            display: "flex",
            alignItems: "center",
            p: 3
          },
          children: [jsx(Spinner, {
            color: "secondary.base",
            sx: {
              mr: 2
            },
            size: 30
          }), "Searching..."]
        }), showNoResults && jsx("p", {
          sx: {
            m: 3,
            display: "flex",
            alignItems: "center",
            p: 3,
            bg: "primary.l4",
            border: "1px dashed",
            borderColor: "primary.l2"
          },
          children: "No results found"
        }), showResults && results.map((item, index) => jsx("li", __spreadProps(__spreadValues({
          sx: {
            p: 2,
            listStyleType: "none",
            cursor: "pointer",
            bg: highlightedIndex === index ? "primary.l4" : "white"
          }
        }, getItemProps({
          item,
          index,
          key: item.id
        })), {
          children: renderNode(item)
        })))]
      })
    }))]
  });
};
const FileCard = ({
  fileMeta,
  onFileDelete
}) => {
  const {
    fileName,
    progress,
    error,
    fileDescription,
    uploadedAt,
    uploadedBy,
    url,
    fulfilled
  } = fileMeta;
  const resolveInformativeMessage = () => {
    let message = fulfilled && !error ? "Completed: Upload " : "In progress: Upload ";
    message = error ? `Failed: Upload ` : message;
    if ((uploadedAt == null ? void 0 : uploadedAt.length) && (uploadedBy == null ? void 0 : uploadedBy.length)) {
      message += `by ${uploadedBy}, ${uploadedAt}`;
    } else if ((uploadedAt == null ? void 0 : uploadedAt.length) && !(uploadedBy == null ? void 0 : uploadedBy.length)) {
      message += `at ${uploadedAt}`;
    } else if (!(uploadedAt == null ? void 0 : uploadedAt.length) && (uploadedBy == null ? void 0 : uploadedBy.length)) {
      message += `by ${uploadedBy}`;
    } else {
      message += "N/A";
    }
    return jsx("div", {
      sx: {
        marginLeft: "auto"
      },
      children: message
    });
  };
  return jsxs(Card, {
    sx: {
      marginBottom: 2,
      paddingY: 3
    },
    children: [jsxs("div", {
      sx: {
        borderBottom: "1px solid",
        borderColor: "primary.l3",
        paddingBottom: 1,
        marginBottom: 1,
        display: "flex",
        justifyContent: "space-between"
      },
      children: [jsxs("div", {
        sx: {
          display: "flex",
          flexDirection: "column"
        },
        children: [jsx("a", {
          href: url,
          target: "_blank",
          rel: "noreferrer",
          children: jsxs("div", {
            sx: {
              display: "flex",
              alignItems: "center"
            },
            children: [url && jsx(Icon, {
              variant: "download",
              size: "sm",
              sx: {
                marginRight: 2
              }
            }), jsx(Heading, {
              variant: "h6",
              children: fileName
            })]
          })
        }), jsx("div", {
          sx: {
            color: "neutral.base"
          },
          children: fileDescription
        })]
      }), jsxs("div", {
        sx: {
          display: "flex",
          flexDirection: "column"
        },
        children: [fulfilled && jsx(Icon, {
          variant: "trash",
          size: "md",
          sx: {
            pt: 0,
            marginLeft: "auto"
          },
          onClick: () => onFileDelete(fileMeta)
        }), jsx("div", {
          sx: {
            color: "danger.base"
          },
          children: error
        })]
      })]
    }), jsxs("div", {
      sx: {
        display: "flex",
        flexDirection: "column"
      },
      children: [progress && progress < 100 ? jsx(Progress, {
        progress
      }) : null, resolveInformativeMessage()]
    })]
  });
};
const UploadDropzone = ({
  allowedFormats,
  onFileProcessed,
  onFileDelete = () => {
  },
  title,
  description,
  uploadedBy,
  ignoreDuplicates = true,
  maxUploads,
  maxFileSize
}) => {
  const [fileMeta, setFileMeta] = useState([]);
  const prevFileMetaRef = useRef(fileMeta);
  const timeNow = () => DateTime.now().toLocaleString(DateTime.DATETIME_FULL);
  const updateFileInternal = (file, updateMeta) => {
    setFileMeta((prevFileMeta) => prevFileMeta.map((f) => {
      if (f.uuid !== file.uuid)
        return f;
      return __spreadValues(__spreadValues({}, f), updateMeta);
    }));
  };
  const updateFile = (file, updateMeta) => {
    const _a = updateMeta, {
      uuid: _,
      fileName,
      fileType,
      blob,
      fulfilled
    } = _a, sanitized = __objRest(_a, [
      "uuid",
      "fileName",
      "fileType",
      "blob",
      "fulfilled"
    ]);
    updateFileInternal(file, sanitized);
  };
  const errToStr = (err) => {
    var _a;
    let message = err;
    const error = err;
    message = (_a = error.message) != null ? _a : message;
    return (message == null ? void 0 : message.length) ? message : "Oops, something went wrong. Operation Failed.";
  };
  useEffect(() => {
    fileMeta.forEach(async (meta) => {
      if (prevFileMetaRef.current.find((prev) => prev.uuid === meta.uuid))
        return;
      try {
        await onFileProcessed(meta, (updated) => updateFile(meta, updated));
      } catch (err) {
        updateFileInternal(meta, {
          error: errToStr(err),
          progress: 0
        });
      } finally {
        updateFileInternal(meta, {
          fulfilled: true
        });
      }
    });
    prevFileMetaRef.current = fileMeta;
  }, [fileMeta.length]);
  const filterDuplicates = (arr, meta) => ignoreDuplicates ? arr.filter((f) => !meta.find((prev) => {
    var _a;
    const fname = (_a = f.name) != null ? _a : f.file.name;
    return prev.fileName === fname;
  })) : arr;
  const onDrop = (files, fileRejections) => {
    setFileMeta((prevFileMeta) => {
      if (maxUploads && (prevFileMeta.length >= maxUploads || prevFileMeta.length + files.length + fileRejections.length > maxUploads))
        return prevFileMeta;
      const accepted = filterDuplicates(files, prevFileMeta).map((f) => ({
        uuid: v4(),
        blob: f,
        fileName: f.name,
        fileType: f.type,
        progress: 0,
        uploadedBy,
        uploadedAt: timeNow(),
        fulfilled: false
      }));
      const rejected = filterDuplicates(fileRejections, prevFileMeta).map((rejection) => ({
        uuid: v4(),
        blob: rejection.file,
        fileName: rejection.file.name,
        fileType: rejection.file.type,
        error: rejection.errors.map((e) => e.message).join("."),
        progress: 0,
        uploadedBy,
        uploadedAt: timeNow(),
        fulfilled: true
      }));
      return [...prevFileMeta, ...accepted, ...rejected];
    });
  };
  const onDelete = async (file) => {
    try {
      await onFileDelete(file, (updated) => updateFile(file, updated));
      setFileMeta((prevFileMeta) => prevFileMeta.filter((f) => f.uuid !== file.uuid));
    } catch (err) {
      updateFileInternal(file, {
        error: errToStr(err),
        progress: 0
      });
    }
  };
  return jsxs("div", {
    sx: {
      paddingBottom: 5
    },
    children: [title && jsx(Heading, {
      variant: "h6",
      as: "div",
      children: title
    }), description && jsx("div", {
      sx: {
        variant: "text.small",
        color: "neutral.l1",
        mb: 2
      },
      children: description
    }), jsx(Dropzone, {
      onDrop,
      accept: allowedFormats,
      maxSize: maxFileSize,
      children: ({
        getRootProps,
        getInputProps
      }) => jsxs("div", __spreadProps(__spreadValues({}, getRootProps()), {
        sx: {
          backgroundColor: "primary.l4",
          height: "120px",
          border: "1px dotted",
          borderColor: "primary.l2",
          borderRadius: "7px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          cursor: "pointer"
        },
        children: [jsx("input", __spreadValues({}, getInputProps())), jsx(Icon, {
          variant: "upload",
          size: "xl",
          color: "primary.base"
        }), maxUploads ? `Drag up to ${maxUploads} files to upload` : "Drag files to upload", jsx("div", {
          sx: {
            color: "primary.base"
          },
          children: "Browse files"
        })]
      }))
    }), jsx("div", {
      sx: {
        marginTop: "3"
      },
      children: fileMeta.map((file) => jsx(FileCard, {
        fileMeta: file,
        onFileDelete: onDelete
      }, `${file.uuid}`))
    })]
  });
};
export { AddressInput, AdvancedSearch, AlertBanner, AlertInline, Animation, Badge, Button, ButtonBack, ButtonConfirmationTooltip, ButtonLink, Card, CheckboxWithOther, ChoiceInput, Collapsible, CompletionList, ConfirmInput, DataList, DateInput, DatePicker, RadioInput as DecisionInput, DispositionButton, Divider, Drawer, DrawerControlType, DrawerControls, Form, Heading, Icon, LUMOS_ONLY_SELECT, loanCard as LoanCard, Logo, Menu, Modal, ModalControls, MultiSelect, MultiSelectDynamic, Navbar as NavBar, NotifyProvider, NumberInput, PercentageInput, Progress as ProgressBar, Search as SearchInput, SecretInput, SectionGroup, Signature, SingleSelect$1 as SingleSelect, SingleSelect as SingleSelectOther, Tabs, Tag, TextArea, TextInput, ToggleSwitch, Tooltip$1 as Tooltip, UploadDropzone, VisuallyHidden, Wizard, useMobileToggle, useNotify };
